export const vulnerabilityData=[
  {
    "scanId": "SCANC26DF40A",
    "category": "Vulnerability Scan",
    "resolved": true,
    "timestamp": "04 January 2025",
    "status": "Analyzed",
    "Basic": {
      "Name": "google.com",
      "Description": "Basic Network Scan for google.com",
      "target": "google.com",
      "scanType": ""
    },
    "schedule": {
      "frequency": "",
      "time": "",
      "timezone": ""
    },
    "credentials": {},
    "mainscanType": "basic",
    "files": {},
    "vulnerabilities": {
      "google.com": [
        {
          "name": "HTTP Server Type and Version",
          "protocol": "tcp",
          "port": 80,
          "synopsis": "A web server is running on the remote host.",
          "description": "This plugin attempts to determine the type and the version of the\n  remote web server.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "IAVT:0001-T-0931",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HTTP Server Type and Version",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "A web server is running on the remote host.",
          "description": "This plugin attempts to determine the type and the version of the\n  remote web server.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "IAVT:0001-T-0931",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Traceroute Information",
          "protocol": "udp",
          "port": 0,
          "synopsis": "It was possible to obtain traceroute information.",
          "description": "Makes a traceroute to the remote host.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Information",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "This plugin displays the SSL certificate.",
          "description": "This plugin connects to every SSL-related port and attempts to \nextract and dump the X.509 certificate.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SYN scanner",
          "protocol": "tcp",
          "port": 80,
          "synopsis": "It is possible to determine which TCP ports are open.",
          "description": "This plugin is a SYN 'half-open' port scanner.  It shall be reasonably\nquick even against a firewalled target. \n\nNote that SYN scans are less intrusive than TCP (full connect) scans\nagainst broken services, but they might cause problems for less robust\nfirewalls and also leave unclosed connections on the remote target, if\nthe network is loaded.",
          "solution": "Protect your target with an IP filter.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SYN scanner",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "It is possible to determine which TCP ports are open.",
          "description": "This plugin is a SYN 'half-open' port scanner.  It shall be reasonably\nquick even against a firewalled target. \n\nNote that SYN scans are less intrusive than TCP (full connect) scans\nagainst broken services, but they might cause problems for less robust\nfirewalls and also leave unclosed connections on the remote target, if\nthe network is loaded.",
          "solution": "Protect your target with an IP filter.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "OS Identification",
          "protocol": "tcp",
          "port": 0,
          "synopsis": "It is possible to guess the remote operating system.",
          "description": "Using a combination of remote probes (e.g., TCP/IP, SMB, HTTP, NTP,\nSNMP, etc.), it is possible to guess the name of the remote operating\nsystem in use. It is also possible sometimes to guess the version of\nthe operating system.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Host Fully Qualified Domain Name (FQDN) Resolution",
          "protocol": "tcp",
          "port": 0,
          "synopsis": "It was possible to resolve the name of the remote host.",
          "description": "Scanner was able to resolve the fully qualified domain name (FQDN) of\nthe remote host.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Scan Information",
          "protocol": "tcp",
          "port": 0,
          "synopsis": "This plugin displays information about the Scanner scan.",
          "description": "This plugin displays, for each tested host, information about the\nscan itself :\n\n  - The version of the plugin set.\n  - The type of scanner (Scanner or Scanner Home).\n  - The version of the Scanner Engine.\n  - The port scanner(s) used.\n  - The port range scanned.\n  - The ping round trip time \n  - Whether credentialed or third-party patch management\n    checks are possible.\n  - Whether the display of superseded patches is enabled\n  - The date of the scan.\n  - The duration of the scan.\n  - The number of hosts scanned in parallel.\n  - The number of checks done in parallel.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Cipher Suites Supported",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service encrypts communications using SSL.",
          "description": "This plugin detects which SSL ciphers are supported by the remote\nservice for encrypting communications.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "port": 80,
          "synopsis": "The remote service could be identified.",
          "description": "Scanner was able to identify the remote service by its banner or by\nlooking at the error message it sends when it receives an HTTP\nrequest.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service could be identified.",
          "description": "Scanner was able to identify the remote service by its banner or by\nlooking at the error message it sends when it receives an HTTP\nrequest.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service could be identified.",
          "description": "Scanner was able to identify the remote service by its banner or by\nlooking at the error message it sends when it receives an HTTP\nrequest.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HyperText Transfer Protocol (HTTP) Information",
          "protocol": "tcp",
          "port": 80,
          "synopsis": "Some information about the remote HTTP configuration can be extracted.",
          "description": "This test gives some information about the remote HTTP protocol - the\nversion used, whether HTTP Keep-Alive is enabled, etc... \n\nThis test is informational only and does not denote any security\nproblem.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HyperText Transfer Protocol (HTTP) Information",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "Some information about the remote HTTP configuration can be extracted.",
          "description": "This test gives some information about the remote HTTP protocol - the\nversion used, whether HTTP Keep-Alive is enabled, etc... \n\nThis test is informational only and does not denote any security\nproblem.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TCP/IP Timestamps Supported",
          "protocol": "tcp",
          "port": 0,
          "synopsis": "The remote service implements TCP timestamps.",
          "description": "The remote host implements TCP timestamps, as defined by RFC1323.  A\nside effect of this feature is that the uptime of the remote host can\nsometimes be computed.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Medium Strength Cipher Suites Supported (SWEET32)",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service supports the use of medium strength SSL ciphers.",
          "description": "The remote host supports the use of SSL ciphers that offer medium\nstrength encryption. Scanner regards medium strength as any encryption\nthat uses key lengths at least 64 bits and less than 112 bits, or \nelse that uses the 3DES encryption suite.\n\nNote that it is considerably easier to circumvent medium strength\nencryption if the attacker is on the same physical network.",
          "solution": "Reconfigure the affected application if possible to avoid use of\nmedium strength ciphers.",
          "risk_factor": "Medium",
          "cve": "CVE-2016-2183",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Expiry - Future Expiry",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The SSL certificate associated with the remote service will expire\nsoon.",
          "description": "The SSL certificate associated with the remote service will expire\nsoon.",
          "solution": "Purchase or generate a new SSL certificate in the near future to\nreplace the existing one.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Common Platform Enumeration (CPE)",
          "protocol": "tcp",
          "port": 0,
          "synopsis": "It was possible to enumerate CPE names that matched on the remote\nsystem.",
          "description": "By using information obtained from a Scanner scan, this plugin reports\nCPE (Common Platform Enumeration) matches for various hardware and\nsoftware products found on a host. \n\nNote that if an official CPE is not available for the product, this\nplugin computes the best possible CPE based on the information\navailable from the scan.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Additional DNS Hostnames",
          "protocol": "tcp",
          "port": 0,
          "synopsis": "Scanner has detected potential virtual hosts.",
          "description": "Hostnames different from the current hostname have been collected by\nmiscellaneous plugins. Scanner has generated a list of hostnames that\npoint to the remote host. Note that these are only the alternate\nhostnames for vhosts discovered on a web server.\n\nDifferent web servers may be hosted on name-based virtual hosts.",
          "solution": "If you want to test them, re-scan using the special vhost syntax,\nsuch as :\n\nwww.example.com[192.0.32.10]",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "OpenSSL Detection",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service appears to use OpenSSL to encrypt traffic.",
          "description": "Based on its response to a TLS request with a specially crafted\nserver name extension, it seems that the remote service is using the\nOpenSSL library to encrypt traffic.\n\nNote that this plugin can only detect OpenSSL implementations that\nhave enabled support for TLS extensions (RFC 4366).",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Device Type",
          "protocol": "tcp",
          "port": 0,
          "synopsis": "It is possible to guess the remote device type.",
          "description": "Based on the remote operating system, it is possible to determine\nwhat the remote system type is (eg: a printer, router, general-purpose\ncomputer, etc).",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL / TLS Versions Supported",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service encrypts communications.",
          "description": "This plugin detects which SSL and TLS versions are supported by the\nremote service for encrypting communications.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Perfect Forward Secrecy Cipher Suites Supported",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service supports the use of SSL Perfect Forward Secrecy\nciphers, which maintain confidentiality even if the key is stolen.",
          "description": "The remote host supports the use of SSL ciphers that offer Perfect\nForward Secrecy (PFS) encryption.  These cipher suites ensure that\nrecorded SSL traffic cannot be broken at a future date if the server's\nprivate key is compromised.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Next Protocols Supported",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service advertises one or more protocols as being supported\nover TLS.",
          "description": "This script detects which protocols are advertised by the remote\nservice to be encapsulated by TLS connections.\n\nNote that Scanner did not attempt to negotiate TLS sessions with the\nprotocols shown.  The remote service may be falsely advertising these\nprotocols and / or failing to advertise other supported protocols.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Cipher Block Chaining Cipher Suites Supported",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service supports the use of SSL Cipher Block Chaining\nciphers, which combine previous blocks with subsequent ones.",
          "description": "The remote host supports the use of SSL ciphers that operate in Cipher\nBlock Chaining (CBC) mode.  These cipher suites offer additional\nsecurity over Electronic Codebook (ECB) mode, but have the potential to\nleak information if used improperly.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Chain Contains Certificates Expiring Soon",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote host has an SSL certificate chain with one or more\ncertificates that are going to expire soon.",
          "description": "The remote host has an SSL certificate chain with one or more SSL\ncertificates that are going to expire soon. Failure to renew these\ncertificates before the expiration date may result in denial of\nservice for users.",
          "solution": "Renew any soon to expire SSL certificates.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HSTS Missing From HTTPS Server",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote web server is not enforcing HSTS.",
          "description": "The remote HTTPS server is not enforcing HTTP Strict Transport Security (HSTS). \nHSTS is an optional response header that can be configured on the server to instruct \nthe browser to only communicate via HTTPS. The lack of HSTS allows downgrade attacks,\nSSL-stripping man-in-the-middle attacks, and weakens cookie-hijacking protections.",
          "solution": "Configure the remote web server to use HSTS.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS ALPN Supported Protocol Enumeration",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote host supports the TLS ALPN extension.",
          "description": "The remote host supports the TLS ALPN extension. This plugin\nenumerates the protocols the extension supports.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS NPN Supported Protocol Enumeration",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote host supports the TLS NPN extension.",
          "description": "The remote host supports the TLS NPN (Transport Layer Security Next\nProtocol Negotiation) extension. This plugin enumerates the protocols\nthe extension supports.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Root Certification Authority Certificate Information",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "A root Certification Authority certificate was found at the top of the\ncertificate chain.",
          "description": "The remote service uses an SSL certificate chain that contains a\nself-signed root Certification Authority certificate at the top of the\nchain.",
          "solution": "Ensure that use of this root Certification Authority certificate\ncomplies with your organization's acceptable use and security\npolicies.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Signed Using Weak Hashing Algorithm (Known CA)",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "A known CA SSL certificate in the certificate chain has been signed\nusing a weak hashing algorithm.",
          "description": "The remote service uses a known CA certificate in the SSL certificate chain that has been signed using a \ncryptographically weak hashing algorithm (e.g., MD2, MD4, MD5, or SHA1). These signature algorithms are known to be \nvulnerable to collision attacks (CVE-2004-2761, for example). An attacker can exploit this to generate another \ncertificate with the same digital signature, allowing the attacker to masquerade as the affected service.\n\nNote that this plugin reports all SSL certificate chains signed with SHA-1 that expire after January 1, 2017 as \nvulnerable. This is in accordance with Google's gradual sunsetting of the SHA-1 cryptographic hash algorithm.\n\nNote that this plugin will only fire on root certificates that are known certificate authorities as listed in Tenable \nCommunity Knowledge Article 000001752. That is what differentiates this plugin from plugin 35291, which will fire on any\ncertificate, not just known certificate authority root certificates.\n\nKnown certificate authority root certificates are inherently trusted and so any potential issues with the signature, \nincluding it being signed using a weak hashing algorithm, are not considered security issues.",
          "solution": "Contact the Certificate Authority to have the certificate reissued.",
          "risk_factor": "None",
          "cve": "",
          "bid": "11849;33065",
          "xref": "CWE:310",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.0 Protocol Detection",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service encrypts traffic using an older version of TLS.",
          "description": "The remote service accepts connections encrypted using TLS 1.0. TLS 1.0 has a\nnumber of cryptographic design flaws. Modern implementations of TLS 1.0\nmitigate these problems, but newer versions of TLS like 1.2 and 1.3 are\ndesigned against these flaws and should be used whenever possible.\n\nAs of March 31, 2020, Endpoints that aren’t enabled for TLS 1.2\nand higher will no longer function properly with major web browsers and major vendors.\n\nPCI DSS v3.2 requires that TLS 1.0 be disabled entirely by June 30,\n2018, except for POS POI terminals (and the SSL/TLS termination\npoints to which they connect) that can be verified as not being\nsusceptible to any known exploits.",
          "solution": "Enable support for TLS 1.2 and 1.3, and disable support for TLS 1.0.",
          "risk_factor": "Medium",
          "cve": "",
          "bid": "",
          "xref": "CWE:327",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.1 Protocol Detection",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service encrypts traffic using an older version of TLS.",
          "description": "The remote service accepts connections encrypted using TLS 1.1.\nTLS 1.1 lacks support for current and recommended cipher suites.\nCiphers that support encryption before MAC computation, and\nauthenticated encryption modes such as GCM cannot be used with\nTLS 1.1\n\nAs of March 31, 2020, Endpoints that are not enabled for TLS 1.2 \nand higher will no longer function properly with major web browsers and major vendors.",
          "solution": "Enable support for TLS 1.2 and/or 1.3, and disable support for TLS 1.1.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "CWE:327",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.2 Protocol Detection",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service encrypts traffic using a version of TLS.",
          "description": "The remote service accepts connections encrypted using TLS 1.2.",
          "solution": "N/A",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.3 Protocol Detection",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service encrypts traffic using a version of TLS.",
          "description": "The remote service accepts connections encrypted using TLS 1.3.",
          "solution": "N/A",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HSTS Missing From HTTPS Server (RFC 6797)",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote web server is not enforcing HSTS, as defined by RFC 6797.",
          "description": "The remote web server is not enforcing HSTS, as defined by RFC 6797. \nHSTS is an optional response header that can be configured on the server to instruct \nthe browser to only communicate via HTTPS. The lack of HSTS allows downgrade attacks,\nSSL-stripping man-in-the-middle attacks, and weakens cookie-hijacking protections.",
          "solution": "Configure the remote web server to use HSTS.",
          "risk_factor": "Medium",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL/TLS Recommended Cipher Suites",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote host advertises discouraged SSL/TLS ciphers.",
          "description": "The remote host has open SSL/TLS ports which advertise discouraged cipher suites. It is recommended to only enable\nsupport for the following cipher suites:\n\nTLSv1.3:\n  - 0x13,0x01 TLS13_AES_128_GCM_SHA256\n  - 0x13,0x02 TLS13_AES_256_GCM_SHA384\n  - 0x13,0x03 TLS13_CHACHA20_POLY1305_SHA256\n\nTLSv1.2:\n  - 0xC0,0x2B ECDHE-ECDSA-AES128-GCM-SHA256\n  - 0xC0,0x2F ECDHE-RSA-AES128-GCM-SHA256\n  - 0xC0,0x2C ECDHE-ECDSA-AES256-GCM-SHA384\n  - 0xC0,0x30 ECDHE-RSA-AES256-GCM-SHA384\n  - 0xCC,0xA9 ECDHE-ECDSA-CHACHA20-POLY1305\n  - 0xCC,0xA8 ECDHE-RSA-CHACHA20-POLY1305\n\nThis is the recommended configuration for the vast majority of services, as it is highly secure and compatible with\nnearly every client released in the last five (or more) years.",
          "solution": "Only enable support for recommened cipher suites.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.1 Deprecated Protocol",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service encrypts traffic using an older version of TLS.",
          "description": "The remote service accepts connections encrypted using TLS 1.1. TLS 1.1 lacks support for current and recommended\ncipher suites. Ciphers that support encryption before MAC computation, and authenticated encryption modes such as GCM\ncannot be used with TLS 1.1\n\nAs of March 31, 2020, Endpoints that are not enabled for TLS 1.2 and higher will no longer function properly with major\nweb browsers and major vendors.",
          "solution": "Enable support for TLS 1.2 and/or 1.3, and disable support for TLS 1.1.",
          "risk_factor": "Medium",
          "cve": "",
          "bid": "",
          "xref": "CWE:327",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "QUIC Service Detection",
          "protocol": "udp",
          "port": 443,
          "synopsis": "The remote service(s) support the QUIC protocol.",
          "description": "Scanner was able to detect that the remote service supports QUIC by\nsending a QUIC initial packet and receiving QUIC handshake messages in reply.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        }
      ],
      "amazon.com": [
        {
          "name": "HTTP Server Type and Version",
          "protocol": "tcp",
          "port": 80,
          "synopsis": "A web server is running on the remote host.",
          "description": "This plugin attempts to determine the type and the version of the\n  remote web server.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "IAVT:0001-T-0931",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HTTP Server Type and Version",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "A web server is running on the remote host.",
          "description": "This plugin attempts to determine the type and the version of the\n  remote web server.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "IAVT:0001-T-0931",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Traceroute Information",
          "protocol": "udp",
          "port": 0,
          "synopsis": "It was possible to obtain traceroute information.",
          "description": "Makes a traceroute to the remote host.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Information",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "This plugin displays the SSL certificate.",
          "description": "This plugin connects to every SSL-related port and attempts to \nextract and dump the X.509 certificate.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SYN scanner",
          "protocol": "tcp",
          "port": 80,
          "synopsis": "It is possible to determine which TCP ports are open.",
          "description": "This plugin is a SYN 'half-open' port scanner.  It shall be reasonably\nquick even against a firewalled target. \n\nNote that SYN scans are less intrusive than TCP (full connect) scans\nagainst broken services, but they might cause problems for less robust\nfirewalls and also leave unclosed connections on the remote target, if\nthe network is loaded.",
          "solution": "Protect your target with an IP filter.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SYN scanner",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "It is possible to determine which TCP ports are open.",
          "description": "This plugin is a SYN 'half-open' port scanner.  It shall be reasonably\nquick even against a firewalled target. \n\nNote that SYN scans are less intrusive than TCP (full connect) scans\nagainst broken services, but they might cause problems for less robust\nfirewalls and also leave unclosed connections on the remote target, if\nthe network is loaded.",
          "solution": "Protect your target with an IP filter.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "OS Identification",
          "protocol": "tcp",
          "port": 0,
          "synopsis": "It is possible to guess the remote operating system.",
          "description": "Using a combination of remote probes (e.g., TCP/IP, SMB, HTTP, NTP,\nSNMP, etc.), it is possible to guess the name of the remote operating\nsystem in use. It is also possible sometimes to guess the version of\nthe operating system.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Host Fully Qualified Domain Name (FQDN) Resolution",
          "protocol": "tcp",
          "port": 0,
          "synopsis": "It was possible to resolve the name of the remote host.",
          "description": "Scanner was able to resolve the fully qualified domain name (FQDN) of\nthe remote host.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Scan Information",
          "protocol": "tcp",
          "port": 0,
          "synopsis": "This plugin displays information about the Scanner scan.",
          "description": "This plugin displays, for each tested host, information about the\nscan itself :\n\n  - The version of the plugin set.\n  - The type of scanner (Scanner or Scanner Home).\n  - The version of the Scanner Engine.\n  - The port scanner(s) used.\n  - The port range scanned.\n  - The ping round trip time \n  - Whether credentialed or third-party patch management\n    checks are possible.\n  - Whether the display of superseded patches is enabled\n  - The date of the scan.\n  - The duration of the scan.\n  - The number of hosts scanned in parallel.\n  - The number of checks done in parallel.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Cipher Suites Supported",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service encrypts communications using SSL.",
          "description": "This plugin detects which SSL ciphers are supported by the remote\nservice for encrypting communications.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "port": 80,
          "synopsis": "The remote service could be identified.",
          "description": "Scanner was able to identify the remote service by its banner or by\nlooking at the error message it sends when it receives an HTTP\nrequest.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service could be identified.",
          "description": "Scanner was able to identify the remote service by its banner or by\nlooking at the error message it sends when it receives an HTTP\nrequest.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service could be identified.",
          "description": "Scanner was able to identify the remote service by its banner or by\nlooking at the error message it sends when it receives an HTTP\nrequest.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HyperText Transfer Protocol (HTTP) Information",
          "protocol": "tcp",
          "port": 80,
          "synopsis": "Some information about the remote HTTP configuration can be extracted.",
          "description": "This test gives some information about the remote HTTP protocol - the\nversion used, whether HTTP Keep-Alive is enabled, etc... \n\nThis test is informational only and does not denote any security\nproblem.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HyperText Transfer Protocol (HTTP) Information",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "Some information about the remote HTTP configuration can be extracted.",
          "description": "This test gives some information about the remote HTTP protocol - the\nversion used, whether HTTP Keep-Alive is enabled, etc... \n\nThis test is informational only and does not denote any security\nproblem.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TCP/IP Timestamps Supported",
          "protocol": "tcp",
          "port": 0,
          "synopsis": "The remote service implements TCP timestamps.",
          "description": "The remote host implements TCP timestamps, as defined by RFC1323.  A\nside effect of this feature is that the uptime of the remote host can\nsometimes be computed.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Medium Strength Cipher Suites Supported (SWEET32)",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service supports the use of medium strength SSL ciphers.",
          "description": "The remote host supports the use of SSL ciphers that offer medium\nstrength encryption. Scanner regards medium strength as any encryption\nthat uses key lengths at least 64 bits and less than 112 bits, or \nelse that uses the 3DES encryption suite.\n\nNote that it is considerably easier to circumvent medium strength\nencryption if the attacker is on the same physical network.",
          "solution": "Reconfigure the affected application if possible to avoid use of\nmedium strength ciphers.",
          "risk_factor": "Medium",
          "cve": "CVE-2016-2183",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Expiry - Future Expiry",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The SSL certificate associated with the remote service will expire\nsoon.",
          "description": "The SSL certificate associated with the remote service will expire\nsoon.",
          "solution": "Purchase or generate a new SSL certificate in the near future to\nreplace the existing one.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Common Platform Enumeration (CPE)",
          "protocol": "tcp",
          "port": 0,
          "synopsis": "It was possible to enumerate CPE names that matched on the remote\nsystem.",
          "description": "By using information obtained from a Scanner scan, this plugin reports\nCPE (Common Platform Enumeration) matches for various hardware and\nsoftware products found on a host. \n\nNote that if an official CPE is not available for the product, this\nplugin computes the best possible CPE based on the information\navailable from the scan.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Additional DNS Hostnames",
          "protocol": "tcp",
          "port": 0,
          "synopsis": "Scanner has detected potential virtual hosts.",
          "description": "Hostnames different from the current hostname have been collected by\nmiscellaneous plugins. Scanner has generated a list of hostnames that\npoint to the remote host. Note that these are only the alternate\nhostnames for vhosts discovered on a web server.\n\nDifferent web servers may be hosted on name-based virtual hosts.",
          "solution": "If you want to test them, re-scan using the special vhost syntax,\nsuch as :\n\nwww.example.com[192.0.32.10]",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "OpenSSL Detection",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service appears to use OpenSSL to encrypt traffic.",
          "description": "Based on its response to a TLS request with a specially crafted\nserver name extension, it seems that the remote service is using the\nOpenSSL library to encrypt traffic.\n\nNote that this plugin can only detect OpenSSL implementations that\nhave enabled support for TLS extensions (RFC 4366).",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Device Type",
          "protocol": "tcp",
          "port": 0,
          "synopsis": "It is possible to guess the remote device type.",
          "description": "Based on the remote operating system, it is possible to determine\nwhat the remote system type is (eg: a printer, router, general-purpose\ncomputer, etc).",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL / TLS Versions Supported",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service encrypts communications.",
          "description": "This plugin detects which SSL and TLS versions are supported by the\nremote service for encrypting communications.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Perfect Forward Secrecy Cipher Suites Supported",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service supports the use of SSL Perfect Forward Secrecy\nciphers, which maintain confidentiality even if the key is stolen.",
          "description": "The remote host supports the use of SSL ciphers that offer Perfect\nForward Secrecy (PFS) encryption.  These cipher suites ensure that\nrecorded SSL traffic cannot be broken at a future date if the server's\nprivate key is compromised.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Next Protocols Supported",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service advertises one or more protocols as being supported\nover TLS.",
          "description": "This script detects which protocols are advertised by the remote\nservice to be encapsulated by TLS connections.\n\nNote that Scanner did not attempt to negotiate TLS sessions with the\nprotocols shown.  The remote service may be falsely advertising these\nprotocols and / or failing to advertise other supported protocols.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Cipher Block Chaining Cipher Suites Supported",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service supports the use of SSL Cipher Block Chaining\nciphers, which combine previous blocks with subsequent ones.",
          "description": "The remote host supports the use of SSL ciphers that operate in Cipher\nBlock Chaining (CBC) mode.  These cipher suites offer additional\nsecurity over Electronic Codebook (ECB) mode, but have the potential to\nleak information if used improperly.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Chain Contains Certificates Expiring Soon",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote host has an SSL certificate chain with one or more\ncertificates that are going to expire soon.",
          "description": "The remote host has an SSL certificate chain with one or more SSL\ncertificates that are going to expire soon. Failure to renew these\ncertificates before the expiration date may result in denial of\nservice for users.",
          "solution": "Renew any soon to expire SSL certificates.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HSTS Missing From HTTPS Server",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote web server is not enforcing HSTS.",
          "description": "The remote HTTPS server is not enforcing HTTP Strict Transport Security (HSTS). \nHSTS is an optional response header that can be configured on the server to instruct \nthe browser to only communicate via HTTPS. The lack of HSTS allows downgrade attacks,\nSSL-stripping man-in-the-middle attacks, and weakens cookie-hijacking protections.",
          "solution": "Configure the remote web server to use HSTS.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS ALPN Supported Protocol Enumeration",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote host supports the TLS ALPN extension.",
          "description": "The remote host supports the TLS ALPN extension. This plugin\nenumerates the protocols the extension supports.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS NPN Supported Protocol Enumeration",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote host supports the TLS NPN extension.",
          "description": "The remote host supports the TLS NPN (Transport Layer Security Next\nProtocol Negotiation) extension. This plugin enumerates the protocols\nthe extension supports.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Root Certification Authority Certificate Information",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "A root Certification Authority certificate was found at the top of the\ncertificate chain.",
          "description": "The remote service uses an SSL certificate chain that contains a\nself-signed root Certification Authority certificate at the top of the\nchain.",
          "solution": "Ensure that use of this root Certification Authority certificate\ncomplies with your organization's acceptable use and security\npolicies.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Signed Using Weak Hashing Algorithm (Known CA)",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "A known CA SSL certificate in the certificate chain has been signed\nusing a weak hashing algorithm.",
          "description": "The remote service uses a known CA certificate in the SSL certificate chain that has been signed using a \ncryptographically weak hashing algorithm (e.g., MD2, MD4, MD5, or SHA1). These signature algorithms are known to be \nvulnerable to collision attacks (CVE-2004-2761, for example). An attacker can exploit this to generate another \ncertificate with the same digital signature, allowing the attacker to masquerade as the affected service.\n\nNote that this plugin reports all SSL certificate chains signed with SHA-1 that expire after January 1, 2017 as \nvulnerable. This is in accordance with Google's gradual sunsetting of the SHA-1 cryptographic hash algorithm.\n\nNote that this plugin will only fire on root certificates that are known certificate authorities as listed in Tenable \nCommunity Knowledge Article 000001752. That is what differentiates this plugin from plugin 35291, which will fire on any\ncertificate, not just known certificate authority root certificates.\n\nKnown certificate authority root certificates are inherently trusted and so any potential issues with the signature, \nincluding it being signed using a weak hashing algorithm, are not considered security issues.",
          "solution": "Contact the Certificate Authority to have the certificate reissued.",
          "risk_factor": "None",
          "cve": "",
          "bid": "11849;33065",
          "xref": "CWE:310",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.0 Protocol Detection",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service encrypts traffic using an older version of TLS.",
          "description": "The remote service accepts connections encrypted using TLS 1.0. TLS 1.0 has a\nnumber of cryptographic design flaws. Modern implementations of TLS 1.0\nmitigate these problems, but newer versions of TLS like 1.2 and 1.3 are\ndesigned against these flaws and should be used whenever possible.\n\nAs of March 31, 2020, Endpoints that aren’t enabled for TLS 1.2\nand higher will no longer function properly with major web browsers and major vendors.\n\nPCI DSS v3.2 requires that TLS 1.0 be disabled entirely by June 30,\n2018, except for POS POI terminals (and the SSL/TLS termination\npoints to which they connect) that can be verified as not being\nsusceptible to any known exploits.",
          "solution": "Enable support for TLS 1.2 and 1.3, and disable support for TLS 1.0.",
          "risk_factor": "Medium",
          "cve": "",
          "bid": "",
          "xref": "CWE:327",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.1 Protocol Detection",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service encrypts traffic using an older version of TLS.",
          "description": "The remote service accepts connections encrypted using TLS 1.1.\nTLS 1.1 lacks support for current and recommended cipher suites.\nCiphers that support encryption before MAC computation, and\nauthenticated encryption modes such as GCM cannot be used with\nTLS 1.1\n\nAs of March 31, 2020, Endpoints that are not enabled for TLS 1.2 \nand higher will no longer function properly with major web browsers and major vendors.",
          "solution": "Enable support for TLS 1.2 and/or 1.3, and disable support for TLS 1.1.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "CWE:327",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.2 Protocol Detection",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service encrypts traffic using a version of TLS.",
          "description": "The remote service accepts connections encrypted using TLS 1.2.",
          "solution": "N/A",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.3 Protocol Detection",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service encrypts traffic using a version of TLS.",
          "description": "The remote service accepts connections encrypted using TLS 1.3.",
          "solution": "N/A",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HSTS Missing From HTTPS Server (RFC 6797)",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote web server is not enforcing HSTS, as defined by RFC 6797.",
          "description": "The remote web server is not enforcing HSTS, as defined by RFC 6797. \nHSTS is an optional response header that can be configured on the server to instruct \nthe browser to only communicate via HTTPS. The lack of HSTS allows downgrade attacks,\nSSL-stripping man-in-the-middle attacks, and weakens cookie-hijacking protections.",
          "solution": "Configure the remote web server to use HSTS.",
          "risk_factor": "Medium",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL/TLS Recommended Cipher Suites",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote host advertises discouraged SSL/TLS ciphers.",
          "description": "The remote host has open SSL/TLS ports which advertise discouraged cipher suites. It is recommended to only enable\nsupport for the following cipher suites:\n\nTLSv1.3:\n  - 0x13,0x01 TLS13_AES_128_GCM_SHA256\n  - 0x13,0x02 TLS13_AES_256_GCM_SHA384\n  - 0x13,0x03 TLS13_CHACHA20_POLY1305_SHA256\n\nTLSv1.2:\n  - 0xC0,0x2B ECDHE-ECDSA-AES128-GCM-SHA256\n  - 0xC0,0x2F ECDHE-RSA-AES128-GCM-SHA256\n  - 0xC0,0x2C ECDHE-ECDSA-AES256-GCM-SHA384\n  - 0xC0,0x30 ECDHE-RSA-AES256-GCM-SHA384\n  - 0xCC,0xA9 ECDHE-ECDSA-CHACHA20-POLY1305\n  - 0xCC,0xA8 ECDHE-RSA-CHACHA20-POLY1305\n\nThis is the recommended configuration for the vast majority of services, as it is highly secure and compatible with\nnearly every client released in the last five (or more) years.",
          "solution": "Only enable support for recommened cipher suites.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.1 Deprecated Protocol",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service encrypts traffic using an older version of TLS.",
          "description": "The remote service accepts connections encrypted using TLS 1.1. TLS 1.1 lacks support for current and recommended\ncipher suites. Ciphers that support encryption before MAC computation, and authenticated encryption modes such as GCM\ncannot be used with TLS 1.1\n\nAs of March 31, 2020, Endpoints that are not enabled for TLS 1.2 and higher will no longer function properly with major\nweb browsers and major vendors.",
          "solution": "Enable support for TLS 1.2 and/or 1.3, and disable support for TLS 1.1.",
          "risk_factor": "Medium",
          "cve": "",
          "bid": "",
          "xref": "CWE:327",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "QUIC Service Detection",
          "protocol": "udp",
          "port": 443,
          "synopsis": "The remote service(s) support the QUIC protocol.",
          "description": "Scanner was able to detect that the remote service supports QUIC by\nsending a QUIC initial packet and receiving QUIC handshake messages in reply.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        }
      ]
    },
    "deletedDate": "2025-01-05T11:22:52.186Z"
  },
  {
    "scanId": "SCAN1D8C674C",
    "category": "Vulnerability Scan",
    "timestamp": "07January 2025",
    "status": "Analyzed",
    "resolved": false,
    "Basic": {
      "Name": "Company3",
      "Description": "Company3 application sbom",
      "sbomFormat": "",
      "sbomVersion": ""
    },
    "Advanced Settings": {
      "sbomValidate": "",
      "sbomIncludeDevDependencies": ""
    },
    "schedule": {
      "frequency": "",
      "time": "",
      "timezone": ""
    },
    "credentials": {},
    "mainscanType": "SBOM",
    "files": {
      "sbomFile": {
        "filename": "sbom-complex-1736247175573.json",
        "originalName": "sbom-complex.json",
        "storedAt": "sbom-complex-1736247175573.json"
      }
    },
    "deletedDate": "2025-01-07T10:55:57.453Z",
    "analysis": {
      "matches": [
        {
          "vulnerability": {
            "id": "GHSA-rgv9-q543-rqg4",
            "dataSource": "https://github.com/advisories/GHSA-rgv9-q543-rqg4",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-rgv9-q543-rqg4"
            ],
            "description": "Uncontrolled Resource Consumption in FasterXML jackson-databind",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                "metrics": {
                  "baseScore": 7.5,
                  "exploitabilityScore": 3.9,
                  "impactScore": 3.6
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "2.13.4"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2022-42004",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2022-42004",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://bugs.chromium.org/p/oss-fuzz/issues/detail?id=50490",
                "https://github.com/FasterXML/jackson-databind/commit/063183589218fec19a9293ed2f17ec53ea80ba88",
                "https://github.com/FasterXML/jackson-databind/issues/3582",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.gentoo.org/glsa/202210-21",
                "https://security.netapp.com/advisory/ntap-20221118-0008/",
                "https://www.debian.org/security/2022/dsa-5283",
                "https://bugs.chromium.org/p/oss-fuzz/issues/detail?id=50490",
                "https://github.com/FasterXML/jackson-databind/commit/063183589218fec19a9293ed2f17ec53ea80ba88",
                "https://github.com/FasterXML/jackson-databind/issues/3582",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.gentoo.org/glsa/202210-21",
                "https://security.netapp.com/advisory/ntap-20221118-0008/",
                "https://www.debian.org/security/2022/dsa-5283"
              ],
              "description": "In FasterXML jackson-databind before 2.13.4, resource exhaustion can occur because of a lack of a check in BeanDeserializer._deserializeFromArray to prevent use of deeply nested arrays. An application is vulnerable only with certain customized choices for deserialization.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                  "metrics": {
                    "baseScore": 7.5,
                    "exploitabilityScore": 3.9,
                    "impactScore": 3.6
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "jackson-databind",
                  "version": "2.13.0"
                }
              },
              "found": {
                "versionConstraint": ">=2.13.0,<2.13.4 (unknown)",
                "vulnerabilityID": "GHSA-rgv9-q543-rqg4"
              }
            }
          ],
          "artifact": {
            "id": "ce3eae9514ee480b",
            "name": "jackson-databind",
            "version": "2.13.0",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/com.fasterxml.jackson.core/jackson-databind@2.13.0",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-jjjh-jjxp-wpff",
            "dataSource": "https://github.com/advisories/GHSA-jjjh-jjxp-wpff",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-jjjh-jjxp-wpff"
            ],
            "description": "Uncontrolled Resource Consumption in Jackson-databind",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                "metrics": {
                  "baseScore": 7.5,
                  "exploitabilityScore": 3.9,
                  "impactScore": 3.6
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "2.13.4.2"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2022-42003",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2022-42003",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://bugs.chromium.org/p/oss-fuzz/issues/detail?id=51020",
                "https://github.com/FasterXML/jackson-databind/commit/d78d00ee7b5245b93103fef3187f70543d67ca33",
                "https://github.com/FasterXML/jackson-databind/issues/3590",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.gentoo.org/glsa/202210-21",
                "https://security.netapp.com/advisory/ntap-20221124-0004/",
                "https://www.debian.org/security/2022/dsa-5283",
                "https://bugs.chromium.org/p/oss-fuzz/issues/detail?id=51020",
                "https://github.com/FasterXML/jackson-databind/commit/d78d00ee7b5245b93103fef3187f70543d67ca33",
                "https://github.com/FasterXML/jackson-databind/issues/3590",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.gentoo.org/glsa/202210-21",
                "https://security.netapp.com/advisory/ntap-20221124-0004/",
                "https://www.debian.org/security/2022/dsa-5283"
              ],
              "description": "In FasterXML jackson-databind before versions 2.13.4.1 and 2.12.17.1, resource exhaustion can occur because of a lack of a check in primitive value deserializers to avoid deep wrapper array nesting, when the UNWRAP_SINGLE_VALUE_ARRAYS feature is enabled.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                  "metrics": {
                    "baseScore": 7.5,
                    "exploitabilityScore": 3.9,
                    "impactScore": 3.6
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "jackson-databind",
                  "version": "2.13.0"
                }
              },
              "found": {
                "versionConstraint": ">=2.13.0,<2.13.4.2 (unknown)",
                "vulnerabilityID": "GHSA-jjjh-jjxp-wpff"
              }
            }
          ],
          "artifact": {
            "id": "ce3eae9514ee480b",
            "name": "jackson-databind",
            "version": "2.13.0",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/com.fasterxml.jackson.core/jackson-databind@2.13.0",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-57j2-w4cx-62h2",
            "dataSource": "https://github.com/advisories/GHSA-57j2-w4cx-62h2",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-57j2-w4cx-62h2"
            ],
            "description": "Deeply nested json in jackson-databind",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                "metrics": {
                  "baseScore": 7.5,
                  "exploitabilityScore": 3.9,
                  "impactScore": 3.6
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "2.13.2.1"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2020-36518",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2020-36518",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://github.com/FasterXML/jackson-databind/issues/2816",
                "https://lists.debian.org/debian-lts-announce/2022/05/msg00001.html",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.netapp.com/advisory/ntap-20220506-0004/",
                "https://www.debian.org/security/2022/dsa-5283",
                "https://www.oracle.com/security-alerts/cpuapr2022.html",
                "https://www.oracle.com/security-alerts/cpujul2022.html",
                "https://github.com/FasterXML/jackson-databind/issues/2816",
                "https://lists.debian.org/debian-lts-announce/2022/05/msg00001.html",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.netapp.com/advisory/ntap-20220506-0004/",
                "https://www.debian.org/security/2022/dsa-5283",
                "https://www.oracle.com/security-alerts/cpuapr2022.html",
                "https://www.oracle.com/security-alerts/cpujul2022.html"
              ],
              "description": "jackson-databind before 2.13.0 allows a Java StackOverflow exception and denial of service via a large depth of nested objects.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "2.0",
                  "vector": "AV:N/AC:L/Au:N/C:N/I:N/A:P",
                  "metrics": {
                    "baseScore": 5,
                    "exploitabilityScore": 10,
                    "impactScore": 2.9
                  },
                  "vendorMetadata": {}
                },
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                  "metrics": {
                    "baseScore": 7.5,
                    "exploitabilityScore": 3.9,
                    "impactScore": 3.6
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "jackson-databind",
                  "version": "2.13.0"
                }
              },
              "found": {
                "versionConstraint": ">=2.13.0,<=2.13.2.0 (unknown)",
                "vulnerabilityID": "GHSA-57j2-w4cx-62h2"
              }
            }
          ],
          "artifact": {
            "id": "ce3eae9514ee480b",
            "name": "jackson-databind",
            "version": "2.13.0",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/com.fasterxml.jackson.core/jackson-databind@2.13.0",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-3x8x-79m2-3w2w",
            "dataSource": "https://github.com/advisories/GHSA-3x8x-79m2-3w2w",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-3x8x-79m2-3w2w"
            ],
            "description": "jackson-databind possible Denial of Service if using JDK serialization to serialize JsonNode",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                "metrics": {
                  "baseScore": 7.5,
                  "exploitabilityScore": 3.9,
                  "impactScore": 3.6
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "2.13.1"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2021-46877",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2021-46877",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://github.com/FasterXML/jackson-databind/issues/3328",
                "https://groups.google.com/g/jackson-user/c/OsBsirPM_Vw",
                "https://github.com/FasterXML/jackson-databind/issues/3328",
                "https://groups.google.com/g/jackson-user/c/OsBsirPM_Vw"
              ],
              "description": "jackson-databind 2.10.x through 2.12.x before 2.12.6 and 2.13.x before 2.13.1 allows attackers to cause a denial of service (2 GB transient heap usage per read) in uncommon situations involving JsonNode JDK serialization.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                  "metrics": {
                    "baseScore": 7.5,
                    "exploitabilityScore": 3.9,
                    "impactScore": 3.6
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "jackson-databind",
                  "version": "2.13.0"
                }
              },
              "found": {
                "versionConstraint": ">=2.13.0,<2.13.1 (unknown)",
                "vulnerabilityID": "GHSA-3x8x-79m2-3w2w"
              }
            }
          ],
          "artifact": {
            "id": "ce3eae9514ee480b",
            "name": "jackson-databind",
            "version": "2.13.0",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/com.fasterxml.jackson.core/jackson-databind@2.13.0",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-4wrc-f8pq-fpqp",
            "dataSource": "https://github.com/advisories/GHSA-4wrc-f8pq-fpqp",
            "namespace": "github:language:java",
            "severity": "Critical",
            "urls": [
              "https://github.com/advisories/GHSA-4wrc-f8pq-fpqp"
            ],
            "description": "Pivotal Spring Framework contains unsafe Java deserialization methods",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:H/I:H/A:H",
                "metrics": {
                  "baseScore": 9.8,
                  "exploitabilityScore": 3.9,
                  "impactScore": 5.9
                },
                "vendorMetadata": {
                  "base_severity": "Critical",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "6.0.0"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2016-1000027",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2016-1000027",
              "namespace": "nvd:cpe",
              "severity": "Critical",
              "urls": [
                "https://bugzilla.redhat.com/show_bug.cgi?id=CVE-2016-1000027",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-579669626",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-582313417",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-744519525",
                "https://raw.githubusercontent.com/distributedweaknessfiling/cvelist/master/2016/1000xxx/CVE-2016-1000027.json",
                "https://security-tracker.debian.org/tracker/CVE-2016-1000027",
                "https://security.netapp.com/advisory/ntap-20230420-0009/",
                "https://spring.io/blog/2022/05/11/spring-framework-5-3-20-and-5-2-22-available-now",
                "https://www.tenable.com/security/research/tra-2016-20",
                "https://bugzilla.redhat.com/show_bug.cgi?id=CVE-2016-1000027",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-579669626",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-582313417",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-744519525",
                "https://raw.githubusercontent.com/distributedweaknessfiling/cvelist/master/2016/1000xxx/CVE-2016-1000027.json",
                "https://security-tracker.debian.org/tracker/CVE-2016-1000027",
                "https://security.netapp.com/advisory/ntap-20230420-0009/",
                "https://spring.io/blog/2022/05/11/spring-framework-5-3-20-and-5-2-22-available-now",
                "https://www.tenable.com/security/research/tra-2016-20"
              ],
              "description": "Pivotal Spring Framework through 5.3.16 suffers from a potential remote code execution (RCE) issue if used for Java deserialization of untrusted data. Depending on how the library is implemented within a product, this issue may or not occur, and authentication may be required. NOTE: the vendor's position is that untrusted data is not an intended use case. The product's behavior will not be changed because some users rely on deserialization of trusted data.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "2.0",
                  "vector": "AV:N/AC:L/Au:N/C:P/I:P/A:P",
                  "metrics": {
                    "baseScore": 7.5,
                    "exploitabilityScore": 10,
                    "impactScore": 6.4
                  },
                  "vendorMetadata": {}
                },
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:H/I:H/A:H",
                  "metrics": {
                    "baseScore": 9.8,
                    "exploitabilityScore": 3.9,
                    "impactScore": 5.9
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "spring-web",
                  "version": "5.3.10"
                }
              },
              "found": {
                "versionConstraint": "<6.0.0 (unknown)",
                "vulnerabilityID": "GHSA-4wrc-f8pq-fpqp"
              }
            }
          ],
          "artifact": {
            "id": "d9fe63f0bf4a4200",
            "name": "spring-web",
            "version": "5.3.10",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/org.springframework/spring-web@5.3.10",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-hgjh-9rj2-g67j",
            "dataSource": "https://github.com/advisories/GHSA-hgjh-9rj2-g67j",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-hgjh-9rj2-g67j"
            ],
            "description": "Spring Framework URL Parsing with Host Validation Vulnerability",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                "metrics": {
                  "baseScore": 8.1,
                  "exploitabilityScore": 2.8,
                  "impactScore": 5.2
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "5.3.33"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2024-22259",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2024-22259",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://security.netapp.com/advisory/ntap-20240524-0002/",
                "https://spring.io/security/cve-2024-22259",
                "https://security.netapp.com/advisory/ntap-20240524-0002/",
                "https://spring.io/security/cve-2024-22259"
              ],
              "description": "Applications that use UriComponentsBuilder in Spring Framework to parse an externally provided URL (e.g. through a query parameter) AND perform validation checks on the host of the parsed URL may be vulnerable to a  open redirect https://cwe.mitre.org/data/definitions/601.html  attack or to a SSRF attack if the URL is used after passing validation checks.\n\nThis is the same as  CVE-2024-22243 https://spring.io/security/cve-2024-22243 , but with different input.\n\n",
              "cvss": [
                {
                  "source": "security@vmware.com",
                  "type": "Secondary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                  "metrics": {
                    "baseScore": 8.1,
                    "exploitabilityScore": 2.8,
                    "impactScore": 5.2
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "spring-web",
                  "version": "5.3.10"
                }
              },
              "found": {
                "versionConstraint": "<5.3.33 (unknown)",
                "vulnerabilityID": "GHSA-hgjh-9rj2-g67j"
              }
            }
          ],
          "artifact": {
            "id": "d9fe63f0bf4a4200",
            "name": "spring-web",
            "version": "5.3.10",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/org.springframework/spring-web@5.3.10",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-ccgv-vj62-xf9h",
            "dataSource": "https://github.com/advisories/GHSA-ccgv-vj62-xf9h",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-ccgv-vj62-xf9h"
            ],
            "description": "Spring Web vulnerable to Open Redirect or Server Side Request Forgery",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                "metrics": {
                  "baseScore": 8.1,
                  "exploitabilityScore": 2.8,
                  "impactScore": 5.2
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "5.3.32"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2024-22243",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2024-22243",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://security.netapp.com/advisory/ntap-20240524-0001/",
                "https://spring.io/security/cve-2024-22243",
                "http://seclists.org/fulldisclosure/2024/Sep/24",
                "https://security.netapp.com/advisory/ntap-20240524-0001/",
                "https://spring.io/security/cve-2024-22243"
              ],
              "description": "Applications that use UriComponentsBuilder to parse an externally provided URL (e.g. through a query parameter) AND perform validation checks on the host of the parsed URL may be vulnerable to a  open redirect https://cwe.mitre.org/data/definitions/601.html  attack or to a SSRF attack if the URL is used after passing validation checks.\n",
              "cvss": [
                {
                  "source": "security@vmware.com",
                  "type": "Secondary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                  "metrics": {
                    "baseScore": 8.1,
                    "exploitabilityScore": 2.8,
                    "impactScore": 5.2
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "spring-web",
                  "version": "5.3.10"
                }
              },
              "found": {
                "versionConstraint": ">=5.3.0,<5.3.32 (unknown)",
                "vulnerabilityID": "GHSA-ccgv-vj62-xf9h"
              }
            }
          ],
          "artifact": {
            "id": "d9fe63f0bf4a4200",
            "name": "spring-web",
            "version": "5.3.10",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/org.springframework/spring-web@5.3.10",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-2wrp-6fg6-hmc5",
            "dataSource": "https://github.com/advisories/GHSA-2wrp-6fg6-hmc5",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-2wrp-6fg6-hmc5"
            ],
            "description": "Spring Framework URL Parsing with Host Validation",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                "metrics": {
                  "baseScore": 8.1,
                  "exploitabilityScore": 2.8,
                  "impactScore": 5.2
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "5.3.34"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2024-22262",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2024-22262",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://security.netapp.com/advisory/ntap-20240524-0003/",
                "https://spring.io/security/cve-2024-22262",
                "https://security.netapp.com/advisory/ntap-20240524-0003/",
                "https://spring.io/security/cve-2024-22262"
              ],
              "description": "Applications that use UriComponentsBuilder to parse an externally provided URL (e.g. through a query parameter) AND perform validation checks on the host of the parsed URL may be vulnerable to a  open redirect https://cwe.mitre.org/data/definitions/601.html  attack or to a SSRF attack if the URL is used after passing validation checks.\n\nThis is the same as  CVE-2024-22259 https://spring.io/security/cve-2024-22259  and  CVE-2024-22243 https://spring.io/security/cve-2024-22243 , but with different input.\n\n",
              "cvss": [
                {
                  "source": "security@vmware.com",
                  "type": "Secondary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                  "metrics": {
                    "baseScore": 8.1,
                    "exploitabilityScore": 2.8,
                    "impactScore": 5.2
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "spring-web",
                  "version": "5.3.10"
                }
              },
              "found": {
                "versionConstraint": "<5.3.34 (unknown)",
                "vulnerabilityID": "GHSA-2wrp-6fg6-hmc5"
              }
            }
          ],
          "artifact": {
            "id": "d9fe63f0bf4a4200",
            "name": "spring-web",
            "version": "5.3.10",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/org.springframework/spring-web@5.3.10",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-2rmj-mq67-h97g",
            "dataSource": "https://github.com/advisories/GHSA-2rmj-mq67-h97g",
            "namespace": "github:language:java",
            "severity": "Medium",
            "urls": [
              "https://github.com/advisories/GHSA-2rmj-mq67-h97g"
            ],
            "description": "Spring Framework DoS via conditional HTTP request",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:L",
                "metrics": {
                  "baseScore": 5.3,
                  "exploitabilityScore": 3.9,
                  "impactScore": 1.4
                },
                "vendorMetadata": {
                  "base_severity": "Medium",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "5.3.38"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2024-38809",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2024-38809",
              "namespace": "nvd:cpe",
              "severity": "Medium",
              "urls": [
                "https://spring.io/security/cve-2024-38809",
                "https://security.netapp.com/advisory/ntap-20240920-0003/"
              ],
              "description": "Applications that parse ETags from \"If-Match\" or \"If-None-Match\" request headers are vulnerable to DoS attack.\n\nUsers of affected versions should upgrade to the corresponding fixed version.\n\nUsers of older, unsupported versions could enforce a size limit on \"If-Match\" and \"If-None-Match\" headers, e.g. through a Filter.",
              "cvss": [
                {
                  "source": "security@vmware.com",
                  "type": "Secondary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:L",
                  "metrics": {
                    "baseScore": 5.3,
                    "exploitabilityScore": 3.9,
                    "impactScore": 1.4
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "spring-web",
                  "version": "5.3.10"
                }
              },
              "found": {
                "versionConstraint": "<5.3.38 (unknown)",
                "vulnerabilityID": "GHSA-2rmj-mq67-h97g"
              }
            }
          ],
          "artifact": {
            "id": "d9fe63f0bf4a4200",
            "name": "spring-web",
            "version": "5.3.10",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/org.springframework/spring-web@5.3.10",
            "upstreams": []
          }
        }
      ],
      "source": {
        "type": "unknown",
        "target": "unknown"
      },
      "distro": {
        "name": "Ubuntu",
        "version": "22.04",
        "idLike": [
          "Ubuntu"
        ]
      },
      "descriptor": {
        "name": "grype",
        "version": "0.86.1",
        "configuration": {
          "output": [
            "json"
          ],
          "file": "",
          "distro": "",
          "add-cpes-if-none": false,
          "output-template-file": "",
          "check-for-app-update": true,
          "only-fixed": false,
          "only-notfixed": false,
          "ignore-wontfix": "",
          "platform": "",
          "search": {
            "scope": "squashed",
            "unindexed-archives": false,
            "indexed-archives": true
          },
          "ignore": [
            {
              "vulnerability": "",
              "reason": "",
              "namespace": "",
              "fix-state": "",
              "package": {
                "name": "kernel-headers",
                "version": "",
                "language": "",
                "type": "rpm",
                "location": "",
                "upstream-name": "kernel"
              },
              "vex-status": "",
              "vex-justification": "",
              "match-type": "exact-indirect-match"
            },
            {
              "vulnerability": "",
              "reason": "",
              "namespace": "",
              "fix-state": "",
              "package": {
                "name": "linux-.*-headers-.*",
                "version": "",
                "language": "",
                "type": "deb",
                "location": "",
                "upstream-name": "linux"
              },
              "vex-status": "",
              "vex-justification": "",
              "match-type": "exact-indirect-match"
            },
            {
              "vulnerability": "",
              "reason": "",
              "namespace": "",
              "fix-state": "",
              "package": {
                "name": "linux-libc-dev",
                "version": "",
                "language": "",
                "type": "deb",
                "location": "",
                "upstream-name": "linux"
              },
              "vex-status": "",
              "vex-justification": "",
              "match-type": "exact-indirect-match"
            }
          ],
          "exclude": [],
          "db": {
            "cache-dir": "/home/ut/.cache/grype/db",
            "update-url": "https://toolbox-data.anchore.io/grype/databases/listing.json",
            "ca-cert": "",
            "auto-update": true,
            "validate-by-hash-on-start": false,
            "validate-age": true,
            "max-allowed-built-age": 432000000000000,
            "require-update-check": false,
            "update-available-timeout": 30000000000,
            "update-download-timeout": 300000000000,
            "max-update-check-frequency": 7200000000000
          },
          "externalSources": {
            "enable": false,
            "maven": {
              "searchUpstreamBySha1": true,
              "baseUrl": "https://search.maven.org/solrsearch/select"
            }
          },
          "match": {
            "java": {
              "using-cpes": false
            },
            "jvm": {
              "using-cpes": true
            },
            "dotnet": {
              "using-cpes": false
            },
            "golang": {
              "using-cpes": false,
              "always-use-cpe-for-stdlib": true,
              "allow-main-module-pseudo-version-comparison": false
            },
            "javascript": {
              "using-cpes": false
            },
            "python": {
              "using-cpes": false
            },
            "ruby": {
              "using-cpes": false
            },
            "rust": {
              "using-cpes": false
            },
            "stock": {
              "using-cpes": true
            }
          },
          "fail-on-severity": "",
          "registry": {
            "insecure-skip-tls-verify": false,
            "insecure-use-http": false,
            "auth": null,
            "ca-cert": ""
          },
          "show-suppressed": false,
          "by-cve": false,
          "name": "",
          "default-image-pull-source": "",
          "vex-documents": [],
          "vex-add": [],
          "match-upstream-kernel-headers": false,
          "exp": {
            "dbv6": false
          }
        },
        "db": {
          "built": "2025-01-11T01:31:37Z",
          "schemaVersion": 5,
          "location": "/home/ut/.cache/grype/db/5",
          "checksum": "sha256:cc72ba1db7ec7312d2aa0bc6d2bace933d843af7e256540aa73b461e1733f3be",
          "error": null
        },
        "timestamp": "2025-01-11T21:56:16.040478079Z"
      }
    }
  },
  {
    "scanId": "SCANA231AAD1",
    "category": "Vulnerability Scan",
    "timestamp": "10 January 2025",
    "status": "Analyzed",
    "resolved": false,
    "Basic": {
      "Name": "vulnweb",
      "Description": "Testing for common web vulnerabilities on vulnweb.com",
      "target": "vulnweb.com",
      "scanType": ""
    },
    "schedule": {
      "frequency": "",
      "time": "",
      "timezone": ""
    },
    "credentials": {},
    "mainscanType": "webApp",
    "files": {},
    "vulnerabilities": {
      "vulnweb.com": [
        {
          "name": "HTTP Server Type and Version",
          "protocol": "tcp",
          "port": 80,
          "synopsis": "A web server is running on the remote host.",
          "description": "This plugin attempts to determine the type and the version of the\n  remote web server.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "IAVT:0001-T-0931",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SYN scanner",
          "protocol": "tcp",
          "port": 80,
          "synopsis": "It is possible to determine which TCP ports are open.",
          "description": "This plugin is a SYN 'half-open' port scanner.  It shall be reasonably\nquick even against a firewalled target. \n\nNote that SYN scans are less intrusive than TCP (full connect) scans\nagainst broken services, but they might cause problems for less robust\nfirewalls and also leave unclosed connections on the remote target, if\nthe network is loaded.",
          "solution": "Protect your target with an IP filter.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Scan Information",
          "protocol": "tcp",
          "port": 0,
          "synopsis": "This plugin displays information about the Scanner scan.",
          "description": "This plugin displays, for each tested host, information about the\nscan itself :\n\n  - The version of the plugin set.\n  - The type of scanner (Scanner or Scanner Home).\n  - The version of the Scanner Engine.\n  - The port scanner(s) used.\n  - The port range scanned.\n  - The ping round trip time \n  - Whether credentialed or third-party patch management\n    checks are possible.\n  - Whether the display of superseded patches is enabled\n  - The date of the scan.\n  - The duration of the scan.\n  - The number of hosts scanned in parallel.\n  - The number of checks done in parallel.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HyperText Transfer Protocol (HTTP) Information",
          "protocol": "tcp",
          "port": 80,
          "synopsis": "Some information about the remote HTTP configuration can be extracted.",
          "description": "This test gives some information about the remote HTTP protocol - the\nversion used, whether HTTP Keep-Alive is enabled, etc... \n\nThis test is informational only and does not denote any security\nproblem.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HTTP Methods Allowed (per directory)",
          "protocol": "tcp",
          "port": 80,
          "synopsis": "This plugin determines which HTTP methods are allowed on various CGI\ndirectories.",
          "description": "By calling the OPTIONS method, it is possible to determine which HTTP\nmethods are allowed on each directory.\n\nThe following HTTP methods are considered insecure:\n  PUT, DELETE, CONNECT, TRACE, HEAD\n\nMany frameworks and languages treat 'HEAD' as a 'GET' request, albeit\none without any body in the response. If a security constraint was\nset on 'GET' requests such that only 'authenticatedUsers' could\naccess GET requests for a particular servlet or resource, it would be\nbypassed for the 'HEAD' version. This allowed unauthorized blind\nsubmission of any privileged GET request.\n\nAs this list may be incomplete, the plugin also tests - if 'Thorough\ntests' are enabled or 'Enable web applications tests' is set to 'yes'\nin the scan policy - various known HTTP methods on each directory and\nconsiders them as unsupported if it receives a response code of 400,\n403, 405, or 501.\n\nNote that the plugin output is only informational and does not\nnecessarily indicate the presence of any security vulnerabilities.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "External URLs",
          "protocol": "tcp",
          "port": 80,
          "synopsis": "Links to external sites were gathered.",
          "description": "Scanner gathered HREF links to external sites by crawling the remote\nweb server.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Missing or Permissive Content-Security-Policy frame-ancestors HTTP Response Header",
          "protocol": "tcp",
          "port": 80,
          "synopsis": "The remote web server does not take steps to mitigate a class of web\napplication vulnerabilities.",
          "description": "The remote web server in some responses sets a permissive\nContent-Security-Policy (CSP) frame-ancestors response header or does\nnot set one at all.\n\nThe CSP frame-ancestors header has been proposed by the W3C Web\nApplication Security Working Group as a way to mitigate cross-site\nscripting and clickjacking attacks.",
          "solution": "Set a non-permissive Content-Security-Policy frame-ancestors header\nfor all requested resources.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Missing or Permissive X-Frame-Options HTTP Response Header",
          "protocol": "tcp",
          "port": 80,
          "synopsis": "The remote web server does not take steps to mitigate a class of web\napplication vulnerabilities.",
          "description": "The remote web server in some responses sets a permissive\nX-Frame-Options response header or does not set one at all.\n\nThe X-Frame-Options header has been proposed by Microsoft as a way to\nmitigate clickjacking attacks and is currently supported by all major\nbrowser vendors",
          "solution": "Set a properly configured X-Frame-Options header for all requested\nresources.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Web Application Sitemap",
          "protocol": "tcp",
          "port": 80,
          "synopsis": "The remote web server hosts linkable content that can be crawled by\nScanner.",
          "description": "The remote web server contains linkable content that can be used to\ngather information about a target.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "nginx HTTP Server Detection",
          "protocol": "tcp",
          "port": 80,
          "synopsis": "The nginx HTTP server was detected on the remote host.",
          "description": "Scanner was able to detect the nginx HTTP server by looking at\nthe HTTP banner on the remote host.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "IAVT:0001-T-0677",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        }
      ]
    },
    "deletedDate": "2025-01-07T09:59:17.510Z"
  },
  {
    "scanId": "SCAN9953FC4A",
    "timestamp": "10 January 2025",
    "status": "Analyzed",
    "resolved": true,
    "Basic": {
      "Name": "Company2",
      "Description": "Company2 application sbom",
      "sbomFormat": "",
      "sbomVersion": ""
    },
    "Advanced Settings": {
      "sbomValidate": "",
      "sbomIncludeDevDependencies": ""
    },
    "schedule": {
      "frequency": "",
      "time": "",
      "timezone": ""
    },
    "credentials": {},
    "mainscanType": "SBOM",
    "files": {
      "sbomFile": {
        "filename": "sbom-complex-1736251041464.json",
        "originalName": "sbom-complex.json",
        "storedAt": "sbom-complex-1736251041464.json"
      }
    },
    "analysis": {
      "matches": [
        {
          "vulnerability": {
            "id": "GHSA-rgv9-q543-rqg4",
            "dataSource": "https://github.com/advisories/GHSA-rgv9-q543-rqg4",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-rgv9-q543-rqg4"
            ],
            "description": "Uncontrolled Resource Consumption in FasterXML jackson-databind",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                "metrics": {
                  "baseScore": 7.5,
                  "exploitabilityScore": 3.9,
                  "impactScore": 3.6
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "2.13.4"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2022-42004",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2022-42004",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://bugs.chromium.org/p/oss-fuzz/issues/detail?id=50490",
                "https://github.com/FasterXML/jackson-databind/commit/063183589218fec19a9293ed2f17ec53ea80ba88",
                "https://github.com/FasterXML/jackson-databind/issues/3582",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.gentoo.org/glsa/202210-21",
                "https://security.netapp.com/advisory/ntap-20221118-0008/",
                "https://www.debian.org/security/2022/dsa-5283",
                "https://bugs.chromium.org/p/oss-fuzz/issues/detail?id=50490",
                "https://github.com/FasterXML/jackson-databind/commit/063183589218fec19a9293ed2f17ec53ea80ba88",
                "https://github.com/FasterXML/jackson-databind/issues/3582",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.gentoo.org/glsa/202210-21",
                "https://security.netapp.com/advisory/ntap-20221118-0008/",
                "https://www.debian.org/security/2022/dsa-5283"
              ],
              "description": "In FasterXML jackson-databind before 2.13.4, resource exhaustion can occur because of a lack of a check in BeanDeserializer._deserializeFromArray to prevent use of deeply nested arrays. An application is vulnerable only with certain customized choices for deserialization.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                  "metrics": {
                    "baseScore": 7.5,
                    "exploitabilityScore": 3.9,
                    "impactScore": 3.6
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "jackson-databind",
                  "version": "2.13.0"
                }
              },
              "found": {
                "versionConstraint": ">=2.13.0,<2.13.4 (unknown)",
                "vulnerabilityID": "GHSA-rgv9-q543-rqg4"
              }
            }
          ],
          "artifact": {
            "id": "ce3eae9514ee480b",
            "name": "jackson-databind",
            "version": "2.13.0",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/com.fasterxml.jackson.core/jackson-databind@2.13.0",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-jjjh-jjxp-wpff",
            "dataSource": "https://github.com/advisories/GHSA-jjjh-jjxp-wpff",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-jjjh-jjxp-wpff"
            ],
            "description": "Uncontrolled Resource Consumption in Jackson-databind",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                "metrics": {
                  "baseScore": 7.5,
                  "exploitabilityScore": 3.9,
                  "impactScore": 3.6
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "2.13.4.2"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2022-42003",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2022-42003",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://bugs.chromium.org/p/oss-fuzz/issues/detail?id=51020",
                "https://github.com/FasterXML/jackson-databind/commit/d78d00ee7b5245b93103fef3187f70543d67ca33",
                "https://github.com/FasterXML/jackson-databind/issues/3590",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.gentoo.org/glsa/202210-21",
                "https://security.netapp.com/advisory/ntap-20221124-0004/",
                "https://www.debian.org/security/2022/dsa-5283",
                "https://bugs.chromium.org/p/oss-fuzz/issues/detail?id=51020",
                "https://github.com/FasterXML/jackson-databind/commit/d78d00ee7b5245b93103fef3187f70543d67ca33",
                "https://github.com/FasterXML/jackson-databind/issues/3590",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.gentoo.org/glsa/202210-21",
                "https://security.netapp.com/advisory/ntap-20221124-0004/",
                "https://www.debian.org/security/2022/dsa-5283"
              ],
              "description": "In FasterXML jackson-databind before versions 2.13.4.1 and 2.12.17.1, resource exhaustion can occur because of a lack of a check in primitive value deserializers to avoid deep wrapper array nesting, when the UNWRAP_SINGLE_VALUE_ARRAYS feature is enabled.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                  "metrics": {
                    "baseScore": 7.5,
                    "exploitabilityScore": 3.9,
                    "impactScore": 3.6
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "jackson-databind",
                  "version": "2.13.0"
                }
              },
              "found": {
                "versionConstraint": ">=2.13.0,<2.13.4.2 (unknown)",
                "vulnerabilityID": "GHSA-jjjh-jjxp-wpff"
              }
            }
          ],
          "artifact": {
            "id": "ce3eae9514ee480b",
            "name": "jackson-databind",
            "version": "2.13.0",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/com.fasterxml.jackson.core/jackson-databind@2.13.0",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-57j2-w4cx-62h2",
            "dataSource": "https://github.com/advisories/GHSA-57j2-w4cx-62h2",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-57j2-w4cx-62h2"
            ],
            "description": "Deeply nested json in jackson-databind",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                "metrics": {
                  "baseScore": 7.5,
                  "exploitabilityScore": 3.9,
                  "impactScore": 3.6
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "2.13.2.1"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2020-36518",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2020-36518",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://github.com/FasterXML/jackson-databind/issues/2816",
                "https://lists.debian.org/debian-lts-announce/2022/05/msg00001.html",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.netapp.com/advisory/ntap-20220506-0004/",
                "https://www.debian.org/security/2022/dsa-5283",
                "https://www.oracle.com/security-alerts/cpuapr2022.html",
                "https://www.oracle.com/security-alerts/cpujul2022.html",
                "https://github.com/FasterXML/jackson-databind/issues/2816",
                "https://lists.debian.org/debian-lts-announce/2022/05/msg00001.html",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.netapp.com/advisory/ntap-20220506-0004/",
                "https://www.debian.org/security/2022/dsa-5283",
                "https://www.oracle.com/security-alerts/cpuapr2022.html",
                "https://www.oracle.com/security-alerts/cpujul2022.html"
              ],
              "description": "jackson-databind before 2.13.0 allows a Java StackOverflow exception and denial of service via a large depth of nested objects.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "2.0",
                  "vector": "AV:N/AC:L/Au:N/C:N/I:N/A:P",
                  "metrics": {
                    "baseScore": 5,
                    "exploitabilityScore": 10,
                    "impactScore": 2.9
                  },
                  "vendorMetadata": {}
                },
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                  "metrics": {
                    "baseScore": 7.5,
                    "exploitabilityScore": 3.9,
                    "impactScore": 3.6
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "jackson-databind",
                  "version": "2.13.0"
                }
              },
              "found": {
                "versionConstraint": ">=2.13.0,<=2.13.2.0 (unknown)",
                "vulnerabilityID": "GHSA-57j2-w4cx-62h2"
              }
            }
          ],
          "artifact": {
            "id": "ce3eae9514ee480b",
            "name": "jackson-databind",
            "version": "2.13.0",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/com.fasterxml.jackson.core/jackson-databind@2.13.0",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-3x8x-79m2-3w2w",
            "dataSource": "https://github.com/advisories/GHSA-3x8x-79m2-3w2w",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-3x8x-79m2-3w2w"
            ],
            "description": "jackson-databind possible Denial of Service if using JDK serialization to serialize JsonNode",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                "metrics": {
                  "baseScore": 7.5,
                  "exploitabilityScore": 3.9,
                  "impactScore": 3.6
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "2.13.1"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2021-46877",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2021-46877",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://github.com/FasterXML/jackson-databind/issues/3328",
                "https://groups.google.com/g/jackson-user/c/OsBsirPM_Vw",
                "https://github.com/FasterXML/jackson-databind/issues/3328",
                "https://groups.google.com/g/jackson-user/c/OsBsirPM_Vw"
              ],
              "description": "jackson-databind 2.10.x through 2.12.x before 2.12.6 and 2.13.x before 2.13.1 allows attackers to cause a denial of service (2 GB transient heap usage per read) in uncommon situations involving JsonNode JDK serialization.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                  "metrics": {
                    "baseScore": 7.5,
                    "exploitabilityScore": 3.9,
                    "impactScore": 3.6
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "jackson-databind",
                  "version": "2.13.0"
                }
              },
              "found": {
                "versionConstraint": ">=2.13.0,<2.13.1 (unknown)",
                "vulnerabilityID": "GHSA-3x8x-79m2-3w2w"
              }
            }
          ],
          "artifact": {
            "id": "ce3eae9514ee480b",
            "name": "jackson-databind",
            "version": "2.13.0",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/com.fasterxml.jackson.core/jackson-databind@2.13.0",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-4wrc-f8pq-fpqp",
            "dataSource": "https://github.com/advisories/GHSA-4wrc-f8pq-fpqp",
            "namespace": "github:language:java",
            "severity": "Critical",
            "urls": [
              "https://github.com/advisories/GHSA-4wrc-f8pq-fpqp"
            ],
            "description": "Pivotal Spring Framework contains unsafe Java deserialization methods",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:H/I:H/A:H",
                "metrics": {
                  "baseScore": 9.8,
                  "exploitabilityScore": 3.9,
                  "impactScore": 5.9
                },
                "vendorMetadata": {
                  "base_severity": "Critical",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "6.0.0"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2016-1000027",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2016-1000027",
              "namespace": "nvd:cpe",
              "severity": "Critical",
              "urls": [
                "https://bugzilla.redhat.com/show_bug.cgi?id=CVE-2016-1000027",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-579669626",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-582313417",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-744519525",
                "https://raw.githubusercontent.com/distributedweaknessfiling/cvelist/master/2016/1000xxx/CVE-2016-1000027.json",
                "https://security-tracker.debian.org/tracker/CVE-2016-1000027",
                "https://security.netapp.com/advisory/ntap-20230420-0009/",
                "https://spring.io/blog/2022/05/11/spring-framework-5-3-20-and-5-2-22-available-now",
                "https://www.tenable.com/security/research/tra-2016-20",
                "https://bugzilla.redhat.com/show_bug.cgi?id=CVE-2016-1000027",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-579669626",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-582313417",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-744519525",
                "https://raw.githubusercontent.com/distributedweaknessfiling/cvelist/master/2016/1000xxx/CVE-2016-1000027.json",
                "https://security-tracker.debian.org/tracker/CVE-2016-1000027",
                "https://security.netapp.com/advisory/ntap-20230420-0009/",
                "https://spring.io/blog/2022/05/11/spring-framework-5-3-20-and-5-2-22-available-now",
                "https://www.tenable.com/security/research/tra-2016-20"
              ],
              "description": "Pivotal Spring Framework through 5.3.16 suffers from a potential remote code execution (RCE) issue if used for Java deserialization of untrusted data. Depending on how the library is implemented within a product, this issue may or not occur, and authentication may be required. NOTE: the vendor's position is that untrusted data is not an intended use case. The product's behavior will not be changed because some users rely on deserialization of trusted data.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "2.0",
                  "vector": "AV:N/AC:L/Au:N/C:P/I:P/A:P",
                  "metrics": {
                    "baseScore": 7.5,
                    "exploitabilityScore": 10,
                    "impactScore": 6.4
                  },
                  "vendorMetadata": {}
                },
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:H/I:H/A:H",
                  "metrics": {
                    "baseScore": 9.8,
                    "exploitabilityScore": 3.9,
                    "impactScore": 5.9
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "spring-web",
                  "version": "5.3.10"
                }
              },
              "found": {
                "versionConstraint": "<6.0.0 (unknown)",
                "vulnerabilityID": "GHSA-4wrc-f8pq-fpqp"
              }
            }
          ],
          "artifact": {
            "id": "d9fe63f0bf4a4200",
            "name": "spring-web",
            "version": "5.3.10",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/org.springframework/spring-web@5.3.10",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-hgjh-9rj2-g67j",
            "dataSource": "https://github.com/advisories/GHSA-hgjh-9rj2-g67j",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-hgjh-9rj2-g67j"
            ],
            "description": "Spring Framework URL Parsing with Host Validation Vulnerability",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                "metrics": {
                  "baseScore": 8.1,
                  "exploitabilityScore": 2.8,
                  "impactScore": 5.2
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "5.3.33"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2024-22259",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2024-22259",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://security.netapp.com/advisory/ntap-20240524-0002/",
                "https://spring.io/security/cve-2024-22259",
                "https://security.netapp.com/advisory/ntap-20240524-0002/",
                "https://spring.io/security/cve-2024-22259"
              ],
              "description": "Applications that use UriComponentsBuilder in Spring Framework to parse an externally provided URL (e.g. through a query parameter) AND perform validation checks on the host of the parsed URL may be vulnerable to a  open redirect https://cwe.mitre.org/data/definitions/601.html  attack or to a SSRF attack if the URL is used after passing validation checks.\n\nThis is the same as  CVE-2024-22243 https://spring.io/security/cve-2024-22243 , but with different input.\n\n",
              "cvss": [
                {
                  "source": "security@vmware.com",
                  "type": "Secondary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                  "metrics": {
                    "baseScore": 8.1,
                    "exploitabilityScore": 2.8,
                    "impactScore": 5.2
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "spring-web",
                  "version": "5.3.10"
                }
              },
              "found": {
                "versionConstraint": "<5.3.33 (unknown)",
                "vulnerabilityID": "GHSA-hgjh-9rj2-g67j"
              }
            }
          ],
          "artifact": {
            "id": "d9fe63f0bf4a4200",
            "name": "spring-web",
            "version": "5.3.10",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/org.springframework/spring-web@5.3.10",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-ccgv-vj62-xf9h",
            "dataSource": "https://github.com/advisories/GHSA-ccgv-vj62-xf9h",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-ccgv-vj62-xf9h"
            ],
            "description": "Spring Web vulnerable to Open Redirect or Server Side Request Forgery",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                "metrics": {
                  "baseScore": 8.1,
                  "exploitabilityScore": 2.8,
                  "impactScore": 5.2
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "5.3.32"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2024-22243",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2024-22243",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://security.netapp.com/advisory/ntap-20240524-0001/",
                "https://spring.io/security/cve-2024-22243",
                "http://seclists.org/fulldisclosure/2024/Sep/24",
                "https://security.netapp.com/advisory/ntap-20240524-0001/",
                "https://spring.io/security/cve-2024-22243"
              ],
              "description": "Applications that use UriComponentsBuilder to parse an externally provided URL (e.g. through a query parameter) AND perform validation checks on the host of the parsed URL may be vulnerable to a  open redirect https://cwe.mitre.org/data/definitions/601.html  attack or to a SSRF attack if the URL is used after passing validation checks.\n",
              "cvss": [
                {
                  "source": "security@vmware.com",
                  "type": "Secondary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                  "metrics": {
                    "baseScore": 8.1,
                    "exploitabilityScore": 2.8,
                    "impactScore": 5.2
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "spring-web",
                  "version": "5.3.10"
                }
              },
              "found": {
                "versionConstraint": ">=5.3.0,<5.3.32 (unknown)",
                "vulnerabilityID": "GHSA-ccgv-vj62-xf9h"
              }
            }
          ],
          "artifact": {
            "id": "d9fe63f0bf4a4200",
            "name": "spring-web",
            "version": "5.3.10",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/org.springframework/spring-web@5.3.10",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-2wrp-6fg6-hmc5",
            "dataSource": "https://github.com/advisories/GHSA-2wrp-6fg6-hmc5",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-2wrp-6fg6-hmc5"
            ],
            "description": "Spring Framework URL Parsing with Host Validation",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                "metrics": {
                  "baseScore": 8.1,
                  "exploitabilityScore": 2.8,
                  "impactScore": 5.2
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "5.3.34"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2024-22262",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2024-22262",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://security.netapp.com/advisory/ntap-20240524-0003/",
                "https://spring.io/security/cve-2024-22262",
                "https://security.netapp.com/advisory/ntap-20240524-0003/",
                "https://spring.io/security/cve-2024-22262"
              ],
              "description": "Applications that use UriComponentsBuilder to parse an externally provided URL (e.g. through a query parameter) AND perform validation checks on the host of the parsed URL may be vulnerable to a  open redirect https://cwe.mitre.org/data/definitions/601.html  attack or to a SSRF attack if the URL is used after passing validation checks.\n\nThis is the same as  CVE-2024-22259 https://spring.io/security/cve-2024-22259  and  CVE-2024-22243 https://spring.io/security/cve-2024-22243 , but with different input.\n\n",
              "cvss": [
                {
                  "source": "security@vmware.com",
                  "type": "Secondary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                  "metrics": {
                    "baseScore": 8.1,
                    "exploitabilityScore": 2.8,
                    "impactScore": 5.2
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "spring-web",
                  "version": "5.3.10"
                }
              },
              "found": {
                "versionConstraint": "<5.3.34 (unknown)",
                "vulnerabilityID": "GHSA-2wrp-6fg6-hmc5"
              }
            }
          ],
          "artifact": {
            "id": "d9fe63f0bf4a4200",
            "name": "spring-web",
            "version": "5.3.10",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/org.springframework/spring-web@5.3.10",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-2rmj-mq67-h97g",
            "dataSource": "https://github.com/advisories/GHSA-2rmj-mq67-h97g",
            "namespace": "github:language:java",
            "severity": "Medium",
            "urls": [
              "https://github.com/advisories/GHSA-2rmj-mq67-h97g"
            ],
            "description": "Spring Framework DoS via conditional HTTP request",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:L",
                "metrics": {
                  "baseScore": 5.3,
                  "exploitabilityScore": 3.9,
                  "impactScore": 1.4
                },
                "vendorMetadata": {
                  "base_severity": "Medium",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "5.3.38"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2024-38809",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2024-38809",
              "namespace": "nvd:cpe",
              "severity": "Medium",
              "urls": [
                "https://spring.io/security/cve-2024-38809",
                "https://security.netapp.com/advisory/ntap-20240920-0003/"
              ],
              "description": "Applications that parse ETags from \"If-Match\" or \"If-None-Match\" request headers are vulnerable to DoS attack.\n\nUsers of affected versions should upgrade to the corresponding fixed version.\n\nUsers of older, unsupported versions could enforce a size limit on \"If-Match\" and \"If-None-Match\" headers, e.g. through a Filter.",
              "cvss": [
                {
                  "source": "security@vmware.com",
                  "type": "Secondary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:L",
                  "metrics": {
                    "baseScore": 5.3,
                    "exploitabilityScore": 3.9,
                    "impactScore": 1.4
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "spring-web",
                  "version": "5.3.10"
                }
              },
              "found": {
                "versionConstraint": "<5.3.38 (unknown)",
                "vulnerabilityID": "GHSA-2rmj-mq67-h97g"
              }
            }
          ],
          "artifact": {
            "id": "d9fe63f0bf4a4200",
            "name": "spring-web",
            "version": "5.3.10",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/org.springframework/spring-web@5.3.10",
            "upstreams": []
          }
        }
      ],
      "source": {
        "type": "unknown",
        "target": "unknown"
      },
      "distro": {
        "name": "Ubuntu",
        "version": "22.04",
        "idLike": [
          "Ubuntu"
        ]
      },
      "descriptor": {
        "name": "grype",
        "version": "0.86.1",
        "configuration": {
          "output": [
            "json"
          ],
          "file": "",
          "distro": "",
          "add-cpes-if-none": false,
          "output-template-file": "",
          "check-for-app-update": true,
          "only-fixed": false,
          "only-notfixed": false,
          "ignore-wontfix": "",
          "platform": "",
          "search": {
            "scope": "squashed",
            "unindexed-archives": false,
            "indexed-archives": true
          },
          "ignore": [
            {
              "vulnerability": "",
              "reason": "",
              "namespace": "",
              "fix-state": "",
              "package": {
                "name": "kernel-headers",
                "version": "",
                "language": "",
                "type": "rpm",
                "location": "",
                "upstream-name": "kernel"
              },
              "vex-status": "",
              "vex-justification": "",
              "match-type": "exact-indirect-match"
            },
            {
              "vulnerability": "",
              "reason": "",
              "namespace": "",
              "fix-state": "",
              "package": {
                "name": "linux-.*-headers-.*",
                "version": "",
                "language": "",
                "type": "deb",
                "location": "",
                "upstream-name": "linux"
              },
              "vex-status": "",
              "vex-justification": "",
              "match-type": "exact-indirect-match"
            },
            {
              "vulnerability": "",
              "reason": "",
              "namespace": "",
              "fix-state": "",
              "package": {
                "name": "linux-libc-dev",
                "version": "",
                "language": "",
                "type": "deb",
                "location": "",
                "upstream-name": "linux"
              },
              "vex-status": "",
              "vex-justification": "",
              "match-type": "exact-indirect-match"
            }
          ],
          "exclude": [],
          "db": {
            "cache-dir": "/home/ut/.cache/grype/db",
            "update-url": "https://toolbox-data.anchore.io/grype/databases/listing.json",
            "ca-cert": "",
            "auto-update": true,
            "validate-by-hash-on-start": false,
            "validate-age": true,
            "max-allowed-built-age": 432000000000000,
            "require-update-check": false,
            "update-available-timeout": 30000000000,
            "update-download-timeout": 300000000000,
            "max-update-check-frequency": 7200000000000
          },
          "externalSources": {
            "enable": false,
            "maven": {
              "searchUpstreamBySha1": true,
              "baseUrl": "https://search.maven.org/solrsearch/select"
            }
          },
          "match": {
            "java": {
              "using-cpes": false
            },
            "jvm": {
              "using-cpes": true
            },
            "dotnet": {
              "using-cpes": false
            },
            "golang": {
              "using-cpes": false,
              "always-use-cpe-for-stdlib": true,
              "allow-main-module-pseudo-version-comparison": false
            },
            "javascript": {
              "using-cpes": false
            },
            "python": {
              "using-cpes": false
            },
            "ruby": {
              "using-cpes": false
            },
            "rust": {
              "using-cpes": false
            },
            "stock": {
              "using-cpes": true
            }
          },
          "fail-on-severity": "",
          "registry": {
            "insecure-skip-tls-verify": false,
            "insecure-use-http": false,
            "auth": null,
            "ca-cert": ""
          },
          "show-suppressed": false,
          "by-cve": false,
          "name": "",
          "default-image-pull-source": "",
          "vex-documents": [],
          "vex-add": [],
          "match-upstream-kernel-headers": false,
          "exp": {
            "dbv6": false
          }
        },
        "db": {
          "built": "2025-01-08T01:31:26Z",
          "schemaVersion": 5,
          "location": "/home/ut/.cache/grype/db/5",
          "checksum": "sha256:4df63b32bc732b61fa64c4b9ccd0fc2afa675314f1de5bd52eb4fd2a34d98e50",
          "error": null
        },
        "timestamp": "2025-01-08T08:13:21.132690365Z"
      }
    }
  },
  {
    "scanId": "SCAN9EAEC58D",
    "timestamp": "12 January 2025",
    "status": "Analyzed",
    "resolved": true,
    "Basic": {
      "Name": "Company1",
      "Description": "Company1 application sbom",
      "sbomFormat": "cyclonedx",
      "sbomVersion": "1.0.0"
    },
    "Advanced Settings": {
      "sbomValidate": "",
      "sbomIncludeDevDependencies": ""
    },
    "schedule": {
      "frequency": "",
      "time": "",
      "timezone": ""
    },
    "credentials": {},
    "mainscanType": "SBOM",
    "files": {
      "sbomFile": {
        "filename": "sbom-complex-1736630608136.json",
        "originalName": "sbom-complex.json",
        "storedAt": "sbom-complex-1736630608136.json"
      }
    },
    "analysis": {
      "matches": [
        {
          "vulnerability": {
            "id": "GHSA-rgv9-q543-rqg4",
            "dataSource": "https://github.com/advisories/GHSA-rgv9-q543-rqg4",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-rgv9-q543-rqg4"
            ],
            "description": "Uncontrolled Resource Consumption in FasterXML jackson-databind",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                "metrics": {
                  "baseScore": 7.5,
                  "exploitabilityScore": 3.9,
                  "impactScore": 3.6
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "2.13.4"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2022-42004",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2022-42004",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://bugs.chromium.org/p/oss-fuzz/issues/detail?id=50490",
                "https://github.com/FasterXML/jackson-databind/commit/063183589218fec19a9293ed2f17ec53ea80ba88",
                "https://github.com/FasterXML/jackson-databind/issues/3582",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.gentoo.org/glsa/202210-21",
                "https://security.netapp.com/advisory/ntap-20221118-0008/",
                "https://www.debian.org/security/2022/dsa-5283",
                "https://bugs.chromium.org/p/oss-fuzz/issues/detail?id=50490",
                "https://github.com/FasterXML/jackson-databind/commit/063183589218fec19a9293ed2f17ec53ea80ba88",
                "https://github.com/FasterXML/jackson-databind/issues/3582",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.gentoo.org/glsa/202210-21",
                "https://security.netapp.com/advisory/ntap-20221118-0008/",
                "https://www.debian.org/security/2022/dsa-5283"
              ],
              "description": "In FasterXML jackson-databind before 2.13.4, resource exhaustion can occur because of a lack of a check in BeanDeserializer._deserializeFromArray to prevent use of deeply nested arrays. An application is vulnerable only with certain customized choices for deserialization.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                  "metrics": {
                    "baseScore": 7.5,
                    "exploitabilityScore": 3.9,
                    "impactScore": 3.6
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "jackson-databind",
                  "version": "2.13.0"
                }
              },
              "found": {
                "versionConstraint": ">=2.13.0,<2.13.4 (unknown)",
                "vulnerabilityID": "GHSA-rgv9-q543-rqg4"
              }
            }
          ],
          "artifact": {
            "id": "ce3eae9514ee480b",
            "name": "jackson-databind",
            "version": "2.13.0",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/com.fasterxml.jackson.core/jackson-databind@2.13.0",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-jjjh-jjxp-wpff",
            "dataSource": "https://github.com/advisories/GHSA-jjjh-jjxp-wpff",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-jjjh-jjxp-wpff"
            ],
            "description": "Uncontrolled Resource Consumption in Jackson-databind",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                "metrics": {
                  "baseScore": 7.5,
                  "exploitabilityScore": 3.9,
                  "impactScore": 3.6
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "2.13.4.2"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2022-42003",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2022-42003",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://bugs.chromium.org/p/oss-fuzz/issues/detail?id=51020",
                "https://github.com/FasterXML/jackson-databind/commit/d78d00ee7b5245b93103fef3187f70543d67ca33",
                "https://github.com/FasterXML/jackson-databind/issues/3590",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.gentoo.org/glsa/202210-21",
                "https://security.netapp.com/advisory/ntap-20221124-0004/",
                "https://www.debian.org/security/2022/dsa-5283",
                "https://bugs.chromium.org/p/oss-fuzz/issues/detail?id=51020",
                "https://github.com/FasterXML/jackson-databind/commit/d78d00ee7b5245b93103fef3187f70543d67ca33",
                "https://github.com/FasterXML/jackson-databind/issues/3590",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.gentoo.org/glsa/202210-21",
                "https://security.netapp.com/advisory/ntap-20221124-0004/",
                "https://www.debian.org/security/2022/dsa-5283"
              ],
              "description": "In FasterXML jackson-databind before versions 2.13.4.1 and 2.12.17.1, resource exhaustion can occur because of a lack of a check in primitive value deserializers to avoid deep wrapper array nesting, when the UNWRAP_SINGLE_VALUE_ARRAYS feature is enabled.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                  "metrics": {
                    "baseScore": 7.5,
                    "exploitabilityScore": 3.9,
                    "impactScore": 3.6
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "jackson-databind",
                  "version": "2.13.0"
                }
              },
              "found": {
                "versionConstraint": ">=2.13.0,<2.13.4.2 (unknown)",
                "vulnerabilityID": "GHSA-jjjh-jjxp-wpff"
              }
            }
          ],
          "artifact": {
            "id": "ce3eae9514ee480b",
            "name": "jackson-databind",
            "version": "2.13.0",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/com.fasterxml.jackson.core/jackson-databind@2.13.0",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-57j2-w4cx-62h2",
            "dataSource": "https://github.com/advisories/GHSA-57j2-w4cx-62h2",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-57j2-w4cx-62h2"
            ],
            "description": "Deeply nested json in jackson-databind",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                "metrics": {
                  "baseScore": 7.5,
                  "exploitabilityScore": 3.9,
                  "impactScore": 3.6
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "2.13.2.1"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2020-36518",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2020-36518",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://github.com/FasterXML/jackson-databind/issues/2816",
                "https://lists.debian.org/debian-lts-announce/2022/05/msg00001.html",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.netapp.com/advisory/ntap-20220506-0004/",
                "https://www.debian.org/security/2022/dsa-5283",
                "https://www.oracle.com/security-alerts/cpuapr2022.html",
                "https://www.oracle.com/security-alerts/cpujul2022.html",
                "https://github.com/FasterXML/jackson-databind/issues/2816",
                "https://lists.debian.org/debian-lts-announce/2022/05/msg00001.html",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.netapp.com/advisory/ntap-20220506-0004/",
                "https://www.debian.org/security/2022/dsa-5283",
                "https://www.oracle.com/security-alerts/cpuapr2022.html",
                "https://www.oracle.com/security-alerts/cpujul2022.html"
              ],
              "description": "jackson-databind before 2.13.0 allows a Java StackOverflow exception and denial of service via a large depth of nested objects.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "2.0",
                  "vector": "AV:N/AC:L/Au:N/C:N/I:N/A:P",
                  "metrics": {
                    "baseScore": 5,
                    "exploitabilityScore": 10,
                    "impactScore": 2.9
                  },
                  "vendorMetadata": {}
                },
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                  "metrics": {
                    "baseScore": 7.5,
                    "exploitabilityScore": 3.9,
                    "impactScore": 3.6
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "jackson-databind",
                  "version": "2.13.0"
                }
              },
              "found": {
                "versionConstraint": ">=2.13.0,<=2.13.2.0 (unknown)",
                "vulnerabilityID": "GHSA-57j2-w4cx-62h2"
              }
            }
          ],
          "artifact": {
            "id": "ce3eae9514ee480b",
            "name": "jackson-databind",
            "version": "2.13.0",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/com.fasterxml.jackson.core/jackson-databind@2.13.0",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-3x8x-79m2-3w2w",
            "dataSource": "https://github.com/advisories/GHSA-3x8x-79m2-3w2w",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-3x8x-79m2-3w2w"
            ],
            "description": "jackson-databind possible Denial of Service if using JDK serialization to serialize JsonNode",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                "metrics": {
                  "baseScore": 7.5,
                  "exploitabilityScore": 3.9,
                  "impactScore": 3.6
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "2.13.1"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2021-46877",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2021-46877",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://github.com/FasterXML/jackson-databind/issues/3328",
                "https://groups.google.com/g/jackson-user/c/OsBsirPM_Vw",
                "https://github.com/FasterXML/jackson-databind/issues/3328",
                "https://groups.google.com/g/jackson-user/c/OsBsirPM_Vw"
              ],
              "description": "jackson-databind 2.10.x through 2.12.x before 2.12.6 and 2.13.x before 2.13.1 allows attackers to cause a denial of service (2 GB transient heap usage per read) in uncommon situations involving JsonNode JDK serialization.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                  "metrics": {
                    "baseScore": 7.5,
                    "exploitabilityScore": 3.9,
                    "impactScore": 3.6
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "jackson-databind",
                  "version": "2.13.0"
                }
              },
              "found": {
                "versionConstraint": ">=2.13.0,<2.13.1 (unknown)",
                "vulnerabilityID": "GHSA-3x8x-79m2-3w2w"
              }
            }
          ],
          "artifact": {
            "id": "ce3eae9514ee480b",
            "name": "jackson-databind",
            "version": "2.13.0",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/com.fasterxml.jackson.core/jackson-databind@2.13.0",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-4wrc-f8pq-fpqp",
            "dataSource": "https://github.com/advisories/GHSA-4wrc-f8pq-fpqp",
            "namespace": "github:language:java",
            "severity": "Critical",
            "urls": [
              "https://github.com/advisories/GHSA-4wrc-f8pq-fpqp"
            ],
            "description": "Pivotal Spring Framework contains unsafe Java deserialization methods",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:H/I:H/A:H",
                "metrics": {
                  "baseScore": 9.8,
                  "exploitabilityScore": 3.9,
                  "impactScore": 5.9
                },
                "vendorMetadata": {
                  "base_severity": "Critical",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "6.0.0"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2016-1000027",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2016-1000027",
              "namespace": "nvd:cpe",
              "severity": "Critical",
              "urls": [
                "https://bugzilla.redhat.com/show_bug.cgi?id=CVE-2016-1000027",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-579669626",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-582313417",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-744519525",
                "https://raw.githubusercontent.com/distributedweaknessfiling/cvelist/master/2016/1000xxx/CVE-2016-1000027.json",
                "https://security-tracker.debian.org/tracker/CVE-2016-1000027",
                "https://security.netapp.com/advisory/ntap-20230420-0009/",
                "https://spring.io/blog/2022/05/11/spring-framework-5-3-20-and-5-2-22-available-now",
                "https://www.tenable.com/security/research/tra-2016-20",
                "https://bugzilla.redhat.com/show_bug.cgi?id=CVE-2016-1000027",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-579669626",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-582313417",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-744519525",
                "https://raw.githubusercontent.com/distributedweaknessfiling/cvelist/master/2016/1000xxx/CVE-2016-1000027.json",
                "https://security-tracker.debian.org/tracker/CVE-2016-1000027",
                "https://security.netapp.com/advisory/ntap-20230420-0009/",
                "https://spring.io/blog/2022/05/11/spring-framework-5-3-20-and-5-2-22-available-now",
                "https://www.tenable.com/security/research/tra-2016-20"
              ],
              "description": "Pivotal Spring Framework through 5.3.16 suffers from a potential remote code execution (RCE) issue if used for Java deserialization of untrusted data. Depending on how the library is implemented within a product, this issue may or not occur, and authentication may be required. NOTE: the vendor's position is that untrusted data is not an intended use case. The product's behavior will not be changed because some users rely on deserialization of trusted data.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "2.0",
                  "vector": "AV:N/AC:L/Au:N/C:P/I:P/A:P",
                  "metrics": {
                    "baseScore": 7.5,
                    "exploitabilityScore": 10,
                    "impactScore": 6.4
                  },
                  "vendorMetadata": {}
                },
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:H/I:H/A:H",
                  "metrics": {
                    "baseScore": 9.8,
                    "exploitabilityScore": 3.9,
                    "impactScore": 5.9
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "spring-web",
                  "version": "5.3.10"
                }
              },
              "found": {
                "versionConstraint": "<6.0.0 (unknown)",
                "vulnerabilityID": "GHSA-4wrc-f8pq-fpqp"
              }
            }
          ],
          "artifact": {
            "id": "d9fe63f0bf4a4200",
            "name": "spring-web",
            "version": "5.3.10",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/org.springframework/spring-web@5.3.10",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-hgjh-9rj2-g67j",
            "dataSource": "https://github.com/advisories/GHSA-hgjh-9rj2-g67j",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-hgjh-9rj2-g67j"
            ],
            "description": "Spring Framework URL Parsing with Host Validation Vulnerability",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                "metrics": {
                  "baseScore": 8.1,
                  "exploitabilityScore": 2.8,
                  "impactScore": 5.2
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "5.3.33"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2024-22259",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2024-22259",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://security.netapp.com/advisory/ntap-20240524-0002/",
                "https://spring.io/security/cve-2024-22259",
                "https://security.netapp.com/advisory/ntap-20240524-0002/",
                "https://spring.io/security/cve-2024-22259"
              ],
              "description": "Applications that use UriComponentsBuilder in Spring Framework to parse an externally provided URL (e.g. through a query parameter) AND perform validation checks on the host of the parsed URL may be vulnerable to a  open redirect https://cwe.mitre.org/data/definitions/601.html  attack or to a SSRF attack if the URL is used after passing validation checks.\n\nThis is the same as  CVE-2024-22243 https://spring.io/security/cve-2024-22243 , but with different input.\n\n",
              "cvss": [
                {
                  "source": "security@vmware.com",
                  "type": "Secondary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                  "metrics": {
                    "baseScore": 8.1,
                    "exploitabilityScore": 2.8,
                    "impactScore": 5.2
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "spring-web",
                  "version": "5.3.10"
                }
              },
              "found": {
                "versionConstraint": "<5.3.33 (unknown)",
                "vulnerabilityID": "GHSA-hgjh-9rj2-g67j"
              }
            }
          ],
          "artifact": {
            "id": "d9fe63f0bf4a4200",
            "name": "spring-web",
            "version": "5.3.10",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/org.springframework/spring-web@5.3.10",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-ccgv-vj62-xf9h",
            "dataSource": "https://github.com/advisories/GHSA-ccgv-vj62-xf9h",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-ccgv-vj62-xf9h"
            ],
            "description": "Spring Web vulnerable to Open Redirect or Server Side Request Forgery",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                "metrics": {
                  "baseScore": 8.1,
                  "exploitabilityScore": 2.8,
                  "impactScore": 5.2
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "5.3.32"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2024-22243",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2024-22243",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://security.netapp.com/advisory/ntap-20240524-0001/",
                "https://spring.io/security/cve-2024-22243",
                "http://seclists.org/fulldisclosure/2024/Sep/24",
                "https://security.netapp.com/advisory/ntap-20240524-0001/",
                "https://spring.io/security/cve-2024-22243"
              ],
              "description": "Applications that use UriComponentsBuilder to parse an externally provided URL (e.g. through a query parameter) AND perform validation checks on the host of the parsed URL may be vulnerable to a  open redirect https://cwe.mitre.org/data/definitions/601.html  attack or to a SSRF attack if the URL is used after passing validation checks.\n",
              "cvss": [
                {
                  "source": "security@vmware.com",
                  "type": "Secondary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                  "metrics": {
                    "baseScore": 8.1,
                    "exploitabilityScore": 2.8,
                    "impactScore": 5.2
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "spring-web",
                  "version": "5.3.10"
                }
              },
              "found": {
                "versionConstraint": ">=5.3.0,<5.3.32 (unknown)",
                "vulnerabilityID": "GHSA-ccgv-vj62-xf9h"
              }
            }
          ],
          "artifact": {
            "id": "d9fe63f0bf4a4200",
            "name": "spring-web",
            "version": "5.3.10",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/org.springframework/spring-web@5.3.10",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-2wrp-6fg6-hmc5",
            "dataSource": "https://github.com/advisories/GHSA-2wrp-6fg6-hmc5",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-2wrp-6fg6-hmc5"
            ],
            "description": "Spring Framework URL Parsing with Host Validation",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                "metrics": {
                  "baseScore": 8.1,
                  "exploitabilityScore": 2.8,
                  "impactScore": 5.2
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "5.3.34"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2024-22262",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2024-22262",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://security.netapp.com/advisory/ntap-20240524-0003/",
                "https://spring.io/security/cve-2024-22262",
                "https://security.netapp.com/advisory/ntap-20240524-0003/",
                "https://spring.io/security/cve-2024-22262"
              ],
              "description": "Applications that use UriComponentsBuilder to parse an externally provided URL (e.g. through a query parameter) AND perform validation checks on the host of the parsed URL may be vulnerable to a  open redirect https://cwe.mitre.org/data/definitions/601.html  attack or to a SSRF attack if the URL is used after passing validation checks.\n\nThis is the same as  CVE-2024-22259 https://spring.io/security/cve-2024-22259  and  CVE-2024-22243 https://spring.io/security/cve-2024-22243 , but with different input.\n\n",
              "cvss": [
                {
                  "source": "security@vmware.com",
                  "type": "Secondary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                  "metrics": {
                    "baseScore": 8.1,
                    "exploitabilityScore": 2.8,
                    "impactScore": 5.2
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "spring-web",
                  "version": "5.3.10"
                }
              },
              "found": {
                "versionConstraint": "<5.3.34 (unknown)",
                "vulnerabilityID": "GHSA-2wrp-6fg6-hmc5"
              }
            }
          ],
          "artifact": {
            "id": "d9fe63f0bf4a4200",
            "name": "spring-web",
            "version": "5.3.10",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/org.springframework/spring-web@5.3.10",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-2rmj-mq67-h97g",
            "dataSource": "https://github.com/advisories/GHSA-2rmj-mq67-h97g",
            "namespace": "github:language:java",
            "severity": "Medium",
            "urls": [
              "https://github.com/advisories/GHSA-2rmj-mq67-h97g"
            ],
            "description": "Spring Framework DoS via conditional HTTP request",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:L",
                "metrics": {
                  "baseScore": 5.3,
                  "exploitabilityScore": 3.9,
                  "impactScore": 1.4
                },
                "vendorMetadata": {
                  "base_severity": "Medium",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "5.3.38"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2024-38809",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2024-38809",
              "namespace": "nvd:cpe",
              "severity": "Medium",
              "urls": [
                "https://spring.io/security/cve-2024-38809",
                "https://security.netapp.com/advisory/ntap-20240920-0003/"
              ],
              "description": "Applications that parse ETags from \"If-Match\" or \"If-None-Match\" request headers are vulnerable to DoS attack.\n\nUsers of affected versions should upgrade to the corresponding fixed version.\n\nUsers of older, unsupported versions could enforce a size limit on \"If-Match\" and \"If-None-Match\" headers, e.g. through a Filter.",
              "cvss": [
                {
                  "source": "security@vmware.com",
                  "type": "Secondary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:L",
                  "metrics": {
                    "baseScore": 5.3,
                    "exploitabilityScore": 3.9,
                    "impactScore": 1.4
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "spring-web",
                  "version": "5.3.10"
                }
              },
              "found": {
                "versionConstraint": "<5.3.38 (unknown)",
                "vulnerabilityID": "GHSA-2rmj-mq67-h97g"
              }
            }
          ],
          "artifact": {
            "id": "d9fe63f0bf4a4200",
            "name": "spring-web",
            "version": "5.3.10",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [],
            "purl": "pkg:maven/org.springframework/spring-web@5.3.10",
            "upstreams": []
          }
        }
      ],
      "source": {
        "type": "unknown",
        "target": "unknown"
      },
      "distro": {
        "name": "Ubuntu",
        "version": "22.04",
        "idLike": [
          "Ubuntu"
        ]
      },
      "descriptor": {
        "name": "grype",
        "version": "0.86.1",
        "configuration": {
          "output": [
            "json"
          ],
          "file": "",
          "distro": "",
          "add-cpes-if-none": false,
          "output-template-file": "",
          "check-for-app-update": true,
          "only-fixed": false,
          "only-notfixed": false,
          "ignore-wontfix": "",
          "platform": "",
          "search": {
            "scope": "squashed",
            "unindexed-archives": false,
            "indexed-archives": true
          },
          "ignore": [
            {
              "vulnerability": "",
              "reason": "",
              "namespace": "",
              "fix-state": "",
              "package": {
                "name": "kernel-headers",
                "version": "",
                "language": "",
                "type": "rpm",
                "location": "",
                "upstream-name": "kernel"
              },
              "vex-status": "",
              "vex-justification": "",
              "match-type": "exact-indirect-match"
            },
            {
              "vulnerability": "",
              "reason": "",
              "namespace": "",
              "fix-state": "",
              "package": {
                "name": "linux-.*-headers-.*",
                "version": "",
                "language": "",
                "type": "deb",
                "location": "",
                "upstream-name": "linux"
              },
              "vex-status": "",
              "vex-justification": "",
              "match-type": "exact-indirect-match"
            },
            {
              "vulnerability": "",
              "reason": "",
              "namespace": "",
              "fix-state": "",
              "package": {
                "name": "linux-libc-dev",
                "version": "",
                "language": "",
                "type": "deb",
                "location": "",
                "upstream-name": "linux"
              },
              "vex-status": "",
              "vex-justification": "",
              "match-type": "exact-indirect-match"
            }
          ],
          "exclude": [],
          "db": {
            "cache-dir": "/home/ut/.cache/grype/db",
            "update-url": "https://toolbox-data.anchore.io/grype/databases/listing.json",
            "ca-cert": "",
            "auto-update": true,
            "validate-by-hash-on-start": false,
            "validate-age": true,
            "max-allowed-built-age": 432000000000000,
            "require-update-check": false,
            "update-available-timeout": 30000000000,
            "update-download-timeout": 300000000000,
            "max-update-check-frequency": 7200000000000
          },
          "externalSources": {
            "enable": false,
            "maven": {
              "searchUpstreamBySha1": true,
              "baseUrl": "https://search.maven.org/solrsearch/select"
            }
          },
          "match": {
            "java": {
              "using-cpes": false
            },
            "jvm": {
              "using-cpes": true
            },
            "dotnet": {
              "using-cpes": false
            },
            "golang": {
              "using-cpes": false,
              "always-use-cpe-for-stdlib": true,
              "allow-main-module-pseudo-version-comparison": false
            },
            "javascript": {
              "using-cpes": false
            },
            "python": {
              "using-cpes": false
            },
            "ruby": {
              "using-cpes": false
            },
            "rust": {
              "using-cpes": false
            },
            "stock": {
              "using-cpes": true
            }
          },
          "fail-on-severity": "",
          "registry": {
            "insecure-skip-tls-verify": false,
            "insecure-use-http": false,
            "auth": null,
            "ca-cert": ""
          },
          "show-suppressed": false,
          "by-cve": false,
          "name": "",
          "default-image-pull-source": "",
          "vex-documents": [],
          "vex-add": [],
          "match-upstream-kernel-headers": false,
          "exp": {
            "dbv6": false
          }
        },
        "db": {
          "built": "2025-01-11T01:31:37Z",
          "schemaVersion": 5,
          "location": "/home/ut/.cache/grype/db/5",
          "checksum": "sha256:cc72ba1db7ec7312d2aa0bc6d2bace933d843af7e256540aa73b461e1733f3be",
          "error": null
        },
        "timestamp": "2025-01-11T21:53:16.520113777Z"
      }
    }
  },
  {
    "scanId": "SCANE0869145",
    "timestamp": "12 January 2025",
    "status": "Analyzed",
    "Basic": {
      "Name": "Internet Secure org",
      "Description": "testing Internet Secure Org ",
      "target": "https://internetsecure.org",
      "scanType": ""
    },
    "schedule": {
      "frequency": "",
      "time": "",
      "timezone": ""
    },
    "credentials": {},
    "mainscanType": "basic",
    "files": {},
    "resolved": false,
    "vulnerabilities": {
      "internetsecure.org": [
        {
          "name": "HTTP Server Type and Version",
          "protocol": "tcp",
          "port": 80,
          "synopsis": "An HTTP web server is detected on the remote host.  Further analysis is required to identify the specific server software and version.",
          "description": "This service attempts to identify the type and version of the HTTP web server running on the remote host.  Knowing this information is crucial for understanding potential security vulnerabilities.",
          "solution": "Implement a robust vulnerability management program that includes regular patching and updates of web server software.  Regularly review and update security configurations for the web server.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "IAVT:0001-T-0931",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HTTP Server Type and Version",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "A web server is accessible on the remote host via port 443, indicating HTTPS is enabled.",
          "description": "This assessment identifies the type and version of the remote web server utilizing HTTPS.  Identifying the server type and version is crucial for understanding potential vulnerabilities and compatibility.",
          "solution": "Regularly review and update the web server software to address known vulnerabilities and ensure compatibility with security best practices.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "IAVT:0001-T-0931",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HTTP Server Type and Version",
          "protocol": "tcp",
          "port": 2086,
          "synopsis": "A web server is listening on TCP port 2086.  This indicates a potential web application is accessible.",
          "description": "This service attempts to identify the type and version of the web server software running on the remote host.  Knowing this information is crucial for vulnerability assessment and security posture management.",
          "solution": "Implement a robust vulnerability management program, regularly patching the web server software to address known vulnerabilities.  Consider using a web application firewall (WAF) to mitigate potential attacks.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "IAVT:0001-T-0931",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HTTP Server Type and Version",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "A web server is listening on the remote host's TCP port 2087.  This indicates a potential web application is accessible.",
          "description": "This assessment identifies the type and version of the web server software running on the remote host.  Knowledge of the server type and version is crucial for identifying potential security vulnerabilities and implementing appropriate mitigations.",
          "solution": "Implement a robust vulnerability management program that includes regular security scanning and patching.  Regularly review and update server software to address known vulnerabilities.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "IAVT:0001-T-0931",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HTTP Server Type and Version",
          "protocol": "tcp",
          "port": 8080,
          "synopsis": "An HTTP service is detected on the remote host, indicating a web server is operational.",
          "description": "This assessment identifies the type and version of the web server running on the remote host.  Knowledge of the server's type and version is crucial for understanding its security posture and potential vulnerabilities.",
          "solution": "Implement a comprehensive vulnerability management program. Regularly update and patch the web server software to address known security flaws.  Consider implementing robust input validation and output encoding to mitigate potential vulnerabilities.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "IAVT:0001-T-0931",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Traceroute Information",
          "protocol": "udp",
          "port": 0,
          "synopsis": "Network path information was disclosed via traceroute.",
          "description": "The ability to perform a traceroute to the remote host reveals the network path taken by packets, potentially exposing intermediate network devices and their IP addresses.  This information could be used for network mapping and potentially aid in further attacks.",
          "solution": "Implement network-level access controls to restrict traceroute activity. Consider using firewalls to filter ICMP packets utilized by traceroute. Employ intrusion detection systems (IDS) to monitor and alert on suspicious traceroute attempts.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Web Server robots.txt Information Disclosure",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "A 'robots.txt' file is accessible on the remote web server.",
          "description": "The presence of a 'robots.txt' file reveals directives intended to control web crawler access to specific website directories.  While designed for managing web indexing and maintenance, the information contained within this file can inadvertently expose sensitive file paths or directories to unauthorized actors.  This exposure could facilitate further attacks, including direct retrieval of sensitive data or targeted exploitation of identified vulnerabilities.",
          "solution": "Conduct a thorough review of the 'robots.txt' file's contents to identify any potential disclosures of sensitive information.  Consider using alternative methods like Robots META tags to manage web crawler access, thereby reducing reliance on the 'robots.txt' file. Implement robust access controls at the web server level to restrict access to sensitive resources irrespective of 'robots.txt' directives.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Web Server No 404 Error Code Check",
          "protocol": "tcp",
          "port": 8080,
          "synopsis": "The remote web server does not return standard 404 error codes for nonexistent resources.",
          "description": "The web server's response to requests for non-existent files or resources does not conform to the HTTP standard. Instead of a 404 Not Found response, the server returns alternative content, such as a site map, search page, or authentication page. This behavior could potentially reveal unintended information about the server's structure or functionality.  While some mitigations may be in place, their effectiveness against a large-scale attack is uncertain; a high volume of requests targeting this vulnerability might overwhelm these mitigations and lead to inaccurate results.",
          "solution": "Implement proper HTTP error handling.  The server should return a standard 404 Not Found response code for all requests targeting nonexistent resources.  This improves security by preventing information leakage and reduces the potential for exploitation.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Information",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "This function retrieves and analyzes SSL/TLS certificates.",
          "description": "This function establishes a connection to ports utilizing the SSL/TLS protocol and extracts the X.509 certificate data.  This allows for examination of certificate details such as issuer, subject, validity period, and public key information.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Information",
          "protocol": "tcp",
          "port": 2053,
          "synopsis": "This plugin retrieves and displays SSL/TLS certificate information.",
          "description": "This functionality establishes a connection to network ports commonly used for SSL/TLS communication and attempts to retrieve and display the associated X.509 certificate.  This process allows for verification of certificate validity, including checking for expiration dates and examining certificate details.",
          "solution": "Regularly review and update SSL/TLS certificates to ensure validity and prevent expiration. Implement robust certificate management practices.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Information",
          "protocol": "tcp",
          "port": 2083,
          "synopsis": "This module retrieves and displays SSL/TLS certificate details.",
          "description": "This module establishes a connection to network ports using the SSL/TLS protocol and attempts to retrieve and display the X.509 certificate presented by the server.  This allows for verification of certificate validity, including checking for expiration dates and verifying the certificate's issuer and subject.",
          "solution": "Regularly review and update SSL/TLS certificates to ensure validity and prevent certificate-related security issues. Implement certificate pinning where appropriate to prevent man-in-the-middle attacks.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Information",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "This check retrieves and analyzes the SSL/TLS certificate presented by a remote server.",
          "description": "This check establishes a connection to the specified TCP port (2087), typically used for SSL/TLS services, and attempts to retrieve and parse the server's X.509 certificate.  This allows for examination of certificate details, such as validity periods, issuer, and subject information.  Successful retrieval indicates that an SSL/TLS certificate is configured on the specified port.",
          "solution": "Regularly review and update SSL/TLS certificates to ensure validity and appropriate configuration.  Ensure the certificate chain is complete and trusted.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Information",
          "protocol": "tcp",
          "port": 8443,
          "synopsis": "This check retrieves and analyzes the SSL/TLS certificate presented by a service.",
          "description": "This check establishes a connection to the specified port (typically used for HTTPS) and attempts to retrieve and parse the X.509 certificate. This allows for inspection of the certificate's properties, such as issuer, subject, validity period, and algorithms used.",
          "solution": "Ensure that a valid and appropriately configured SSL/TLS certificate is presented by the service.  Regularly review and renew certificates before expiration.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SYN scanner",
          "protocol": "tcp",
          "port": 80,
          "synopsis": "Identifies open TCP ports by detecting responses to SYN packets.",
          "description": "This plugin performs a TCP SYN scan, also known as a half-open scan.  It's designed for speed, even against systems with firewalls.  While less intrusive than a full TCP connect scan against malfunctioning services, it can still stress less robust firewalls or leave half-open connections on the target if the network is heavily loaded.  Incomplete connection closures can lead to resource exhaustion on the target system.",
          "solution": "Implement network-based intrusion detection and prevention systems (NIPS/NIDPS), and consider employing more robust firewall rules that restrict inbound SYN traffic to legitimate sources and ports.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SYN scanner",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "Detects open TCP ports by analyzing responses to SYN packets.",
          "description": "This plugin employs a SYN scan, a TCP port scanning technique that initiates a TCP connection by sending a SYN packet without completing the three-way handshake. This method is generally faster than a full TCP connect scan and can be effective even against firewalls. However, while less intrusive than a full connect scan, SYN scans might overload a network and potentially trigger alerts on less robust firewall systems. Furthermore, incompletely closed connections can persist on the target host under heavy network load.  The technique uses the absence or presence of a SYN-ACK to determine port status.",
          "solution": "Implement robust network filtering using a firewall or intrusion prevention system to restrict inbound and outbound TCP connections to only authorized ports and IP addresses. Regularly review and update firewall rules.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SYN scanner",
          "protocol": "tcp",
          "port": 2053,
          "synopsis": "Identifies open TCP ports on a target system.",
          "description": "This plugin performs a TCP SYN scan, a network reconnaissance technique that attempts to establish a TCP connection without completing the three-way handshake.  This method is generally faster than a full TCP connect scan and less likely to trigger alerts from well-configured intrusion detection systems. However, SYN scans can still be detected by network monitoring tools and might overload less robust firewalls. Furthermore, incomplete TCP connections might remain on the target system if its network resources are constrained, potentially leading to resource exhaustion.",
          "solution": "Implement network-based intrusion detection and prevention systems with appropriate rules to filter or block suspicious SYN scanning activity.  Consider implementing rate limiting to mitigate potential denial-of-service attacks associated with high volumes of SYN scans.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SYN scanner",
          "protocol": "tcp",
          "port": 2083,
          "synopsis": "Identifies open TCP ports by detecting responses to SYN packets.",
          "description": "This plugin employs a SYN scan, a TCP port scanning technique that sends a SYN packet (the first part of a TCP three-way handshake) without completing the connection. This method is generally less intrusive than a full TCP connect scan because it avoids establishing a full connection. However,  it's important to note that even SYN scans can overwhelm less robust firewalls or overloaded network infrastructure and may leave incomplete TCP connection attempts on the target system.  The effectiveness against firewalls depends on their configuration and ability to detect and drop SYN packets.",
          "solution": "Implement a robust network firewall with appropriate rules to restrict unauthorized port access.  Consider intrusion detection and prevention systems (IDPS) to monitor and block malicious scanning activity.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SYN scanner",
          "protocol": "tcp",
          "port": 2086,
          "synopsis": "Detects open TCP ports by leveraging the TCP three-way handshake.",
          "description": "This plugin performs a TCP SYN scan, a network reconnaissance technique that initiates a TCP connection but does not complete the handshake.  This method is relatively quick, even against systems with firewalls.  While less intrusive than a full TCP connect scan on failing services, SYN scans can still overload less robust firewalls or leave incomplete TCP connections on the target if network congestion exists.",
          "solution": "Implement network-level access controls, such as firewalls or intrusion detection/prevention systems, to restrict unauthorized network scanning attempts.  Consider rate limiting inbound TCP connections.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SYN scanner",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "Identifies open TCP ports by detecting responses to SYN packets.",
          "description": "This plugin performs a TCP SYN scan, also known as a half-open scan.  This technique is generally faster than a full TCP connect scan, even against systems with firewalls.  While less intrusive than a full connect scan against malfunctioning services, SYN scans can still overload less robust firewalls or leave unclosed connections on the target system under high network load.  Incomplete connection closure can lead to resource exhaustion on the target.",
          "solution": "Implement robust network filtering at the perimeter to restrict unauthorized TCP port access.  Consider deploying an intrusion detection/prevention system (IDS/IPS) to monitor and block malicious network activity.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SYN scanner",
          "protocol": "tcp",
          "port": 8080,
          "synopsis": "Identifies open TCP ports by detecting responses to SYN packets.",
          "description": "This plugin performs a SYN scan, a technique that initiates a TCP connection by sending a SYN packet without completing the three-way handshake. This method is generally faster than a full TCP connect scan and less intrusive towards legitimate services. However, it can still trigger alerts on some firewalls and, under heavy network load, might leave incomplete TCP connections on the target system.  The effectiveness of the scan may be reduced by firewalls that filter SYN packets or implement more advanced intrusion detection mechanisms.",
          "solution": "Implement robust network filtering and intrusion detection systems to mitigate unauthorized port scanning attempts. Consider deploying a firewall that filters incoming SYN packets based on predefined rules and monitoring for suspicious network activity.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SYN scanner",
          "protocol": "tcp",
          "port": 8443,
          "synopsis": "Identifies open TCP ports by detecting responses to SYN packets.",
          "description": "This plugin performs a TCP SYN scan, a technique that initiates a TCP connection but does not complete the three-way handshake. This approach is generally less intrusive than a full TCP connect scan, as it avoids establishing a fully functional connection.  However, it's important to note that  SYN scans can still be detected by intrusion detection systems and firewalls.  High-volume SYN scans may overwhelm less robust network infrastructure or firewalls and potentially leave incomplete TCP connections on the target system if network resources are constrained.  The impact depends heavily on the target system's configuration and network conditions.",
          "solution": "Implement appropriate network segmentation and filtering to restrict inbound TCP connections to only necessary ports and services.  Consider rate limiting to mitigate the effects of SYN flood attacks.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "OS Identification",
          "protocol": "tcp",
          "port": 0,
          "synopsis": "Inference of the remote operating system is possible.",
          "description": "Network probes utilizing various protocols (TCP/IP, SMB, HTTP, NTP, SNMP, etc.) can reveal information enabling the identification of the remote operating system and, in some cases, its version.  This information leakage occurs due to the inherent characteristics of network communication protocols and the operating system's responses to these probes.",
          "solution": "Implement network segmentation and restrict access to network resources.  Minimize the surface area exposed to network scans by disabling unnecessary services and protocols. Employ strong network monitoring and intrusion detection to detect and respond to probing activity. Regular security audits and vulnerability assessments can help identify and mitigate potential weaknesses.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Scan Information",
          "protocol": "tcp",
          "port": 0,
          "synopsis": "This plugin provides a summary of the vulnerability scan execution details.",
          "description": "This plugin provides, for each target system, comprehensive metadata regarding the vulnerability scan process:\n\n  - The version of the vulnerability assessment tool.\n  - The type of scan engine used (e.g., network-based, agent-based).\n  - The version of the scan engine core.\n  - The network ports scanned.\n  - The range of network ports analyzed.\n  - The network latency (round-trip time).\n  - Support for authenticated or remote patching system integration.\n  - Indication of whether outdated patch information is included in the results.\n  - Timestamp of the scan initiation.\n  - The total time required for the scan completion.\n  - The number of concurrent target systems processed.\n  - The number of concurrent checks performed.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Cipher Suites Supported",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service utilizes SSL/TLS for encrypting communications.  This assessment identifies the supported cipher suites.",
          "description": "This analysis determines the SSL/TLS cipher suites enabled by the remote service.  Knowledge of supported cipher suites is crucial for evaluating the strength and security posture of the communication channel.",
          "solution": "Configure the service to support only strong, modern cipher suites, disabling outdated and vulnerable options.  Regularly review and update the cipher suite configuration to align with current best practices and address newly discovered vulnerabilities.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Cipher Suites Supported",
          "protocol": "tcp",
          "port": 2053,
          "synopsis": "The remote service utilizes SSL for encrypting communication channels.  This assessment identifies the supported cipher suites.",
          "description": "This analysis determines the SSL/TLS cipher suites enabled on the remote service.  Knowing the supported cipher suites allows for an assessment of the cryptographic strength and potential vulnerabilities related to weak or deprecated cipher algorithms.",
          "solution": "Implement a robust cipher suite policy, enabling only strong and modern cipher suites.  Regularly review and update this policy to address emerging cryptographic vulnerabilities.  Disable or deprecate weak and outdated cipher suites.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Cipher Suites Supported",
          "protocol": "tcp",
          "port": 2083,
          "synopsis": "The remote service utilizes SSL/TLS for secure communication, employing a specific set of cipher suites.",
          "description": "This assessment identifies the SSL/TLS cipher suites supported by the remote service.  The supported cipher suites determine the cryptographic algorithms used for encryption and authentication during the communication process.  A comprehensive understanding of these suites is crucial for evaluating the strength and security of the connection.",
          "solution": "Implement a security policy defining acceptable cipher suites and ensure the server configuration adheres to that policy. Regularly review and update the policy to incorporate best practices and address newly discovered vulnerabilities.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Cipher Suites Supported",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "The remote service utilizes SSL/TLS for secure communication.  This assessment identifies the supported cipher suites.",
          "description": "This analysis determines the cryptographic algorithms and key exchange methods supported by the remote service's SSL/TLS implementation.  Knowledge of the supported cipher suites is crucial for evaluating the strength and security of the communication channel.",
          "solution": "Configure the service to only support strong, modern cipher suites.  Disable or deprecate weak and vulnerable cipher suites to mitigate potential attacks exploiting known vulnerabilities in older or less secure algorithms.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Cipher Suites Supported",
          "protocol": "tcp",
          "port": 8443,
          "synopsis": "The remote service utilizes SSL/TLS for communication encryption.  This assessment identifies the supported cipher suites.",
          "description": "This evaluation determines the SSL/TLS cipher suites enabled on the remote service.  Understanding the supported cipher suites is crucial for assessing the cryptographic strength and vulnerability to known attacks targeting weak or outdated ciphers.",
          "solution": "Implement a robust cipher suite policy, enabling only strong, modern cipher suites and disabling vulnerable or deprecated options. Regularly review and update this policy to align with current best practices and address newly discovered vulnerabilities.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "port": 80,
          "synopsis": "Remote service identification confirmed.",
          "description": "Network scanning revealed a remote service on port 80.  This was determined through analysis of the service's response to a standard network probe, specifically examining the response banner or error messages generated in response to an HTTP request.  The absence of a specific error message doesn't necessarily indicate a lack of vulnerability; it simply signifies a successful identification of the running service.",
          "solution": "Implement robust network segmentation and intrusion detection systems to monitor for unauthorized access attempts.  Regularly review and update network security policies to ensure appropriate controls are in place for external-facing services.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "Remote service identification confirmed.",
          "description": "Network scanning revealed the presence of a remote service on port 443.  Service identification was achieved through analysis of the service banner or error messages returned in response to HTTP requests. This indicates that a service is listening on this well-known port for HTTPS communication, but does not inherently reveal vulnerabilities. Further investigation is required to determine the specific service and its security posture.",
          "solution": "Implement robust network segmentation and access control lists (ACLs) to limit exposure to unauthorized scanning. Regularly review and update network device configurations to ensure only necessary services are exposed to the network.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "Remote service identification confirmed.",
          "description": "Network scanning revealed the presence of a remote service on port 443.  Service identification was achieved through analysis of the service banner or error responses to HTTP requests. This indicates the service is actively listening and responding to network traffic.",
          "solution": "Further investigation is required to determine the specific service and its configuration.  Appropriate security measures should be implemented based on the identified service.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "port": 2053,
          "synopsis": "Remote service identification confirmed.",
          "description": "Network scanning revealed the presence of a remote service.  Service identification was achieved through analysis of the service banner or an error response received in response to a probe.  This indicates a service is listening on the specified port.",
          "solution": "Further investigation is required to determine the nature of the service and its security posture.  Appropriate access controls and security hardening measures should be implemented based on the identified service.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "port": 2053,
          "synopsis": "Remote service identification confirmed.",
          "description": "Network scanning techniques successfully identified a remote service.  This was achieved through analysis of the service's response to a network probe, specifically by examining the banner or error message returned in response to a network request.  The specific technique employed did not rely on vulnerabilities, but rather on the service's standard operational behavior of generating identifying information during communication.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "port": 2083,
          "synopsis": "Remote service identification confirmed.",
          "description": "Network scanning identified a remote service via analysis of its response to a network probe.  This was achieved by examining the service banner or analyzing error messages returned in response to a structured data request (e.g., HTTP request).  The specific mechanism used to identify the service is not detailed here.",
          "solution": "Implement appropriate network segmentation and access controls to restrict unauthorized network scanning and probing. Regularly review network traffic logs for suspicious activity.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "port": 2083,
          "synopsis": "Remote service identification confirmed.",
          "description": "Network scanning techniques successfully identified a remote service.  This was achieved through analysis of the service's response to a network probe, potentially including examination of banner information or error messages generated in response to an improperly formatted request (e.g., an HTTP request sent to a non-HTTP service).",
          "solution": "Further investigation is required to determine the nature and security posture of the identified service.  Appropriate mitigation strategies will depend on the identified service.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "port": 2086,
          "synopsis": "Remote service identification detected.",
          "description": "Network scanning revealed the presence of a remote service.  This was determined through analysis of the service's response to a network probe, specifically examining the banner or error messages returned. The nature of the probe indicates a potential vulnerability to service fingerprinting techniques.",
          "solution": "Implement network segmentation and restrict network access to only necessary ports and services.  Employ robust intrusion detection and prevention systems (IDS/IPS) to monitor for unauthorized service probing and exploitation attempts. Regularly review and update network security policies to mitigate service fingerprinting risks.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "Remote service identification confirmed.",
          "description": "Network scanning revealed the presence of a remote service on port 2087.  Service identification was achieved through analysis of the service banner or response to a probing request.  The nature of the probing request (e.g., HTTP) suggests potential vulnerabilities related to improper error handling or information leakage if the response contains sensitive data.",
          "solution": "Further investigation is required to determine the specific service and its associated security posture.  Review service configuration and associated security documentation for potential vulnerabilities. Consider implementing appropriate network segmentation and access controls.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "Remote service identification confirmed.",
          "description": "Network scanning revealed the presence of a remote service.  Service identification was achieved through analysis of the service banner or error messages returned in response to a network probe. The method used did not involve unauthorized access or exploitation.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "port": 8080,
          "synopsis": "Remote service identification confirmed.",
          "description": "Network scanning techniques identified a remote service listening on TCP port 8080.  Service identification was achieved through analysis of the service banner or error responses to standard network probes. This indicates the presence of a network service, but does not inherently indicate a vulnerability.",
          "solution": "Regular network audits to maintain an inventory of active network services are recommended.  Further investigation is required to determine the nature and security posture of the identified service.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "port": 8443,
          "synopsis": "Remote service identification confirmed.",
          "description": "Network scanning revealed the presence of a remote service on port 8443.  Service identification was achieved through analysis of the service banner or error messages returned in response to a standard network probe. This indicates a service is listening on this port, but provides no further information on its specific identity or configuration.",
          "solution": "Further investigation is required to identify the specific service running on port 8443 and assess its security posture.  This may involve reviewing network traffic logs, system configurations, and application documentation.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "port": 8443,
          "synopsis": "Remote service identification confirmed.",
          "description": "Network scanning identified a service on port 8443.  Service identification was achieved through analysis of the service banner or an error response to a standard HTTP request. This indicates a service is listening, but provides no information about its configuration or security posture.",
          "solution": "Further investigation is required to determine the specific service and its security configuration.  Appropriate security measures should be implemented based on the identified service.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HyperText Transfer Protocol (HTTP) Information",
          "protocol": "tcp",
          "port": 80,
          "synopsis": "Passive reconnaissance of the remote HTTP service can reveal configuration details.",
          "description": "This test passively probes the remote HTTP service to gather information about its configuration.  This includes identifying the HTTP version in use and determining whether HTTP Keep-Alive is enabled.  The gathered information can be used for network mapping and understanding the target system's capabilities. This test does not directly indicate a security vulnerability but provides context for further analysis.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HyperText Transfer Protocol (HTTP) Information",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "Passive reconnaissance of the remote HTTP server reveals configuration details.",
          "description": "This test passively probes the remote HTTP server to identify details of its configuration, including the HTTP version supported and the presence of HTTP Keep-Alive functionality.  This passive information gathering does not inherently indicate a security vulnerability but provides context for further security assessment.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HyperText Transfer Protocol (HTTP) Information",
          "protocol": "tcp",
          "port": 2086,
          "synopsis": "Passive reconnaissance of the remote HTTP server reveals information about its configuration.",
          "description": "This test passively probes the remote HTTP service to gather information about its configuration.  Specifically, it identifies the HTTP version in use and detects the presence or absence of HTTP Keep-Alive functionality. This information can assist in understanding the server's capabilities and potential vulnerabilities.\n\nThis test is purely informational and does not inherently indicate a security vulnerability.  However, the collected information can be used as part of a broader security assessment.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HyperText Transfer Protocol (HTTP) Information",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "Passive reconnaissance can reveal details about the remote HTTP server configuration.",
          "description": "This test passively assesses the remote HTTP server, identifying characteristics such as the HTTP version in use and the presence of HTTP Keep-Alive functionality.  This information aids in characterizing the server's capabilities and potential attack surface.\n\nPassive assessment of this nature does not inherently indicate a security vulnerability.  However, understanding the server's configuration is crucial for a comprehensive security posture assessment.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HyperText Transfer Protocol (HTTP) Information",
          "protocol": "tcp",
          "port": 8080,
          "synopsis": "Passive reconnaissance of the remote HTTP server reveals configuration details.",
          "description": "This test passively probes the remote HTTP service to identify characteristics of its configuration, such as the HTTP version supported and the presence of HTTP Keep-Alive functionality.  This information assists in understanding the server's capabilities and potential vulnerabilities.  The absence of specific vulnerabilities is implied by this test; however, this does not preclude the existence of other security exposures.  Further investigation is recommended to thoroughly assess the security posture of the server.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TCP/IP Timestamps Supported",
          "protocol": "tcp",
          "port": 0,
          "synopsis": "Detection of TCP timestamp option enabled on a remote host.",
          "description": "The remote host supports the TCP timestamp option as specified in RFC 1323.  This feature allows for the potential inference of the remote host's uptime by analyzing timestamp values exchanged during TCP three-way handshakes.  The precision of this uptime estimation depends on various factors, including network conditions and the remote system's configuration.",
          "solution": "Disabling TCP timestamps may mitigate the risk of uptime inference, however this is often not a feasible or advisable option as it can impact network performance and compatibility with some applications and systems.  Careful consideration of the potential risks associated with this vulnerability should be made in accordance with organizational security policies. ",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Expiry - Future Expiry",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The SSL/TLS certificate used for secure communication on port 443 is nearing its expiration date.  This poses a risk of service interruption and potential security vulnerabilities.",
          "description": "An impending SSL/TLS certificate expiration event on port 443 will result in the termination of secure connections.  Failure to renew the certificate will lead to communication failures and potential exposure to man-in-the-middle attacks, compromising confidentiality and integrity of data in transit.",
          "solution": "Implement a proactive certificate renewal process. This involves generating a Certificate Signing Request (CSR), obtaining a new certificate from a trusted Certificate Authority (CA), and configuring the server to use the new certificate before the current one expires.  Consider automating this process to prevent future expirations.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Expiry - Future Expiry",
          "protocol": "tcp",
          "port": 2053,
          "synopsis": "The SSL/TLS certificate used by the remote service is nearing its expiration date.",
          "description": "An impending expiry of the SSL/TLS certificate used for secure communication with the remote service on port 2053 poses a risk of service disruption and potential compromise of data integrity and confidentiality.  This requires immediate attention to prevent service outages and maintain secure communication channels.",
          "solution": "Renew the SSL/TLS certificate well in advance of its expiration date.  Implement automated certificate renewal processes to prevent future occurrences.  Ensure the certificate is issued by a trusted Certificate Authority (CA).",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Expiry - Future Expiry",
          "protocol": "tcp",
          "port": 2083,
          "synopsis": "Impending expiry of the SSL/TLS certificate used by the remote service presents a security risk.",
          "description": "The SSL/TLS certificate securing communication on port 2083 with the remote service is nearing its expiration date.  This poses a risk of interrupted service and potential compromise of sensitive data transmitted without proper encryption if not renewed.",
          "solution": "Implement a proactive certificate renewal process.  Generate a new SSL/TLS certificate with sufficient validity period before the current certificate expires.  Ensure proper chain of trust is maintained and the new certificate is correctly deployed and configured on the server.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Expiry - Future Expiry",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "The SSL/TLS certificate used for secure communication on the remote service is nearing its expiration date.",
          "description": "The SSL/TLS certificate securing communication on port 2087 will expire in the near future.  This poses a risk of interruption to secure network services and potential vulnerabilities if not renewed promptly.  The exact time until expiration is unknown, but immediate action is recommended.",
          "solution": "Implement a process for timely renewal of SSL/TLS certificates. Generate and deploy a new certificate before the current one expires.  Ensure proper certificate chain validation is configured throughout the system.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Expiry - Future Expiry",
          "protocol": "tcp",
          "port": 8443,
          "synopsis": "The SSL/TLS certificate used for secure communication on port 8443 is nearing its expiration date.",
          "description": "The SSL/TLS certificate securing the service accessible via TCP port 8443 will expire in the near future.  This will result in communication failures and potential service disruption unless a valid replacement certificate is installed before the expiration date.  The exact timeframe until expiration is not specified.",
          "solution": "Implement a proactive certificate lifecycle management process.  Generate a new SSL/TLS certificate with appropriate parameters (key size, algorithm, validity period) and install it on the server well in advance of the current certificate's expiration.  Verify the proper functioning of the service after the certificate replacement.  Consider using automated certificate renewal methods to avoid future occurrences.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Common Platform Enumeration (CPE)",
          "protocol": "tcp",
          "port": 0,
          "synopsis": "Remote system enumeration revealed potential matches against known Common Platform Enumeration (CPE) names.",
          "description": "This assessment identifies potential matches between detected hardware and software components on a remote host and entries within the Common Platform Enumeration (CPE) database.  The process leverages information gathered during a system scan.  It's important to note that a precise CPE match may not always be available, and in such cases, the assessment will attempt to generate the most likely CPE based on the available scan data. This relies on inherent limitations in identifying products from network-based scans.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Device Type",
          "protocol": "tcp",
          "port": 0,
          "synopsis": "Remote device type inference is possible.",
          "description": "Network communication analysis can reveal information about the remote system's operating system and, consequently, its general purpose (e.g., printer, router, general-purpose computer).  This inference is based on observed network behaviors and protocol characteristics.",
          "solution": "Network segmentation and restricting network access based on functional roles can mitigate the risk of inferring device type. Implementing strong access control mechanisms can further limit the amount of information exposed.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL / TLS Versions Supported",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "Assessment of the SSL/TLS versions supported by the remote service for secure communication.",
          "description": "This assessment determines the SSL and TLS versions supported by the remote service for encrypting network communications.  Knowing the supported cipher suites is crucial for evaluating the strength of the encryption employed.",
          "solution": "Implement a consistent and up-to-date security policy defining the acceptable SSL/TLS versions and cipher suites. Regularly review and update this policy to address newly discovered vulnerabilities.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL / TLS Versions Supported",
          "protocol": "tcp",
          "port": 2053,
          "synopsis": "Assessment of the cryptographic protocols supported by the remote service.",
          "description": "This assessment determines the SSL and TLS versions supported by the remote service for secure communication.  This information is crucial for evaluating the strength and security posture of the encryption employed.",
          "solution": "Configure the service to support only strong, modern cipher suites and TLS versions. Disable support for outdated and insecure protocols.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL / TLS Versions Supported",
          "protocol": "tcp",
          "port": 2083,
          "synopsis": "Assessment of the SSL/TLS protocols supported by the remote service for secure communication.",
          "description": "This assessment determines the SSL and TLS versions supported by the remote service for encrypting communication channels.  Understanding the supported cipher suites is crucial for evaluating the security posture of the service.",
          "solution": "Implement a security policy defining acceptable SSL/TLS versions and cipher suites.  Regularly review and update this policy to align with industry best practices and address newly discovered vulnerabilities.  Ensure only strong and currently supported cryptographic algorithms are used.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL / TLS Versions Supported",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "Assessment of the SSL/TLS versions supported by the remote service for secure communication.",
          "description": "This assessment determines the SSL and TLS versions supported by the remote service.  Knowing the supported cipher suites is crucial for evaluating the security posture of the service.  Older or insecure cipher suites may expose the communication channel to vulnerabilities.",
          "solution": "Implement a consistent and secure cipher suite policy, ensuring only strong and up-to-date SSL/TLS protocols are enabled.  Regularly review and update this policy to address emerging threats and vulnerabilities.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL / TLS Versions Supported",
          "protocol": "tcp",
          "port": 8443,
          "synopsis": "Assessment of the SSL/TLS versions supported by the remote service for secure communication.",
          "description": "This check identifies the SSL and TLS protocol versions supported by the remote service.  Knowing the supported cipher suites is crucial for evaluating the strength of the encryption used to protect communication channels.  The absence of support for strong, modern protocols indicates potential vulnerabilities to known attacks.",
          "solution": "Implement a policy defining the minimum acceptable SSL/TLS protocol versions.  Configure the service to only support strong, up-to-date cipher suites.  Regularly review and update this policy to reflect the latest security best practices and address emerging vulnerabilities. Consider using a robust cipher suite selection mechanism that prioritizes strong, modern algorithms.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Perfect Forward Secrecy Cipher Suites Supported",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service advertises support for SSL/TLS cipher suites offering Perfect Forward Secrecy (PFS).  This mitigates the risk of retroactive decryption of past communication sessions even if the server's long-term private key is compromised.",
          "description": "The remote host indicates support for Transport Layer Security (TLS) cipher suites that employ Perfect Forward Secrecy (PFS) mechanisms.  PFS ensures that the compromise of the server's private key at a future date will not compromise the confidentiality of previously established sessions.  Ephemeral keys generated for each session provide this forward secrecy.  However, the specific PFS cipher suites utilized and their strength remain unknown without further analysis.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Perfect Forward Secrecy Cipher Suites Supported",
          "protocol": "tcp",
          "port": 2053,
          "synopsis": "The remote service advertises support for SSL/TLS cipher suites offering Perfect Forward Secrecy (PFS).  This mitigates the risk of decryption of past communications even if long-term server keys are compromised.",
          "description": "The remote host indicates support for Transport Layer Security (TLS) cipher suites that employ Perfect Forward Secrecy (PFS) mechanisms.  PFS ensures that session keys are ephemeral, meaning they are generated uniquely for each connection and are not derived from the server's long-term private key.  This protects the confidentiality of past communications, even in the event of future compromise of the server's private key.  The specific cipher suites supporting PFS are not explicitly identified in this assessment.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Perfect Forward Secrecy Cipher Suites Supported",
          "protocol": "tcp",
          "port": 2083,
          "synopsis": "The remote service advertises support for SSL/TLS cipher suites offering Perfect Forward Secrecy (PFS). This mitigates the risk of retroactive decryption of past communication sessions.",
          "description": "The remote host indicates support for SSL/TLS cipher suites that implement Perfect Forward Secrecy (PFS).  PFS ensures that compromise of the server's long-term private key does not compromise the confidentiality of past TLS sessions established using ephemeral key exchange.  This is a crucial security property for protecting against future decryption of recorded traffic, even if the server's private key is later obtained by an attacker.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Perfect Forward Secrecy Cipher Suites Supported",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "The remote service utilizes SSL cipher suites that offer Perfect Forward Secrecy (PFS).  This cryptographic feature ensures that the confidentiality of past communication sessions remains protected even if the server's long-term private key is compromised.",
          "description": "The remote host's SSL/TLS implementation supports cipher suites with Perfect Forward Secrecy (PFS).  PFS employs ephemeral key exchange, generating unique session keys for each connection.  This mitigates risks associated with long-term key compromise, preventing decryption of past communication even if the server's private key is obtained through an attack or other means.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Perfect Forward Secrecy Cipher Suites Supported",
          "protocol": "tcp",
          "port": 8443,
          "synopsis": "The remote service advertises support for SSL/TLS cipher suites offering Perfect Forward Secrecy (PFS).  This mitigates the risk of past session decryption if the server's long-term private key is compromised.",
          "description": "The remote host indicates support for TLS cipher suites with Perfect Forward Secrecy (PFS). PFS ensures that the confidentiality of past communication sessions is not retroactively compromised even if the server's long-term private key is subsequently compromised.  This is achieved through the ephemeral key exchange during the TLS handshake.",
          "solution": "Maintain up-to-date cryptographic libraries and configurations to ensure support for strong, modern cipher suites with PFS. Regularly review and update the cipher suite preference order to prioritize those offering the highest level of security and compatibility.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Next Protocols Supported",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service advertises one or more TLS-encapsulated protocols.",
          "description": "This assessment identifies the protocols advertised by the remote service for use within TLS connections.\n\nIt is crucial to understand that this assessment did not attempt to establish TLS connections to verify the advertised protocols.  The remote service might inaccurately advertise protocols, or it may fail to advertise all supported protocols.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Next Protocols Supported",
          "protocol": "tcp",
          "port": 2053,
          "synopsis": "The remote service advertises one or more protocols as being supported over TLS.",
          "description": "This assessment identifies the TLS Next Protocol(s) advertised by the remote service.  This advertisement indicates which protocols the service claims to support for TLS encapsulation.  It is crucial to understand that this assessment did not actively negotiate TLS sessions with the advertised protocols. Therefore, the advertised protocols might be inaccurate, or the service may fail to advertise all of its supported protocols.  Further investigation is required to confirm actual TLS protocol support.",
          "solution": "Verify the advertised protocols against the service's expected behavior and configuration. Conduct thorough testing to confirm the functionality of each advertised protocol and identify any missing protocols.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Next Protocols Supported",
          "protocol": "tcp",
          "port": 2083,
          "synopsis": "The remote service advertises one or more TLS-encapsulated protocols.",
          "description": "This assessment identifies the protocols advertised by the remote service for use within TLS connections.  It is crucial to understand that this assessment does not verify the functionality or successful negotiation of these advertised protocols.  The service might inaccurately advertise protocols or omit others it actually supports.  Further testing is needed to confirm the actual capabilities.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Next Protocols Supported",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "The remote service advertises one or more protocols for TLS encapsulation.",
          "description": "This assessment identifies protocols advertised by the remote service for use within TLS connections.\n\nIt's crucial to understand that this assessment does not actively attempt to establish TLS sessions using these advertised protocols.  Therefore, the advertised protocols may be inaccurate, incomplete, or the service might fail to advertise other supported protocols.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Next Protocols Supported",
          "protocol": "tcp",
          "port": 8443,
          "synopsis": "The remote service advertises supported protocols for TLS encapsulation.",
          "description": "This assessment identifies protocols advertised by the remote service for use within TLS connections.\n\nIt is important to note that this assessment did not attempt to establish TLS sessions using these protocols.  Therefore, the advertised protocols may be inaccurate, or the service may support additional protocols not listed.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Cipher Block Chaining Cipher Suites Supported",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service utilizes SSL cipher suites employing Cipher Block Chaining (CBC) mode for encryption.",
          "description": "The remote host supports SSL/TLS cipher suites that implement the Cipher Block Chaining (CBC) mode of operation. While CBC offers improved security compared to Electronic Codebook (ECB) mode by chaining ciphertext blocks, it remains susceptible to vulnerabilities like padding oracle attacks if not properly implemented and protected against known weaknesses.  The use of CBC necessitates robust cryptographic practices and mitigation strategies to prevent information leakage.",
          "solution": "Implement strong cryptographic practices, including the use of authenticated encryption modes (e.g., GCM, CCM) where possible, and ensure all systems are up-to-date with the latest security patches addressing known CBC-related vulnerabilities. Regularly review and update cipher suite preferences to prioritize modern, secure algorithms.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Cipher Block Chaining Cipher Suites Supported",
          "protocol": "tcp",
          "port": 2053,
          "synopsis": "The remote service utilizes SSL cipher suites employing Cipher Block Chaining (CBC) mode for encryption.",
          "description": "The server supports SSL/TLS cipher suites that utilize the Cipher Block Chaining (CBC) mode of operation. While CBC offers enhanced security compared to Electronic Codebook (ECB) mode, it is susceptible to cryptographic vulnerabilities, particularly padding oracle attacks, if not implemented and used correctly.  Improper implementation or use can lead to data leakage or decryption.",
          "solution": "Implement robust cryptographic practices.  Prioritize the use of modern authenticated encryption ciphers (e.g., AES-GCM, ChaCha20-Poly1305) that mitigate the vulnerabilities inherent in CBC mode.  Regularly review and update cryptographic libraries and protocols to address known vulnerabilities.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Cipher Block Chaining Cipher Suites Supported",
          "protocol": "tcp",
          "port": 2083,
          "synopsis": "The remote service supports SSL cipher suites employing Cipher Block Chaining (CBC) mode.  CBC combines the encryption of each block with the previous block's ciphertext.",
          "description": "The server utilizes SSL cipher suites operating in CBC mode. While CBC offers enhanced security compared to Electronic Codebook (ECB) mode, it remains susceptible to cryptographic attacks, particularly padding oracle attacks, if not properly implemented and used with robust padding schemes.  Improper handling can lead to data leakage or decryption.",
          "solution": "Implement strong cryptographic practices, including the use of authenticated encryption modes (e.g., GCM, CCM) which provide both confidentiality and authenticity, eliminating the vulnerabilities inherent in CBC.  Prioritize the use of modern, robust cipher suites recommended by industry best practices and regularly update your cryptographic libraries.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Cipher Block Chaining Cipher Suites Supported",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "The remote service utilizes SSL cipher suites employing Cipher Block Chaining (CBC) mode.  This chaining mechanism links encryption of each data block to the previous one.",
          "description": "The server supports SSL/TLS cipher suites operating in CBC mode. While CBC offers enhanced security compared to Electronic Codebook (ECB) mode by mitigating simple substitution attacks, it remains susceptible to vulnerabilities like padding oracle attacks and information leakage if not implemented and used correctly with proper padding schemes and secure configurations.  The inherent nature of CBC, where the encryption of a block depends on the previous one, creates a potential vulnerability if an attacker can manipulate or predict previous ciphertext blocks.",
          "solution": "Implement robust countermeasures to mitigate CBC-related vulnerabilities.  Prioritize the use of authenticated encryption modes (e.g., GCM, CCM) that inherently provide authentication and integrity alongside confidentiality.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Cipher Block Chaining Cipher Suites Supported",
          "protocol": "tcp",
          "port": 8443,
          "synopsis": "The remote service supports SSL cipher suites employing Cipher Block Chaining (CBC) mode.  CBC combines the encryption of each block with the previous block's ciphertext.",
          "description": "The remote host utilizes SSL cipher suites operating in CBC mode. While offering enhanced security compared to Electronic Codebook (ECB) mode, CBC is susceptible to padding oracle attacks and other vulnerabilities if not implemented and used correctly.  Improper implementation or use can lead to data leakage or other security compromises.",
          "solution": "Implement and utilize strong cipher suites that avoid CBC mode, where feasible.  Prioritize authenticated encryption with associated data (AEAD) ciphers which provide both confidentiality and authenticity.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Chain Contains Certificates Expiring Soon",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "One or more certificates within the remote host's SSL certificate chain are nearing expiration.",
          "description": "The SSL certificate chain presented by the remote host contains one or more certificates that will expire soon.  This poses a risk of service disruption due to client-side validation failures.  Clients may reject connections due to expired trust anchors or intermediate certificates leading to application unavailability.",
          "solution": "Implement a proactive certificate renewal process.  This should include automated monitoring of certificate expiration dates and scheduled renewal procedures well in advance of the expiration date to avoid service interruption.  Consider using a centralized certificate management system.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Chain Contains Certificates Expiring Soon",
          "protocol": "tcp",
          "port": 2053,
          "synopsis": "One or more certificates within the remote host's SSL certificate chain are nearing expiration.",
          "description": "The SSL certificate chain presented by the remote host contains one or more certificates approaching their expiration date.  This poses a significant risk of service interruption for clients relying on the SSL/TLS connection for secure communication.  The inability to establish a secure connection due to expired certificates will result in a denial of service for legitimate users.",
          "solution": "Implement a robust certificate lifecycle management process.  This includes setting up automated alerts for certificate expiration, establishing a schedule for renewal well in advance of the expiration dates, and performing thorough testing of the renewed certificates before deployment.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Chain Contains Certificates Expiring Soon",
          "protocol": "tcp",
          "port": 2083,
          "synopsis": "One or more certificates within the remote host's SSL certificate chain are nearing expiration.",
          "description": "The SSL certificate chain presented by the remote host contains one or more certificates with imminent expiration dates.  Failure to renew these certificates before expiration will result in the termination of secure communication and potential service disruption for clients.",
          "solution": "Implement a proactive certificate lifecycle management process.  Renew all certificates nearing expiration well in advance of their expiration date.  Establish automated renewal mechanisms where feasible.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Chain Contains Certificates Expiring Soon",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "One or more certificates within the remote host's SSL certificate chain are nearing expiration.",
          "description": "The SSL certificate chain presented by the remote host contains one or more certificates with impending expiration dates.  Failure to renew these certificates before expiration will result in a disruption of service, leading to potential unavailability of the service for clients.",
          "solution": "Implement a proactive certificate lifecycle management process.  Renew all SSL/TLS certificates well in advance of their expiration dates, adhering to best practices for key rotation and secure certificate storage.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Chain Contains Certificates Expiring Soon",
          "protocol": "tcp",
          "port": 8443,
          "synopsis": "One or more certificates within the remote host's SSL certificate chain are nearing expiration.",
          "description": "The remote server presents an SSL certificate chain containing one or more certificates that will expire soon.  This impending expiration poses a significant risk of service disruption for clients unable to establish secure connections due to certificate validation failures.  The impact will depend on the certificate's role in the chain and the reliance of the connected systems.",
          "solution": "Implement a proactive certificate lifecycle management strategy.  This includes establishing automated renewal processes and monitoring certificate expiration dates well in advance to prevent service interruptions.  The specific renewal method will depend on the Certificate Authority (CA) and the type of certificate.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HSTS Missing From HTTPS Server",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote web server lacks HTTP Strict Transport Security (HSTS) enforcement.",
          "description": "The remote HTTPS server does not implement HTTP Strict Transport Security (HSTS).  HSTS is a security mechanism where the server sends an HTTP header instructing the client browser to exclusively communicate using HTTPS for a specified period.  The absence of HSTS renders the connection vulnerable to downgrade attacks, where an attacker might force the browser to use insecure HTTP, enabling subsequent interception of sensitive data.  Furthermore, it weakens protection against SSL stripping, a man-in-the-middle attack technique that redirects HTTPS traffic to HTTP, and reduces the effectiveness of defenses against cookie hijacking.",
          "solution": "Implement HSTS on the remote web server by configuring the appropriate HTTP response header. This involves setting the `Strict-Transport-Security` header with appropriate parameters, such as `max-age` to define the duration for which the browser should enforce HSTS and optionally `includeSubDomains` and `preload` directives for broader protection.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HSTS Missing From HTTPS Server",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "The remote web server lacks HTTP Strict Transport Security (HSTS) enforcement.",
          "description": "The remote HTTPS server does not implement HTTP Strict Transport Security (HSTS).  HSTS is a security mechanism where the server sends an HTTP header instructing the client to exclusively use HTTPS for all future connections to that host.  The absence of HSTS allows for potential downgrade attacks, where a connection is downgraded to HTTP, making it vulnerable to man-in-the-middle attacks and exposing sensitive data transmitted over insecure channels.  Furthermore, the lack of HSTS weakens the protection offered against cookie hijacking, increasing the risk of session compromise.",
          "solution": "Implement and configure the HSTS header on the remote web server. This involves adding the `Strict-Transport-Security` header to all HTTPS responses.  Consider including parameters such as `max-age` to define the duration for which the browser enforces HSTS and `includeSubDomains` to extend the policy to subdomains.  Proper configuration is critical to mitigate the risks described above.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS ALPN Supported Protocol Enumeration",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "Detection of TLS Application-Layer Protocol Negotiation (ALPN) support on the remote host.",
          "description": "This assessment identifies the presence of the TLS ALPN extension on the remote host.  ALPN allows a client and server to negotiate a specific application protocol (e.g., HTTP/2, HTTP/1.1) during the TLS handshake, enhancing performance and security by avoiding unnecessary protocol switching. The enumeration process determines which protocols the server advertises as supported via ALPN.",
          "solution": "Review the supported ALPN protocols advertised by the server. Ensure that only necessary and secure protocols are enabled.  Configuration of supported ALPN protocols depends on the server software in use and its configuration options.  Consult the server's documentation for specific instructions.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS ALPN Supported Protocol Enumeration",
          "protocol": "tcp",
          "port": 2053,
          "synopsis": "Detection of TLS Application-Layer Protocol Negotiation (ALPN) extension support on the remote host.",
          "description": "The remote host presents a TLS server that supports the ALPN extension.  This indicates the server is capable of negotiating the application protocol (e.g., HTTP/2, HTTP/1.1) during the TLS handshake.  This capability itself is not inherently a vulnerability, but it can be a factor in broader security assessments. Enumeration of the supported protocols provides insight into the services offered by the server.",
          "solution": "No direct remediation needed if ALPN support is expected and properly configured.  Review server configuration to ensure only necessary protocols are advertised to mitigate potential protocol-specific vulnerabilities.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS ALPN Supported Protocol Enumeration",
          "protocol": "tcp",
          "port": 2083,
          "synopsis": "The remote host advertises support for the TLS Application-Layer Protocol Negotiation (ALPN) extension.",
          "description": "The remote host supports the TLS ALPN extension, indicating its capability to negotiate supported application protocols during the TLS handshake.  This allows for secure selection of protocols like HTTP/2 or HTTP/1.1.  The enumeration of supported protocols provides information about the server's capabilities and potential configuration choices.",
          "solution": "Review and configure the server's TLS settings to ensure only necessary and supported Application Layer Protocols (ALPN) are advertised.  This helps to minimize potential attack surface and improve security posture by reducing the exposure of less secure or deprecated protocols.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS ALPN Supported Protocol Enumeration",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "Detection of TLS Application-Layer Protocol Negotiation (ALPN) support on the remote host.",
          "description": "The remote host supports the TLS ALPN extension.  ALPN allows a client and server to negotiate a specific application protocol (e.g., HTTP/2, HTTP/1.1) during the TLS handshake, improving performance and security by avoiding unnecessary protocol switching.  This assessment identifies the protocols supported by the remote host's ALPN implementation.",
          "solution": "Implement appropriate TLS configuration to support only necessary application protocols and regularly review the supported protocols to ensure they align with security policies and best practices.  Consider disabling support for obsolete or insecure protocols.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS ALPN Supported Protocol Enumeration",
          "protocol": "tcp",
          "port": 8443,
          "synopsis": "The remote host supports the TLS Application-Layer Protocol Negotiation (ALPN) extension, indicating a capability for negotiating the application protocol during the TLS handshake.",
          "description": "The remote host's support for the TLS ALPN extension allows for the negotiation of application protocols (e.g., HTTP/1.1, HTTP/2, h2c) prior to the completion of the TLS handshake. This enhances security and performance by allowing clients and servers to select the most appropriate protocol.  Enumeration of the supported protocols reveals the capabilities of the server.  This information assists in identifying potential misconfigurations or vulnerabilities that may arise from the deployment of insecure protocols, but by itself does not indicate a vulnerability.",
          "solution": "Regularly review and update the server's TLS configuration to ensure only supported and secure protocols are enabled. Consider disabling or deprecating protocols that are known to be insecure or obsolete. Implement proper access control mechanisms to restrict access to the service.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Root Certification Authority Certificate Information",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "A self-signed root Certificate Authority (CA) certificate was identified at the root of the presented certificate chain during SSL/TLS handshake.",
          "description": "The remote service presents an SSL/TLS certificate chain where the root CA certificate is self-signed.  This indicates that the certificate authority is not publicly trusted and has not undergone validation by a trusted third-party Certificate Authority.",
          "solution": "Verify that the use of this self-signed root CA certificate aligns with established organizational security policies and risk acceptance criteria.  Consider the implications for trust and potential man-in-the-middle attack vectors.  Document the rationale for accepting this level of risk.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Root Certification Authority Certificate Information",
          "protocol": "tcp",
          "port": 2053,
          "synopsis": "A root Certification Authority (CA) certificate was identified as the trust anchor in the presented certificate chain.",
          "description": "The remote service presents an SSL certificate chain where a self-signed root CA certificate serves as the trust anchor. This indicates that the certificate authority is not publicly recognized and its trustworthiness is not established through a widely accepted public key infrastructure (PKI).",
          "solution": "Verify the legitimacy and trustworthiness of the self-signed root CA certificate.  This verification should include confirming its alignment with organizational security policies and procedures for managing internal certificate authorities.  Consider the implications of relying on an internal root CA for this service in terms of trust and potential security risks.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Root Certification Authority Certificate Information",
          "protocol": "tcp",
          "port": 2083,
          "synopsis": "A root Certificate Authority (CA) certificate was identified at the apex of the certificate chain presented by the remote service.",
          "description": "The remote service's SSL/TLS handshake revealed a certificate chain where a self-signed root CA certificate is the trust anchor.  This implies that the certificate authority is not publicly trusted and is likely managed internally.",
          "solution": "Verify that the use of this self-signed root CA certificate aligns with established organizational security policies and procedures.  Consider the implications for trust, potential man-in-the-middle attacks, and the overall security posture.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Root Certification Authority Certificate Information",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "A root Certification Authority (CA) certificate was identified as the trust anchor in the presented certificate chain.",
          "description": "The remote service presents an SSL certificate chain where a self-signed root CA certificate serves as the trust anchor.  This indicates that the certificate authority is not publicly trusted and was likely generated internally.",
          "solution": "Verify the legitimacy and trustworthiness of this self-signed root CA certificate.  Ensure its use aligns with organizational security policies, including considerations for certificate lifecycle management, revocation practices, and potential impact on client trust and compatibility.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Root Certification Authority Certificate Information",
          "protocol": "tcp",
          "port": 8443,
          "synopsis": "A root Certificate Authority (CA) certificate was identified as the trust anchor in the presented certificate chain.",
          "description": "The remote server's SSL/TLS certificate chain terminates with a self-signed root CA certificate.  This indicates that the certificate authority is not publicly trusted and is likely internally managed.",
          "solution": "Verify the identity and trustworthiness of the self-signed root CA certificate.  Ensure that its use aligns with your organization's established security policies, including procedures for managing internal PKI infrastructure and acceptable trust anchors.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Signed Using Weak Hashing Algorithm (Known CA)",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "An SSL certificate within the certificate chain, issued by a known Certificate Authority (CA), utilizes a cryptographically weak hashing algorithm.",
          "description": "The remote service's SSL certificate chain includes a certificate signed using a weak hashing algorithm (e.g., MD2, MD4, MD5, or SHA-1).  These algorithms are susceptible to collision attacks (such as those described in CVE-2004-2761), enabling an attacker to potentially forge a certificate with an identical digital signature. This allows the attacker to impersonate the service.  Certificates signed with SHA-1 that expire after January 1, 2017, are considered vulnerable due to the known weaknesses of the algorithm and its deprecation. This analysis focuses solely on root certificates issued by trusted CAs, as defined by a recognized list of trusted root certificates. The inherent trust placed in these CAs means that signature weaknesses, including those related to weak hashing algorithms, may not always represent immediate security risks.",
          "solution": "Request a reissuance of the certificate from the Certificate Authority.",
          "risk_factor": "None",
          "cve": "",
          "bid": "11849;33065",
          "xref": "CWE:310",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Signed Using Weak Hashing Algorithm (Known CA)",
          "protocol": "tcp",
          "port": 2053,
          "synopsis": "An SSL certificate within the certificate chain, issued by a trusted Certificate Authority (CA), utilizes a cryptographically weak hashing algorithm.",
          "description": "The remote service presents an SSL certificate chain containing a certificate signed using a weak hashing algorithm (e.g., MD2, MD4, MD5, or SHA-1).  These algorithms are susceptible to collision attacks (such as those described in CVE-2004-2761), enabling an attacker to potentially create a certificate with an identical digital signature.  This could allow an attacker to impersonate the service.  Certificates signed with SHA-1 that expire after January 1, 2017, are considered vulnerable due to the known weaknesses of the algorithm and industry deprecation.  This assessment is limited to root certificates issued by trusted CAs, as defined by a trusted source.  Certificates issued by untrusted sources are not included in this analysis.",
          "solution": "Request the Certificate Authority (CA) to reissue the certificate using a strong, currently approved hashing algorithm.",
          "risk_factor": "None",
          "cve": "",
          "bid": "11849;33065",
          "xref": "CWE:310",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Signed Using Weak Hashing Algorithm (Known CA)",
          "protocol": "tcp",
          "port": 2083,
          "synopsis": "An SSL certificate within a chain issued by a known Certificate Authority (CA) utilizes a cryptographically weak hashing algorithm for its signature.",
          "description": "The remote service presents an SSL certificate chain including a root certificate from a trusted CA that was signed using a weak hashing algorithm (e.g., MD2, MD4, MD5, or SHA-1).  These algorithms are susceptible to collision attacks (such as those described in CVE-2004-2761), enabling an attacker to potentially forge a certificate with an identical digital signature. This allows the attacker to impersonate the legitimate service. \n\nCertificates signed with SHA-1 and expiring after January 1, 2017, are considered vulnerable due to the known weaknesses of the algorithm and industry deprecation timelines.  \n\nThis specifically refers to root certificates issued by CAs included in a trusted list.  This differs from scenarios involving certificates outside of this trusted root list, where the risks may be significantly higher.",
          "solution": "Engage with the issuing Certificate Authority to request a re-issuance of the certificate using a strong, currently approved hashing algorithm.",
          "risk_factor": "None",
          "cve": "",
          "bid": "11849;33065",
          "xref": "CWE:310",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Signed Using Weak Hashing Algorithm (Known CA)",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "An SSL certificate in the chain, issued by a trusted Certificate Authority (CA), utilizes a cryptographically weak hashing algorithm.",
          "description": "The remote service presents an SSL certificate chain containing a certificate signed using a weak hashing algorithm (e.g., MD2, MD4, MD5, or SHA-1).  These algorithms are susceptible to collision attacks (such as those described in CVE-2004-2761), enabling an attacker to potentially forge a certificate with an identical digital signature. This allows the attacker to impersonate the service.  Certificates signed with SHA-1 expiring after January 1, 2017, are considered vulnerable due to their susceptibility to collision attacks and alignment with industry-wide deprecation timelines. This assessment focuses solely on root certificates issued by trusted CAs, differentiating it from assessments encompassing all certificates.  The inherent trust placed in known CA root certificates mitigates the security implications of signature weaknesses in this specific context.",
          "solution": "Engage the Certificate Authority to initiate a certificate re-issuance using a cryptographically strong hashing algorithm.",
          "risk_factor": "None",
          "cve": "",
          "bid": "11849;33065",
          "xref": "CWE:310",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Signed Using Weak Hashing Algorithm (Known CA)",
          "protocol": "tcp",
          "port": 8443,
          "synopsis": "An SSL certificate within a certificate chain issued by a known Certificate Authority (CA) utilizes a cryptographically weak hashing algorithm.",
          "description": "The remote service presents an SSL certificate chain where the root certificate, issued by a trusted CA, employs a weak hashing algorithm (e.g., MD2, MD4, MD5, or SHA1).  These algorithms are susceptible to collision attacks (such as those described in CVE-2004-2761), enabling a malicious actor to potentially create a certificate with a matching signature, thereby impersonating the legitimate service.  Certificates signed with SHA-1 expiring after January 1, 2017, are considered vulnerable due to the algorithm's known weaknesses and industry deprecation.\n\nThis specifically refers to root certificates from known CAs, distinguishing it from vulnerabilities affecting certificates from untrusted sources. The inherent trust placed in these known CA root certificates means that signature algorithm weaknesses, while technically present, do not automatically represent a direct security risk to the relying party.",
          "solution": "Engage with the Certificate Authority to request reissuance of the certificate using a cryptographically secure hashing algorithm (e.g., SHA-256 or SHA-384).",
          "risk_factor": "None",
          "cve": "",
          "bid": "11849;33065",
          "xref": "CWE:310",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.0 Protocol Detection",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service utilizes an outdated and cryptographically weak TLS version (1.0) for encrypting network traffic.",
          "description": "The remote service is accepting connections secured with TLS 1.0. This protocol exhibits several known cryptographic vulnerabilities. While modern implementations include mitigations, the inherent design flaws of TLS 1.0 are addressed in later versions (TLS 1.2 and 1.3).  Utilizing TLS 1.2 or 1.3 significantly enhances security.  Industry standards and best practices strongly advocate for the deprecation of TLS 1.0.  Major web browsers and vendors ceased support for TLS 1.0 in March 2020, rendering connections insecure and potentially unusable.  Furthermore, regulatory compliance mandates (such as PCI DSS v3.2) require disabling TLS 1.0, with limited exceptions for legacy POS systems verifiable as free from known exploits. This was mandated by June 30, 2018.",
          "solution": "Immediately upgrade to support TLS 1.2 and 1.3.  Completely disable TLS 1.0 support to eliminate vulnerabilities and ensure compliance with security standards and best practices.",
          "risk_factor": "Medium",
          "cve": "",
          "bid": "",
          "xref": "CWE:327",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.0 Protocol Detection",
          "protocol": "tcp",
          "port": 2053,
          "synopsis": "The remote service utilizes an outdated and cryptographically vulnerable TLS version (1.0) for encrypting network traffic.",
          "description": "The service accepts connections secured using TLS 1.0.  This version suffers from several well-documented cryptographic weaknesses. While modern implementations may mitigate some risks, the inherent vulnerabilities are addressed in TLS versions 1.2 and 1.3.  Upgrading to a more modern TLS version is strongly recommended to enhance the security posture.  The deprecation of TLS 1.0 has been widely announced by major web browsers and industry vendors, impacting interoperability.  PCI DSS v3.2 mandates the complete disabling of TLS 1.0 by June 30, 2018, with limited exceptions for POS POI terminals and their associated SSL/TLS termination points demonstrably immune to known exploits.",
          "solution": "Implement support for TLS 1.2 and 1.3, and subsequently disable support for the insecure TLS 1.0 protocol.  This upgrade should be performed across all relevant network services and endpoints.",
          "risk_factor": "Medium",
          "cve": "",
          "bid": "",
          "xref": "CWE:327",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.0 Protocol Detection",
          "protocol": "tcp",
          "port": 2083,
          "synopsis": "The remote service utilizes an outdated and cryptographically weak TLS version.",
          "description": "The observed service accepts connections secured using TLS 1.0.  TLS 1.0 suffers from several significant cryptographic vulnerabilities. While modern implementations may mitigate some risks, newer TLS versions (1.2 and 1.3) address these flaws inherently and offer substantially improved security.  The deprecation of TLS 1.0 is widespread, impacting interoperability with modern systems and browsers.  Industry standards, such as PCI DSS v3.2, mandated the complete disabling of TLS 1.0 by June 30, 2018, with limited exceptions for specifically vetted Point-of-Sale (POS) systems.",
          "solution": "Implement support for TLS 1.2 and 1.3, and immediately disable support for the insecure TLS 1.0 protocol.  This requires updating server-side cryptographic libraries and configuration to prioritize the use of modern TLS versions.",
          "risk_factor": "Medium",
          "cve": "",
          "bid": "",
          "xref": "CWE:327",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.0 Protocol Detection",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "The remote service utilizes an outdated and cryptographically weak TLS version (1.0) for encryption.",
          "description": "The observed service supports TLS 1.0, a protocol with known cryptographic vulnerabilities.  While modern implementations include mitigations, these are insufficient compared to the enhanced security offered by TLS 1.2 and 1.3.  These newer versions address fundamental design flaws inherent in TLS 1.0. Continued reliance on TLS 1.0 presents a significant risk, especially given that major web browsers and vendors have ceased supporting it (effectively since March 31, 2020).  Furthermore, compliance standards such as PCI DSS v3.2 mandate the complete disabling of TLS 1.0 (except for specific, verified exceptions involving POS POI terminals and associated termination points) since June 30, 2018.  The use of TLS 1.0 exposes the system to potential exploits and compromises its overall security posture.",
          "solution": "Immediately disable support for TLS 1.0.  Implement and enable support for TLS 1.2 and TLS 1.3, ensuring that these newer protocols are prioritized for all connections.",
          "risk_factor": "Medium",
          "cve": "",
          "bid": "",
          "xref": "CWE:327",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.0 Protocol Detection",
          "protocol": "tcp",
          "port": 8443,
          "synopsis": "The remote service utilizes an outdated and cryptographically weak TLS version for encryption.",
          "description": "The remote service supports TLS 1.0, a protocol exhibiting several known cryptographic weaknesses. While modern implementations incorporate mitigations, these are insufficient compared to the improved security designs of TLS 1.2 and 1.3.  The use of TLS 1.0 introduces significant vulnerabilities to potential attacks exploiting known weaknesses in its cryptographic algorithms and protocols.  Major web browsers and vendors ceased full support for TLS 1.0 by March 31, 2020.  PCI DSS v3.2 mandated the complete disabling of TLS 1.0 by June 30, 2018, with limited exceptions for POS POI terminals and associated SSL/TLS termination points demonstrably immune to known exploits.",
          "solution": "Implement support for TLS 1.2 and 1.3, and immediately disable support for TLS 1.0.  Verify the complete removal of TLS 1.0 from all supported cipher suites.",
          "risk_factor": "Medium",
          "cve": "",
          "bid": "",
          "xref": "CWE:327",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.1 Protocol Detection",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service utilizes an outdated and insecure TLS version (1.1).",
          "description": "The remote service accepts connections using TLS 1.1. This protocol is considered insecure due to its lack of support for modern cipher suites.  TLS 1.1 lacks support for authenticated encryption with associated data (AEAD) ciphers such as those employing Galois/Counter Mode (GCM), which provide superior confidentiality and integrity protection.  Furthermore, it does not support ciphers that perform encryption after MAC computation, leading to vulnerabilities such as padding oracle attacks.  Major web browsers and vendors have deprecated support for TLS 1.1, rendering systems using it incompatible with modern security practices.",
          "solution": "Implement support for TLS 1.2 and/or 1.3.  Simultaneously, explicitly disable TLS 1.1 to prevent its use.  This ensures interoperability with modern clients and enhances overall security posture.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "CWE:327",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.1 Protocol Detection",
          "protocol": "tcp",
          "port": 2053,
          "synopsis": "The remote service utilizes an outdated and insecure TLS version.",
          "description": "The remote service accepts connections using TLS 1.1.  This version lacks support for modern and secure cipher suites.  Critically, TLS 1.1 does not support authenticated encryption modes like GCM, and allows for encryption before message authentication code (MAC) computation, increasing vulnerability to various attacks.  Support for TLS 1.1 has been deprecated by major web browsers and vendors since March 31, 2020, rendering it functionally obsolete for many systems.",
          "solution": "Implement support for TLS 1.2 and/or TLS 1.3, and explicitly disable support for TLS 1.1.  This ensures compatibility with modern systems and protects against known vulnerabilities inherent to TLS 1.1.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "CWE:327",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.1 Protocol Detection",
          "protocol": "tcp",
          "port": 2083,
          "synopsis": "The remote service utilizes an outdated and insecure TLS version.",
          "description": "The remote service accepts connections using TLS 1.1.  This protocol lacks support for modern and secure cipher suites.  Critically, TLS 1.1 does not support authenticated encryption modes such as Galois/Counter Mode (GCM) which offer strong confidentiality and integrity guarantees.  Furthermore, it may allow for encryption before Message Authentication Code (MAC) computation, introducing vulnerabilities.  Support for TLS 1.1 has been deprecated by major web browsers and vendors, rendering systems using it incompatible with modern security practices.  Continued use poses significant security risks.",
          "solution": "Immediately upgrade the service to support TLS 1.2 or TLS 1.3.  Simultaneously, disable support for the insecure TLS 1.1 protocol to mitigate vulnerabilities and ensure interoperability with modern systems.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "CWE:327",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.1 Protocol Detection",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "The remote service uses the deprecated TLS 1.1 protocol for encryption.",
          "description": "The remote service accepts connections secured using TLS 1.1.  This version is considered insecure due to its lack of support for modern, robust cipher suites.  TLS 1.1 lacks support for authenticated encryption modes like GCM, and it permits ciphers that encrypt before computing the message authentication code (MAC), leading to vulnerabilities.  Major web browsers and vendors ceased support for TLS 1.1 in March 2020, rendering it functionally obsolete and exposing systems to potential attacks.",
          "solution": "Upgrade the service to support TLS 1.2 and/or TLS 1.3, and explicitly disable TLS 1.1.  Ensure that only strong, modern cipher suites are enabled.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "CWE:327",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.1 Protocol Detection",
          "protocol": "tcp",
          "port": 8443,
          "synopsis": "The remote service utilizes an outdated and insecure TLS version.",
          "description": "The remote service accepts TLS 1.1 encrypted connections.  TLS 1.1 lacks support for modern and secure cipher suites, including those offering authenticated encryption with associated data (AEAD) such as Galois/Counter Mode (GCM).  These cipher suites provide stronger confidentiality and integrity protection compared to those supported by TLS 1.1.  Prior to authenticated encryption, the encryption occurs before message authentication, introducing vulnerabilities and reducing security. The deprecation of TLS 1.1 by major web browsers and vendors significantly impacts interoperability and security.",
          "solution": "Implement support for TLS 1.2 and/or TLS 1.3.  Simultaneously, disable support for the vulnerable TLS 1.1 protocol to mitigate potential security risks and ensure compatibility with modern systems and security best practices.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "CWE:327",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.2 Protocol Detection",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service utilizes a TLS encryption protocol for communication.",
          "description": "The remote service establishes encrypted connections using TLS 1.2.  This indicates the service supports at least this version of the TLS protocol for secure communication.",
          "solution": "Implement a comprehensive security posture that addresses encryption protocols and cipher suite configuration.  Upgrade to a stronger TLS version if appropriate for interoperability and security best practices.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.2 Protocol Detection",
          "protocol": "tcp",
          "port": 2053,
          "synopsis": "The remote service utilizes TLS for encrypting network traffic.",
          "description": "The remote service accepts encrypted connections using the TLS 1.2 protocol.  This indicates a basic level of transport security is in place. However, the absence of specific TLS version details, cipher suite information and configuration parameters limits the assessment of its cryptographic strength.",
          "solution": "Implement a comprehensive assessment of the TLS configuration to verify its adherence to best practices, including cipher suite prioritization, support for modern protocols (TLS 1.3 or later), and appropriate key exchange algorithms. Regularly review and update cryptographic libraries and configurations to address emerging vulnerabilities.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.2 Protocol Detection",
          "protocol": "tcp",
          "port": 2083,
          "synopsis": "The remote service utilizes TLS for encrypted communication.  Further analysis is required to determine the cipher suites in use and their cryptographic strength.",
          "description": "The remote service is observed to accept TLS 1.2 encrypted connections.  TLS 1.2, while offering some security, is considered legacy and may be vulnerable to various attacks depending on the specific cipher suites and configurations employed.",
          "solution": "Implement a robust TLS configuration policy.  This should include support for modern TLS versions (TLS 1.3 is preferred), strong cipher suites with forward secrecy, and regular updates to address known vulnerabilities.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.2 Protocol Detection",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "The remote service uses TLS for encrypting network traffic.  Further analysis is required to determine the specific cipher suites and TLS configuration.",
          "description": "The remote service listens on TCP port 2087 and accepts connections secured with TLS 1.2.  This indicates a deployment of encryption, however, the strength and configuration of the TLS implementation require further investigation to ensure appropriate security posture.",
          "solution": "Implement a robust security posture by reviewing and strengthening TLS configuration.  This includes cipher suite selection, protocol version support, and regular updates to address known vulnerabilities in the TLS implementation.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.2 Protocol Detection",
          "protocol": "tcp",
          "port": 8443,
          "synopsis": "The remote service utilizes a TLS encryption protocol.",
          "description": "The remote service is observed to accept connections secured with TLS 1.2.  This indicates the service supports at least TLS 1.2 encryption.  Further investigation is needed to determine the full range of supported TLS protocols and cipher suites.",
          "solution": "Implement a comprehensive TLS configuration policy that mandates the use of strong, modern TLS versions (e.g., TLS 1.3) and cipher suites. Regularly update and review the policy in accordance with best practices and industry standards.  Consider enforcing TLS protocol preference via client-side configuration where applicable.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.3 Protocol Detection",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service utilizes Transport Layer Security (TLS) for encrypting network traffic.  The specific TLS version in use is detected.",
          "description": "The remote service is observed to accept inbound connections secured using TLS 1.3.  This indicates support for modern encryption protocols.",
          "solution": "No immediate action required if TLS 1.3 is the intended and supported protocol.  Maintaining up-to-date cryptographic libraries and regularly reviewing the security posture of the service is recommended.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.3 Protocol Detection",
          "protocol": "tcp",
          "port": 2053,
          "synopsis": "The remote service utilizes TLS for encrypted communication.",
          "description": "The remote service establishes connections secured with the TLS 1.3 protocol.  This indicates the service is configured to use a modern and relatively secure encryption protocol.",
          "solution": "Maintaining up-to-date cryptographic libraries and regularly reviewing TLS configuration is recommended for optimal security.  Consider enforcing TLS 1.3 as the minimum supported version to enhance security posture while mitigating potential vulnerabilities associated with older TLS versions.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.3 Protocol Detection",
          "protocol": "tcp",
          "port": 2083,
          "synopsis": "The remote service utilizes Transport Layer Security (TLS) for communication encryption.",
          "description": "The remote service establishes encrypted connections using TLS 1.3.  This indicates the service supports modern encryption protocols.",
          "solution": "Maintaining up-to-date cryptographic libraries and protocols is a best practice.  Regular security audits should verify the continued use of strong encryption.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.3 Protocol Detection",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "The remote service utilizes Transport Layer Security (TLS) for encrypting network communication.  The specific TLS version in use has been identified.",
          "description": "The remote service is observed to accept encrypted connections using TLS 1.3. This indicates the service supports a modern and relatively secure encryption protocol.",
          "solution": "Maintaining up-to-date cryptographic libraries and ensuring proper configuration of the TLS stack on the server is crucial for optimal security.  Regular security audits should be performed to verify continued compliance with security best practices.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.3 Protocol Detection",
          "protocol": "tcp",
          "port": 8443,
          "synopsis": "The remote service utilizes Transport Layer Security (TLS) for communication encryption.",
          "description": "The remote service establishes encrypted connections using TLS 1.3. This indicates support for modern encryption protocols, but further analysis is needed to ascertain the specific cipher suites in use and their security posture.",
          "solution": "Implement a comprehensive TLS configuration review to ensure the use of strong cipher suites and adherence to best practices.  Regularly update cryptographic libraries and protocols to mitigate against emerging vulnerabilities.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HSTS Missing From HTTPS Server (RFC 6797)",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote web server lacks HTTP Strict Transport Security (HSTS) enforcement, as specified in RFC 6797.",
          "description": "The absence of HSTS on the remote web server represents a security vulnerability.  HSTS is a security mechanism that instructs client browsers to exclusively communicate with the server using HTTPS, preventing downgrade attacks where a connection is downgraded to HTTP.  Without HSTS, various attacks become feasible, including SSL stripping (where an attacker intercepts and redirects a HTTPS connection to an HTTP connection), making the session vulnerable to eavesdropping and manipulation.  Furthermore, the lack of HSTS weakens protections against cookie hijacking and other session-related attacks by enabling interception and manipulation of cookies and sessions.",
          "solution": "Implement and configure the HSTS header on the remote web server.  This involves adding the `Strict-Transport-Security` header to HTTP responses, specifying a maximum age (in seconds) and, optionally, `includeSubDomains` and `preload` directives.  Proper configuration ensures all communication occurs over HTTPS, enhancing the security posture.",
          "risk_factor": "Medium",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HSTS Missing From HTTPS Server (RFC 6797)",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "The remote web server lacks HTTP Strict Transport Security (HSTS) enforcement as specified in RFC 6797.",
          "description": "The absence of HSTS as defined in RFC 6797 on the remote web server represents a security vulnerability.  HSTS is a security mechanism that instructs the client browser to exclusively communicate with the server using HTTPS.  Failure to implement HSTS exposes the system to downgrade attacks, where an attacker forces a downgrade to insecure HTTP, enabling man-in-the-middle attacks and compromising the integrity of sensitive information, including cookies.  This weakens the overall security posture and increases the risk of session hijacking and data breaches.",
          "solution": "Implement and configure HSTS on the remote web server. This involves adding the appropriate `Strict-Transport-Security` header to HTTP responses, specifying parameters such as `max-age` for the duration and optional `includeSubDomains` and `preload` directives for comprehensive protection.",
          "risk_factor": "Medium",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL/TLS Recommended Cipher Suites",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote host utilizes insecure SSL/TLS cipher suites.",
          "description": "The remote host's open SSL/TLS ports advertise cipher suites considered cryptographically weak or vulnerable to known attacks.  Implementing only the following cipher suites mitigates this risk.  Note that hexadecimal representations are provided for clarity, representing the cipher suite's identifier.  Consult relevant RFCs and protocol specifications for detailed descriptions of each suite:\n\nTLSv1.3:\n  - 0x13,0x01 TLS13_AES_128_GCM_SHA256\n  - 0x13,0x02 TLS13_AES_256_GCM_SHA384\n  - 0x13,0x03 TLS13_CHACHA20_POLY1305_SHA256\n\nTLSv1.2:\n  - 0xC0,0x2B ECDHE-ECDSA-AES128-GCM-SHA256\n  - 0xC0,0x2F ECDHE-RSA-AES128-GCM-SHA256\n  - 0xC0,0x2C ECDHE-ECDSA-AES256-GCM-SHA384\n  - 0xC0,0x30 ECDHE-RSA-AES256-GCM-SHA384\n  - 0xCC,0xA9 ECDHE-ECDSA-CHACHA20-POLY1305\n  - 0xCC,0xA8 ECDHE-RSA-CHACHA20-POLY1305\n\nThis configuration prioritizes strong encryption and authentication mechanisms, offering robust protection against modern attacks.  The listed suites provide broad compatibility with current client software.",
          "solution": "Configure the SSL/TLS server to exclusively support the recommended cipher suites.  Disable or remove any other cipher suites from the server's configuration.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL/TLS Recommended Cipher Suites",
          "protocol": "tcp",
          "port": 2053,
          "synopsis": "The remote host utilizes insecure SSL/TLS cipher suites.",
          "description": "The remote host's open SSL/TLS ports advertise cipher suites considered insecure.  Enabling only the following cipher suites mitigates the risk of known vulnerabilities and ensures strong cryptographic protection.  The recommended configuration prioritizes modern, robust algorithms and ensures compatibility with a wide range of clients.\n\nTLSv1.3:\n  - 0x13,0x01 TLS13_AES_128_GCM_SHA256 (AES-128 in GCM mode with SHA256)\n  - 0x13,0x02 TLS13_AES_256_GCM_SHA384 (AES-256 in GCM mode with SHA384)\n  - 0x13,0x03 TLS13_CHACHA20_POLY1305_SHA256 (ChaCha20 with Poly1305 AEAD and SHA256)\n\nTLSv1.2:\n  - 0xC0,0x2B ECDHE-ECDSA-AES128-GCM-SHA256 (ECDHE key exchange with ECDSA signature, AES-128 in GCM mode with SHA256)\n  - 0xC0,0x2F ECDHE-RSA-AES128-GCM-SHA256 (ECDHE key exchange with RSA signature, AES-128 in GCM mode with SHA256)\n  - 0xC0,0x2C ECDHE-ECDSA-AES256-GCM-SHA384 (ECDHE key exchange with ECDSA signature, AES-256 in GCM mode with SHA384)\n  - 0xC0,0x30 ECDHE-RSA-AES256-GCM-SHA384 (ECDHE key exchange with RSA signature, AES-256 in GCM mode with SHA384)\n  - 0xCC,0xA9 ECDHE-ECDSA-CHACHA20-POLY1305 (ECDHE key exchange with ECDSA signature, ChaCha20 with Poly1305 AEAD)\n  - 0xCC,0xA8 ECDHE-RSA-CHACHA20-POLY1305 (ECDHE key exchange with RSA signature, ChaCha20 with Poly1305 AEAD)\n\nThis configuration offers a balance between strong security and broad client compatibility.",
          "solution": "Configure the SSL/TLS service to exclusively utilize the recommended cipher suites.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL/TLS Recommended Cipher Suites",
          "protocol": "tcp",
          "port": 2083,
          "synopsis": "The remote host utilizes insecure SSL/TLS cipher suites.",
          "description": "The remote host's open SSL/TLS ports advertise cipher suites considered cryptographically weak or obsolete.  This increases the risk of successful man-in-the-middle attacks and data breaches.  It is crucial to restrict supported cipher suites to those offering robust forward secrecy and strong authentication.  The following cipher suites provide a balance of security and compatibility:\n\nTLSv1.3:\n  - 0x13,0x01 TLS13_AES_128_GCM_SHA256:  AES-128 in GCM mode with SHA256 authentication.\n  - 0x13,0x02 TLS13_AES_256_GCM_SHA384:  AES-256 in GCM mode with SHA384 authentication.\n  - 0x13,0x03 TLS13_CHACHA20_POLY1305_SHA256: ChaCha20 with Poly1305 authentication and SHA256 hashing.\n\nTLSv1.2:\n  - 0xC0,0x2B ECDHE-ECDSA-AES128-GCM-SHA256: Elliptic Curve Diffie-Hellman Ephemeral (ECDHE) key exchange with ECDSA signature, AES-128 in GCM mode, and SHA256 authentication.\n  - 0xC0,0x2F ECDHE-RSA-AES128-GCM-SHA256: ECDHE key exchange with RSA signature, AES-128 in GCM mode, and SHA256 authentication.\n  - 0xC0,0x2C ECDHE-ECDSA-AES256-GCM-SHA384: ECDHE key exchange with ECDSA signature, AES-256 in GCM mode, and SHA384 authentication.\n  - 0xC0,0x30 ECDHE-RSA-AES256-GCM-SHA384: ECDHE key exchange with RSA signature, AES-256 in GCM mode, and SHA384 authentication.\n  - 0xCC,0xA9 ECDHE-ECDSA-CHACHA20-POLY1305: ECDHE key exchange with ECDSA signature, ChaCha20 with Poly1305 authentication.\n  - 0xCC,0xA8 ECDHE-RSA-CHACHA20-POLY1305: ECDHE key exchange with RSA signature, ChaCha20 with Poly1305 authentication.\n\nEmploying these cipher suites ensures strong cryptographic protection and maintains broad compatibility with modern clients.",
          "solution": "Configure the SSL/TLS service to exclusively support the recommended cipher suites listed above.  Disable or remove support for all other cipher suites.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL/TLS Recommended Cipher Suites",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "The remote host utilizes insecure SSL/TLS cipher suites.",
          "description": "The remote host's open SSL/TLS ports advertise cipher suites considered cryptographically weak or vulnerable to known attacks.  Implementing only the strongly recommended cipher suites mitigates this risk.  The following cipher suites offer a balance of security and broad client compatibility:\n\nTLSv1.3:\n  - 0x13,0x01 TLS13_AES_128_GCM_SHA256\n  - 0x13,0x02 TLS13_AES_256_GCM_SHA384\n  - 0x13,0x03 TLS13_CHACHA20_POLY1305_SHA256\n\nTLSv1.2:\n  - 0xC0,0x2B ECDHE-ECDSA-AES128-GCM-SHA256\n  - 0xC0,0x2F ECDHE-RSA-AES128-GCM-SHA256\n  - 0xC0,0x2C ECDHE-ECDSA-AES256-GCM-SHA384\n  - 0xC0,0x30 ECDHE-RSA-AES256-GCM-SHA384\n  - 0xCC,0xA9 ECDHE-ECDSA-CHACHA20-POLY1305\n  - 0xCC,0xA8 ECDHE-RSA-CHACHA20-POLY1305\n\nThis configuration prioritizes strong encryption and authentication, ensuring compatibility with modern clients while minimizing exposure to known vulnerabilities.  The use of forward secrecy mechanisms is crucial for long-term data confidentiality.",
          "solution": "Reconfigure the SSL/TLS settings to exclusively enable the recommended cipher suites.  Disable or remove any others.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL/TLS Recommended Cipher Suites",
          "protocol": "tcp",
          "port": 8443,
          "synopsis": "The remote host utilizes insecure SSL/TLS cipher suites.",
          "description": "The remote host's open SSL/TLS ports advertise cipher suites considered cryptographically weak or vulnerable to known attacks.  Enabling only the following strong cipher suites is strongly recommended to mitigate these risks:\n\nTLSv1.3:\n  - 0x13,0x01 TLS13_AES_128_GCM_SHA256:  Uses AES-128 in GCM mode with SHA256 for authentication.\n  - 0x13,0x02 TLS13_AES_256_GCM_SHA384: Uses AES-256 in GCM mode with SHA384 for authentication.\n  - 0x13,0x03 TLS13_CHACHA20_POLY1305_SHA256: Uses ChaCha20-Poly1305 authenticated encryption with SHA256.\n\nTLSv1.2:\n  - 0xC0,0x2B ECDHE-ECDSA-AES128-GCM-SHA256: Uses ECDHE key exchange with ECDSA signatures, AES-128 in GCM mode, and SHA256.\n  - 0xC0,0x2F ECDHE-RSA-AES128-GCM-SHA256: Uses ECDHE key exchange with RSA signatures, AES-128 in GCM mode, and SHA256.\n  - 0xC0,0x2C ECDHE-ECDSA-AES256-GCM-SHA384: Uses ECDHE key exchange with ECDSA signatures, AES-256 in GCM mode, and SHA384.\n  - 0xC0,0x30 ECDHE-RSA-AES256-GCM-SHA384: Uses ECDHE key exchange with RSA signatures, AES-256 in GCM mode, and SHA384.\n  - 0xCC,0xA9 ECDHE-ECDSA-CHACHA20-POLY1305: Uses ECDHE key exchange with ECDSA signatures and ChaCha20-Poly1305 authenticated encryption.\n  - 0xCC,0xA8 ECDHE-RSA-CHACHA20-POLY1305: Uses ECDHE key exchange with RSA signatures and ChaCha20-Poly1305 authenticated encryption.\n\nThis configuration provides a strong balance between security and compatibility with modern clients.  The use of forward secrecy (ECDHE) and authenticated encryption (GCM and ChaCha20-Poly1305) are crucial for protecting against various attacks.",
          "solution": "Configure the SSL/TLS server to exclusively support the recommended cipher suites listed above.  Disable all other cipher suites.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.1 Deprecated Protocol",
          "protocol": "tcp",
          "port": 443,
          "synopsis": "The remote service utilizes a deprecated TLS version, posing a security risk.",
          "description": "The remote service accepts connections secured with TLS 1.1. This version lacks support for modern cipher suites offering strong authenticated encryption and forward secrecy.  TLS 1.1's inability to utilize authenticated encryption modes such as GCM and its potential vulnerabilities related to cipher suites that encrypt before computing the message authentication code (MAC) significantly weaken its security posture.  The deprecation of TLS 1.1 by major web browsers and vendors renders it functionally obsolete for many applications.",
          "solution": "Upgrade the service to support TLS 1.2 and/or 1.3.  Simultaneously, explicitly disable support for TLS 1.1 to prevent its use.",
          "risk_factor": "Medium",
          "cve": "",
          "bid": "",
          "xref": "CWE:327",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.1 Deprecated Protocol",
          "protocol": "tcp",
          "port": 2053,
          "synopsis": "The remote service utilizes a deprecated TLS version for encryption.",
          "description": "The remote service accepts connections secured using TLS 1.1. This protocol lacks support for modern cipher suites offering strong cryptographic protections.  TLS 1.1 does not support advanced encryption modes like GCM (Galois/Counter Mode) and does not allow for authenticated encryption after MAC (Message Authentication Code) computation, rendering it vulnerable to various cryptographic attacks.  The widespread deprecation of TLS 1.1 significantly reduces interoperability and security.  Major web browsers and vendors ceased full support for TLS 1.1 on or before March 31, 2020.",
          "solution": "Implement support for TLS 1.2 and/or TLS 1.3, and subsequently disable support for the vulnerable TLS 1.1 protocol.  Ensure that the chosen TLS version supports modern, robust cipher suites.",
          "risk_factor": "Medium",
          "cve": "",
          "bid": "",
          "xref": "CWE:327",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.1 Deprecated Protocol",
          "protocol": "tcp",
          "port": 2083,
          "synopsis": "The remote service uses the deprecated TLS 1.1 protocol for encryption.",
          "description": "The service accepts TLS 1.1 connections. This protocol lacks support for modern cipher suites offering strong authenticated encryption.  Specifically, TLS 1.1 does not support authenticated encryption with associated data (AEAD) modes like GCM, which are crucial for protecting against various cryptographic attacks.  Furthermore, it may not support ciphers that perform encryption after message authentication code (MAC) computation, a critical security feature.  The deprecation of TLS 1.1 by major web browsers and vendors since March 31, 2020, significantly reduces interoperability and increases the risk of security vulnerabilities.",
          "solution": "Upgrade the service to support TLS 1.2 or TLS 1.3.  Simultaneously, disable TLS 1.1 to eliminate the vulnerability.",
          "risk_factor": "Medium",
          "cve": "",
          "bid": "",
          "xref": "CWE:327",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.1 Deprecated Protocol",
          "protocol": "tcp",
          "port": 2087,
          "synopsis": "The remote service utilizes the deprecated TLS 1.1 protocol for encrypting network traffic.",
          "description": "The remote service accepts connections secured using TLS 1.1.  This version lacks support for modern and recommended cipher suites.  Critically, TLS 1.1 does not support authenticated encryption modes like GCM, which offer significantly improved security against various attacks.  Furthermore,  ciphers employing encryption before MAC computation are vulnerable to padding oracle attacks and other exploits that are mitigated in more recent TLS versions.  Major web browsers and vendors ceased support for TLS versions older than 1.2 as of March 31, 2020, rendering TLS 1.1 connections unreliable and insecure.",
          "solution": "Immediately upgrade the service to support TLS 1.2 and/or 1.3.  Simultaneously, disable support for the insecure and deprecated TLS 1.1 protocol to prevent exploitation.",
          "risk_factor": "Medium",
          "cve": "",
          "bid": "",
          "xref": "CWE:327",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.1 Deprecated Protocol",
          "protocol": "tcp",
          "port": 8443,
          "synopsis": "The remote service uses the deprecated TLS 1.1 protocol for encryption.",
          "description": "The service accepts connections using the TLS 1.1 protocol.  This version lacks support for modern cipher suites offering strong authenticated encryption and confidentiality.  Specifically, TLS 1.1 does not support authenticated encryption modes like GCM and prohibits ciphers that perform encryption after MAC computation, resulting in a reduced level of security.  Continued use of TLS 1.1 presents significant vulnerabilities to modern cryptographic attacks.  Major web browsers and vendors ceased full support for TLS 1.1 on or before March 31, 2020, rendering it functionally obsolete in many environments.",
          "solution": "Upgrade the service to support TLS 1.2 and/or TLS 1.3.  Simultaneously, explicitly disable support for TLS 1.1 to prevent its accidental use.",
          "risk_factor": "Medium",
          "cve": "",
          "bid": "",
          "xref": "CWE:327",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        }
      ]
    }
  },
  {
    "scanId": "SCAN7246A50F",
    "resolved": true,
    "timestamp": "1 January 2025",
    "status": "Analyzed",
    "Basic": {
      "Name": "Laravel",
      "Description": "Sbom Analysis for Laravel",
      "sbomFormat": "cyclonedx",
      "sbomVersion": ""
    },
    "Advanced Settings": {
      "sbomValidate": "",
      "sbomIncludeDevDependencies": ""
    },
    "schedule": {
      "frequency": "",
      "time": "",
      "timezone": ""
    },
    "credentials": {},
    "mainscanType": "SBOM",
    "files": {
      "sbomFile": {
        "filename": "bom.1.2-1736641330121.json",
        "originalName": "bom.1.2.json",
        "storedAt": "bom.1.2-1736641330121.json"
      }
    },
    "analysis": {
      "matches": [
        {
          "vulnerability": {
            "id": "CVE-2021-21263",
            "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2021-21263",
            "namespace": "nvd:cpe",
            "severity": "High",
            "urls": [
              "https://blog.laravel.com/security-laravel-62011-7302-8221-released",
              "https://github.com/laravel/framework/pull/35865",
              "https://github.com/laravel/framework/security/advisories/GHSA-3p32-j457-pg5x",
              "https://packagist.org/packages/illuminate/database",
              "https://packagist.org/packages/laravel/framework",
              "https://blog.laravel.com/security-laravel-62011-7302-8221-released",
              "https://github.com/laravel/framework/pull/35865",
              "https://github.com/laravel/framework/security/advisories/GHSA-3p32-j457-pg5x",
              "https://packagist.org/packages/illuminate/database",
              "https://packagist.org/packages/laravel/framework"
            ],
            "description": "Laravel is a web application framework. Versions of Laravel before 6.20.11, 7.30.2 and 8.22.1 contain a query binding exploitation. This same exploit applies to the illuminate/database package which is used by Laravel. If a request is crafted where a field that is normally a non-array value is an array, and that input is not validated or cast to its expected type before being passed to the query builder, an unexpected number of query bindings can be added to the query. In some situations, this will simply lead to no results being returned by the query builder; however, it is possible certain queries could be affected in a way that causes the query to return unexpected results.",
            "cvss": [
              {
                "source": "nvd@nist.gov",
                "type": "Primary",
                "version": "2.0",
                "vector": "AV:N/AC:L/Au:N/C:N/I:P/A:N",
                "metrics": {
                  "baseScore": 5,
                  "exploitabilityScore": 10,
                  "impactScore": 2.9
                },
                "vendorMetadata": {}
              },
              {
                "source": "security-advisories@github.com",
                "type": "Secondary",
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:C/C:L/I:L/A:N",
                "metrics": {
                  "baseScore": 7.2,
                  "exploitabilityScore": 3.9,
                  "impactScore": 2.7
                },
                "vendorMetadata": {}
              },
              {
                "source": "nvd@nist.gov",
                "type": "Primary",
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:L/A:N",
                "metrics": {
                  "baseScore": 5.3,
                  "exploitabilityScore": 3.9,
                  "impactScore": 1.4
                },
                "vendorMetadata": {}
              }
            ],
            "fix": {
              "versions": [
                "6.20.11",
                "7.30.2",
                "8.22.1"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [],
          "matchDetails": [
            {
              "type": "cpe-match",
              "matcher": "stock-matcher",
              "searchedBy": {
                "namespace": "nvd:cpe",
                "cpes": [
                  "cpe:2.3:a:laravel:laravel:v7.12.0:*:*:*:*:*:*:*"
                ],
                "package": {
                  "name": "laravel",
                  "version": "v7.12.0"
                }
              },
              "found": {
                "vulnerabilityID": "CVE-2021-21263",
                "versionConstraint": ">= 6.0.0, < 6.20.11 || >= 7.0.0, < 7.30.2 || >= 8.0.0, < 8.22.1 (unknown)",
                "cpes": [
                  "cpe:2.3:a:laravel:laravel:*:*:*:*:*:*:*:*"
                ]
              }
            }
          ],
          "artifact": {
            "id": "63badb7710732908",
            "name": "laravel",
            "version": "v7.12.0",
            "type": "php-composer",
            "locations": [],
            "language": "php",
            "licenses": [
              "MIT"
            ],
            "cpes": [
              "cpe:2.3:a:laravel:laravel:v7.12.0:*:*:*:*:*:*:*"
            ],
            "purl": "pkg:composer/laravel/laravel@v7.12.0",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "CVE-2020-24941",
            "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2020-24941",
            "namespace": "nvd:cpe",
            "severity": "High",
            "urls": [
              "https://blog.laravel.com/security-release-laravel-61835-7240",
              "https://blog.laravel.com/security-release-laravel-61835-7240"
            ],
            "description": "An issue was discovered in Laravel before 6.18.35 and 7.x before 7.24.0. The $guarded property is mishandled in some situations involving requests with JSON column nesting expressions.",
            "cvss": [
              {
                "source": "nvd@nist.gov",
                "type": "Primary",
                "version": "2.0",
                "vector": "AV:N/AC:M/Au:N/C:N/I:P/A:N",
                "metrics": {
                  "baseScore": 4.3,
                  "exploitabilityScore": 8.6,
                  "impactScore": 2.9
                },
                "vendorMetadata": {}
              },
              {
                "source": "nvd@nist.gov",
                "type": "Primary",
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:H/A:N",
                "metrics": {
                  "baseScore": 7.5,
                  "exploitabilityScore": 3.9,
                  "impactScore": 3.6
                },
                "vendorMetadata": {}
              }
            ],
            "fix": {
              "versions": [
                "6.18.35",
                "7.24.0"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [],
          "matchDetails": [
            {
              "type": "cpe-match",
              "matcher": "stock-matcher",
              "searchedBy": {
                "namespace": "nvd:cpe",
                "cpes": [
                  "cpe:2.3:a:laravel:laravel:v7.12.0:*:*:*:*:*:*:*"
                ],
                "package": {
                  "name": "laravel",
                  "version": "v7.12.0"
                }
              },
              "found": {
                "vulnerabilityID": "CVE-2020-24941",
                "versionConstraint": "< 6.18.35 || >= 7.0.0, < 7.24.0 (unknown)",
                "cpes": [
                  "cpe:2.3:a:laravel:laravel:*:*:*:*:*:*:*:*"
                ]
              }
            }
          ],
          "artifact": {
            "id": "63badb7710732908",
            "name": "laravel",
            "version": "v7.12.0",
            "type": "php-composer",
            "locations": [],
            "language": "php",
            "licenses": [
              "MIT"
            ],
            "cpes": [
              "cpe:2.3:a:laravel:laravel:v7.12.0:*:*:*:*:*:*:*"
            ],
            "purl": "pkg:composer/laravel/laravel@v7.12.0",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "CVE-2020-24940",
            "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2020-24940",
            "namespace": "nvd:cpe",
            "severity": "High",
            "urls": [
              "https://blog.laravel.com/security-release-laravel-61834-7232",
              "https://blog.laravel.com/security-release-laravel-61834-7232"
            ],
            "description": "An issue was discovered in Laravel before 6.18.34 and 7.x before 7.23.2. Unvalidated values are saved to the database in some situations in which table names are stripped during a mass assignment.",
            "cvss": [
              {
                "source": "nvd@nist.gov",
                "type": "Primary",
                "version": "2.0",
                "vector": "AV:N/AC:M/Au:N/C:N/I:P/A:N",
                "metrics": {
                  "baseScore": 4.3,
                  "exploitabilityScore": 8.6,
                  "impactScore": 2.9
                },
                "vendorMetadata": {}
              },
              {
                "source": "nvd@nist.gov",
                "type": "Primary",
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:H/A:N",
                "metrics": {
                  "baseScore": 7.5,
                  "exploitabilityScore": 3.9,
                  "impactScore": 3.6
                },
                "vendorMetadata": {}
              }
            ],
            "fix": {
              "versions": [
                "6.18.34",
                "7.23.2"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [],
          "matchDetails": [
            {
              "type": "cpe-match",
              "matcher": "stock-matcher",
              "searchedBy": {
                "namespace": "nvd:cpe",
                "cpes": [
                  "cpe:2.3:a:laravel:laravel:v7.12.0:*:*:*:*:*:*:*"
                ],
                "package": {
                  "name": "laravel",
                  "version": "v7.12.0"
                }
              },
              "found": {
                "vulnerabilityID": "CVE-2020-24940",
                "versionConstraint": "< 6.18.34 || >= 7.0.0, < 7.23.2 (unknown)",
                "cpes": [
                  "cpe:2.3:a:laravel:laravel:*:*:*:*:*:*:*:*"
                ]
              }
            }
          ],
          "artifact": {
            "id": "63badb7710732908",
            "name": "laravel",
            "version": "v7.12.0",
            "type": "php-composer",
            "locations": [],
            "language": "php",
            "licenses": [
              "MIT"
            ],
            "cpes": [
              "cpe:2.3:a:laravel:laravel:v7.12.0:*:*:*:*:*:*:*"
            ],
            "purl": "pkg:composer/laravel/laravel@v7.12.0",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "CVE-2024-52301",
            "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2024-52301",
            "namespace": "nvd:cpe",
            "severity": "Unknown",
            "urls": [
              "https://github.com/laravel/framework/security/advisories/GHSA-gv7v-rgg6-548h",
              "https://lists.debian.org/debian-lts-announce/2024/12/msg00019.html"
            ],
            "description": "Laravel is a web application framework. When the register_argc_argv php directive is set to on , and users call any URL with a special crafted query string, they are able to change the environment used by the framework when handling the request. The vulnerability fixed in 6.20.45, 7.30.7, 8.83.28, 9.52.17, 10.48.23, and 11.31.0. The framework now ignores argv values for environment detection on non-cli SAPIs.",
            "cvss": [],
            "fix": {
              "versions": [
                "10.48.23",
                "11.31.0",
                "6.20.45",
                "7.30.7",
                "8.83.28",
                "9.52.17"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [],
          "matchDetails": [
            {
              "type": "cpe-match",
              "matcher": "stock-matcher",
              "searchedBy": {
                "namespace": "nvd:cpe",
                "cpes": [
                  "cpe:2.3:a:laravel:laravel:v7.12.0:*:*:*:*:*:*:*"
                ],
                "package": {
                  "name": "laravel",
                  "version": "v7.12.0"
                }
              },
              "found": {
                "vulnerabilityID": "CVE-2024-52301",
                "versionConstraint": "< 6.20.45 || >= 7.0.0, < 7.30.7 || >= 8.0.0, < 8.83.28 || >= 9.0.0, < 9.52.17 || >= 10.0.0, < 10.48.23 || >= 11.0.0, < 11.31.0 (unknown)",
                "cpes": [
                  "cpe:2.3:a:laravel:laravel:*:*:*:*:*:php:*:*"
                ]
              }
            }
          ],
          "artifact": {
            "id": "63badb7710732908",
            "name": "laravel",
            "version": "v7.12.0",
            "type": "php-composer",
            "locations": [],
            "language": "php",
            "licenses": [
              "MIT"
            ],
            "cpes": [
              "cpe:2.3:a:laravel:laravel:v7.12.0:*:*:*:*:*:*:*"
            ],
            "purl": "pkg:composer/laravel/laravel@v7.12.0",
            "upstreams": []
          }
        }
      ],
      "source": {
        "type": "unknown",
        "target": "unknown"
      },
      "distro": {
        "name": "",
        "version": "",
        "idLike": null
      },
      "descriptor": {
        "name": "grype",
        "version": "0.86.1",
        "configuration": {
          "output": [
            "json"
          ],
          "file": "",
          "distro": "",
          "add-cpes-if-none": true,
          "output-template-file": "",
          "check-for-app-update": true,
          "only-fixed": false,
          "only-notfixed": false,
          "ignore-wontfix": "",
          "platform": "",
          "search": {
            "scope": "squashed",
            "unindexed-archives": false,
            "indexed-archives": true
          },
          "ignore": [
            {
              "vulnerability": "",
              "reason": "",
              "namespace": "",
              "fix-state": "",
              "package": {
                "name": "kernel-headers",
                "version": "",
                "language": "",
                "type": "rpm",
                "location": "",
                "upstream-name": "kernel"
              },
              "vex-status": "",
              "vex-justification": "",
              "match-type": "exact-indirect-match"
            },
            {
              "vulnerability": "",
              "reason": "",
              "namespace": "",
              "fix-state": "",
              "package": {
                "name": "linux-.*-headers-.*",
                "version": "",
                "language": "",
                "type": "deb",
                "location": "",
                "upstream-name": "linux"
              },
              "vex-status": "",
              "vex-justification": "",
              "match-type": "exact-indirect-match"
            },
            {
              "vulnerability": "",
              "reason": "",
              "namespace": "",
              "fix-state": "",
              "package": {
                "name": "linux-libc-dev",
                "version": "",
                "language": "",
                "type": "deb",
                "location": "",
                "upstream-name": "linux"
              },
              "vex-status": "",
              "vex-justification": "",
              "match-type": "exact-indirect-match"
            }
          ],
          "exclude": [],
          "db": {
            "cache-dir": "/home/ut/.cache/grype/db",
            "update-url": "https://toolbox-data.anchore.io/grype/databases/listing.json",
            "ca-cert": "",
            "auto-update": true,
            "validate-by-hash-on-start": false,
            "validate-age": true,
            "max-allowed-built-age": 432000000000000,
            "require-update-check": false,
            "update-available-timeout": 30000000000,
            "update-download-timeout": 300000000000,
            "max-update-check-frequency": 7200000000000
          },
          "externalSources": {
            "enable": false,
            "maven": {
              "searchUpstreamBySha1": true,
              "baseUrl": "https://search.maven.org/solrsearch/select"
            }
          },
          "match": {
            "java": {
              "using-cpes": false
            },
            "jvm": {
              "using-cpes": true
            },
            "dotnet": {
              "using-cpes": false
            },
            "golang": {
              "using-cpes": false,
              "always-use-cpe-for-stdlib": true,
              "allow-main-module-pseudo-version-comparison": false
            },
            "javascript": {
              "using-cpes": false
            },
            "python": {
              "using-cpes": false
            },
            "ruby": {
              "using-cpes": false
            },
            "rust": {
              "using-cpes": false
            },
            "stock": {
              "using-cpes": true
            }
          },
          "fail-on-severity": "",
          "registry": {
            "insecure-skip-tls-verify": false,
            "insecure-use-http": false,
            "auth": null,
            "ca-cert": ""
          },
          "show-suppressed": false,
          "by-cve": false,
          "name": "",
          "default-image-pull-source": "",
          "vex-documents": [],
          "vex-add": [],
          "match-upstream-kernel-headers": false,
          "exp": {
            "dbv6": false
          }
        },
        "db": {
          "built": "2025-01-12T01:31:36Z",
          "schemaVersion": 5,
          "location": "/home/ut/.cache/grype/db/5",
          "checksum": "sha256:02bf6a2587c84aff9a2f962bf7783aea0fc4554934049840609b1850e95adc2c",
          "error": null
        },
        "timestamp": "2025-01-12T17:45:32.320548116Z"
      }
    }
  },
  {
    "scanId": "SCANDFFD965C",
    "timestamp": "15 January 2025",
    "status": "Analyzed",
    "Basic": {
      "Name": "Java-archive-engine",
      "Description": "Supply chain Management for java libraries",
      "sbomFormat": "cyclonedx",
      "sbomVersion": ""
    },
    "Advanced Settings": {
      "sbomValidate": "",
      "sbomIncludeDevDependencies": ""
    },
    "schedule": {
      "frequency": "",
      "time": "",
      "timezone": ""
    },
    "credentials": {},
    "mainscanType": "SBOM",
    "files": {
      "sbomFile": {
        "filename": "logj4-1736940653981.json",
        "originalName": "logj4.json",
        "storedAt": "logj4-1736940653981.json"
      }
    },
    "analysis": {
      "matches": [
        {
          "vulnerability": {
            "id": "GHSA-jfh8-c2jp-5v3q",
            "dataSource": "https://github.com/advisories/GHSA-jfh8-c2jp-5v3q",
            "namespace": "github:language:java",
            "severity": "Critical",
            "urls": [
              "https://github.com/advisories/GHSA-jfh8-c2jp-5v3q"
            ],
            "description": "Remote code injection in Log4j",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:C/C:H/I:H/A:H",
                "metrics": {
                  "baseScore": 10,
                  "exploitabilityScore": 3.9,
                  "impactScore": 6
                },
                "vendorMetadata": {
                  "base_severity": "Critical",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "2.15.0"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2021-44228",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2021-44228",
              "namespace": "nvd:cpe",
              "severity": "Critical",
              "urls": [
                "http://packetstormsecurity.com/files/165225/Apache-Log4j2-2.14.1-Remote-Code-Execution.html",
                "http://packetstormsecurity.com/files/165260/VMware-Security-Advisory-2021-0028.html",
                "http://packetstormsecurity.com/files/165261/Apache-Log4j2-2.14.1-Information-Disclosure.html",
                "http://packetstormsecurity.com/files/165270/Apache-Log4j2-2.14.1-Remote-Code-Execution.html",
                "http://packetstormsecurity.com/files/165281/Log4j2-Log4Shell-Regexes.html",
                "http://packetstormsecurity.com/files/165282/Log4j-Payload-Generator.html",
                "http://packetstormsecurity.com/files/165306/L4sh-Log4j-Remote-Code-Execution.html",
                "http://packetstormsecurity.com/files/165307/Log4j-Remote-Code-Execution-Word-Bypassing.html",
                "http://packetstormsecurity.com/files/165311/log4j-scan-Extensive-Scanner.html",
                "http://packetstormsecurity.com/files/165371/VMware-Security-Advisory-2021-0028.4.html",
                "http://packetstormsecurity.com/files/165532/Log4Shell-HTTP-Header-Injection.html",
                "http://packetstormsecurity.com/files/165642/VMware-vCenter-Server-Unauthenticated-Log4Shell-JNDI-Injection-Remote-Code-Execution.html",
                "http://packetstormsecurity.com/files/165673/UniFi-Network-Application-Unauthenticated-Log4Shell-Remote-Code-Execution.html",
                "http://packetstormsecurity.com/files/167794/Open-Xchange-App-Suite-7.10.x-Cross-Site-Scripting-Command-Injection.html",
                "http://packetstormsecurity.com/files/167917/MobileIron-Log4Shell-Remote-Command-Execution.html",
                "http://packetstormsecurity.com/files/171626/AD-Manager-Plus-7122-Remote-Code-Execution.html",
                "http://seclists.org/fulldisclosure/2022/Dec/2",
                "http://seclists.org/fulldisclosure/2022/Jul/11",
                "http://seclists.org/fulldisclosure/2022/Mar/23",
                "http://www.openwall.com/lists/oss-security/2021/12/10/1",
                "http://www.openwall.com/lists/oss-security/2021/12/10/2",
                "http://www.openwall.com/lists/oss-security/2021/12/10/3",
                "http://www.openwall.com/lists/oss-security/2021/12/13/1",
                "http://www.openwall.com/lists/oss-security/2021/12/13/2",
                "http://www.openwall.com/lists/oss-security/2021/12/14/4",
                "http://www.openwall.com/lists/oss-security/2021/12/15/3",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-397453.pdf",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-479842.pdf",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-661247.pdf",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-714170.pdf",
                "https://github.com/cisagov/log4j-affected-db",
                "https://github.com/cisagov/log4j-affected-db/blob/develop/SOFTWARE-LIST.md",
                "https://github.com/nu11secur1ty/CVE-mitre/tree/main/CVE-2021-44228",
                "https://lists.debian.org/debian-lts-announce/2021/12/msg00007.html",
                "https://lists.fedoraproject.org/archives/list/package-announce%40lists.fedoraproject.org/message/M5CSVUNV4HWZZXGOKNSK6L7RPM7BOKIB/",
                "https://lists.fedoraproject.org/archives/list/package-announce%40lists.fedoraproject.org/message/VU57UJDCFIASIO35GC55JMKSRXJMCDFM/",
                "https://logging.apache.org/log4j/2.x/security.html",
                "https://msrc-blog.microsoft.com/2021/12/11/microsofts-response-to-cve-2021-44228-apache-log4j2/",
                "https://psirt.global.sonicwall.com/vuln-detail/SNWLID-2021-0032",
                "https://security.netapp.com/advisory/ntap-20211210-0007/",
                "https://support.apple.com/kb/HT213189",
                "https://tools.cisco.com/security/center/content/CiscoSecurityAdvisory/cisco-sa-apache-log4j-qRuKNEbd",
                "https://tools.cisco.com/security/center/content/CiscoSecurityAdvisory/cisco-sa-apache-log4j-qRuKNEbd",
                "https://tools.cisco.com/security/center/content/CiscoSecurityAdvisory/cisco-sa-apache-log4j-qRuKNEbd",
                "https://twitter.com/kurtseifried/status/1469345530182455296",
                "https://www.bentley.com/en/common-vulnerability-exposure/be-2022-0001",
                "https://www.debian.org/security/2021/dsa-5020",
                "https://www.intel.com/content/www/us/en/security-center/advisory/intel-sa-00646.html",
                "https://www.kb.cert.org/vuls/id/930724",
                "https://www.nu11secur1ty.com/2021/12/cve-2021-44228.html",
                "https://www.oracle.com/security-alerts/alert-cve-2021-44228.html",
                "https://www.oracle.com/security-alerts/cpuapr2022.html",
                "https://www.oracle.com/security-alerts/cpujan2022.html",
                "http://packetstormsecurity.com/files/165225/Apache-Log4j2-2.14.1-Remote-Code-Execution.html",
                "http://packetstormsecurity.com/files/165260/VMware-Security-Advisory-2021-0028.html",
                "http://packetstormsecurity.com/files/165261/Apache-Log4j2-2.14.1-Information-Disclosure.html",
                "http://packetstormsecurity.com/files/165270/Apache-Log4j2-2.14.1-Remote-Code-Execution.html",
                "http://packetstormsecurity.com/files/165281/Log4j2-Log4Shell-Regexes.html",
                "http://packetstormsecurity.com/files/165282/Log4j-Payload-Generator.html",
                "http://packetstormsecurity.com/files/165306/L4sh-Log4j-Remote-Code-Execution.html",
                "http://packetstormsecurity.com/files/165307/Log4j-Remote-Code-Execution-Word-Bypassing.html",
                "http://packetstormsecurity.com/files/165311/log4j-scan-Extensive-Scanner.html",
                "http://packetstormsecurity.com/files/165371/VMware-Security-Advisory-2021-0028.4.html",
                "http://packetstormsecurity.com/files/165532/Log4Shell-HTTP-Header-Injection.html",
                "http://packetstormsecurity.com/files/165642/VMware-vCenter-Server-Unauthenticated-Log4Shell-JNDI-Injection-Remote-Code-Execution.html",
                "http://packetstormsecurity.com/files/165673/UniFi-Network-Application-Unauthenticated-Log4Shell-Remote-Code-Execution.html",
                "http://packetstormsecurity.com/files/167794/Open-Xchange-App-Suite-7.10.x-Cross-Site-Scripting-Command-Injection.html",
                "http://packetstormsecurity.com/files/167917/MobileIron-Log4Shell-Remote-Command-Execution.html",
                "http://packetstormsecurity.com/files/171626/AD-Manager-Plus-7122-Remote-Code-Execution.html",
                "http://seclists.org/fulldisclosure/2022/Dec/2",
                "http://seclists.org/fulldisclosure/2022/Jul/11",
                "http://seclists.org/fulldisclosure/2022/Mar/23",
                "http://www.openwall.com/lists/oss-security/2021/12/10/1",
                "http://www.openwall.com/lists/oss-security/2021/12/10/2",
                "http://www.openwall.com/lists/oss-security/2021/12/10/3",
                "http://www.openwall.com/lists/oss-security/2021/12/13/1",
                "http://www.openwall.com/lists/oss-security/2021/12/13/2",
                "http://www.openwall.com/lists/oss-security/2021/12/14/4",
                "http://www.openwall.com/lists/oss-security/2021/12/15/3",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-397453.pdf",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-479842.pdf",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-661247.pdf",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-714170.pdf",
                "https://github.com/cisagov/log4j-affected-db",
                "https://github.com/cisagov/log4j-affected-db/blob/develop/SOFTWARE-LIST.md",
                "https://github.com/nu11secur1ty/CVE-mitre/tree/main/CVE-2021-44228",
                "https://lists.debian.org/debian-lts-announce/2021/12/msg00007.html",
                "https://lists.fedoraproject.org/archives/list/package-announce%40lists.fedoraproject.org/message/M5CSVUNV4HWZZXGOKNSK6L7RPM7BOKIB/",
                "https://lists.fedoraproject.org/archives/list/package-announce%40lists.fedoraproject.org/message/VU57UJDCFIASIO35GC55JMKSRXJMCDFM/",
                "https://logging.apache.org/log4j/2.x/security.html",
                "https://msrc-blog.microsoft.com/2021/12/11/microsofts-response-to-cve-2021-44228-apache-log4j2/",
                "https://psirt.global.sonicwall.com/vuln-detail/SNWLID-2021-0032",
                "https://security.netapp.com/advisory/ntap-20211210-0007/",
                "https://support.apple.com/kb/HT213189",
                "https://tools.cisco.com/security/center/content/CiscoSecurityAdvisory/cisco-sa-apache-log4j-qRuKNEbd",
                "https://tools.cisco.com/security/center/content/CiscoSecurityAdvisory/cisco-sa-apache-log4j-qRuKNEbd",
                "https://tools.cisco.com/security/center/content/CiscoSecurityAdvisory/cisco-sa-apache-log4j-qRuKNEbd",
                "https://twitter.com/kurtseifried/status/1469345530182455296",
                "https://www.bentley.com/en/common-vulnerability-exposure/be-2022-0001",
                "https://www.debian.org/security/2021/dsa-5020",
                "https://www.intel.com/content/www/us/en/security-center/advisory/intel-sa-00646.html",
                "https://www.kb.cert.org/vuls/id/930724",
                "https://www.nu11secur1ty.com/2021/12/cve-2021-44228.html",
                "https://www.oracle.com/security-alerts/alert-cve-2021-44228.html",
                "https://www.oracle.com/security-alerts/cpuapr2022.html",
                "https://www.oracle.com/security-alerts/cpujan2022.html"
              ],
              "description": "Apache Log4j2 2.0-beta9 through 2.15.0 (excluding security releases 2.12.2, 2.12.3, and 2.3.1) JNDI features used in configuration, log messages, and parameters do not protect against attacker controlled LDAP and other JNDI related endpoints. An attacker who can control log messages or log message parameters can execute arbitrary code loaded from LDAP servers when message lookup substitution is enabled. From log4j 2.15.0, this behavior has been disabled by default. From version 2.16.0 (along with 2.12.2, 2.12.3, and 2.3.1), this functionality has been completely removed. Note that this vulnerability is specific to log4j-core and does not affect log4net, log4cxx, or other Apache Logging Services projects.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "2.0",
                  "vector": "AV:N/AC:M/Au:N/C:C/I:C/A:C",
                  "metrics": {
                    "baseScore": 9.3,
                    "exploitabilityScore": 8.6,
                    "impactScore": 10
                  },
                  "vendorMetadata": {}
                },
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:C/C:H/I:H/A:H",
                  "metrics": {
                    "baseScore": 10,
                    "exploitabilityScore": 3.9,
                    "impactScore": 6
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "log4j-core",
                  "version": "2.14.1"
                }
              },
              "found": {
                "versionConstraint": ">=2.13.0,<2.15.0 (unknown)",
                "vulnerabilityID": "GHSA-jfh8-c2jp-5v3q"
              }
            }
          ],
          "artifact": {
            "id": "5fad944c2c5c1605",
            "name": "log4j-core",
            "version": "2.14.1",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [
              "cpe:2.3:a:log4j-core:log4j-core:2.14.1:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j-core:log4j_core:2.14.1:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j_core:log4j-core:2.14.1:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j_core:log4j_core:2.14.1:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j:log4j-core:2.14.1:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j:log4j_core:2.14.1:*:*:*:*:*:*:*"
            ],
            "purl": "pkg:maven/org.apache.logging.log4j/log4j-core@2.14.1",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-7rjr-3q55-vv33",
            "dataSource": "https://github.com/advisories/GHSA-7rjr-3q55-vv33",
            "namespace": "github:language:java",
            "severity": "Critical",
            "urls": [
              "https://github.com/advisories/GHSA-7rjr-3q55-vv33"
            ],
            "description": "Incomplete fix for Apache Log4j vulnerability",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:H/PR:N/UI:N/S:C/C:H/I:H/A:H",
                "metrics": {
                  "baseScore": 9,
                  "exploitabilityScore": 2.2,
                  "impactScore": 6
                },
                "vendorMetadata": {
                  "base_severity": "Critical",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "2.16.0"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2021-45046",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2021-45046",
              "namespace": "nvd:cpe",
              "severity": "Critical",
              "urls": [
                "http://www.openwall.com/lists/oss-security/2021/12/14/4",
                "http://www.openwall.com/lists/oss-security/2021/12/15/3",
                "http://www.openwall.com/lists/oss-security/2021/12/18/1",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-397453.pdf",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-479842.pdf",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-661247.pdf",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-714170.pdf",
                "https://lists.fedoraproject.org/archives/list/package-announce%40lists.fedoraproject.org/message/EOKPQGV24RRBBI4TBZUDQMM4MEH7MXCY/",
                "https://lists.fedoraproject.org/archives/list/package-announce%40lists.fedoraproject.org/message/SIG7FZULMNK2XF6FZRU4VWYDQXNMUGAJ/",
                "https://logging.apache.org/log4j/2.x/security.html",
                "https://psirt.global.sonicwall.com/vuln-detail/SNWLID-2021-0032",
                "https://security.gentoo.org/glsa/202310-16",
                "https://tools.cisco.com/security/center/content/CiscoSecurityAdvisory/cisco-sa-apache-log4j-qRuKNEbd",
                "https://www.cve.org/CVERecord?id=CVE-2021-44228",
                "https://www.debian.org/security/2021/dsa-5022",
                "https://www.intel.com/content/www/us/en/security-center/advisory/intel-sa-00646.html",
                "https://www.kb.cert.org/vuls/id/930724",
                "https://www.oracle.com/security-alerts/alert-cve-2021-44228.html",
                "https://www.oracle.com/security-alerts/cpuapr2022.html",
                "https://www.oracle.com/security-alerts/cpujan2022.html",
                "https://www.oracle.com/security-alerts/cpujul2022.html",
                "http://www.openwall.com/lists/oss-security/2021/12/14/4",
                "http://www.openwall.com/lists/oss-security/2021/12/15/3",
                "http://www.openwall.com/lists/oss-security/2021/12/18/1",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-397453.pdf",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-479842.pdf",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-661247.pdf",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-714170.pdf",
                "https://lists.fedoraproject.org/archives/list/package-announce%40lists.fedoraproject.org/message/EOKPQGV24RRBBI4TBZUDQMM4MEH7MXCY/",
                "https://lists.fedoraproject.org/archives/list/package-announce%40lists.fedoraproject.org/message/SIG7FZULMNK2XF6FZRU4VWYDQXNMUGAJ/",
                "https://logging.apache.org/log4j/2.x/security.html",
                "https://psirt.global.sonicwall.com/vuln-detail/SNWLID-2021-0032",
                "https://security.gentoo.org/glsa/202310-16",
                "https://tools.cisco.com/security/center/content/CiscoSecurityAdvisory/cisco-sa-apache-log4j-qRuKNEbd",
                "https://www.cve.org/CVERecord?id=CVE-2021-44228",
                "https://www.debian.org/security/2021/dsa-5022",
                "https://www.intel.com/content/www/us/en/security-center/advisory/intel-sa-00646.html",
                "https://www.kb.cert.org/vuls/id/930724",
                "https://www.oracle.com/security-alerts/alert-cve-2021-44228.html",
                "https://www.oracle.com/security-alerts/cpuapr2022.html",
                "https://www.oracle.com/security-alerts/cpujan2022.html",
                "https://www.oracle.com/security-alerts/cpujul2022.html"
              ],
              "description": "It was found that the fix to address CVE-2021-44228 in Apache Log4j 2.15.0 was incomplete in certain non-default configurations. This could allows attackers with control over Thread Context Map (MDC) input data when the logging configuration uses a non-default Pattern Layout with either a Context Lookup (for example, $${ctx:loginId}) or a Thread Context Map pattern (%X, %mdc, or %MDC) to craft malicious input data using a JNDI Lookup pattern resulting in an information leak and remote code execution in some environments and local code execution in all environments. Log4j 2.16.0 (Java 8) and 2.12.2 (Java 7) fix this issue by removing support for message lookup patterns and disabling JNDI functionality by default.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "2.0",
                  "vector": "AV:N/AC:H/Au:N/C:P/I:P/A:P",
                  "metrics": {
                    "baseScore": 5.1,
                    "exploitabilityScore": 4.9,
                    "impactScore": 6.4
                  },
                  "vendorMetadata": {}
                },
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:H/PR:N/UI:N/S:C/C:H/I:H/A:H",
                  "metrics": {
                    "baseScore": 9,
                    "exploitabilityScore": 2.2,
                    "impactScore": 6
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "log4j-core",
                  "version": "2.14.1"
                }
              },
              "found": {
                "versionConstraint": ">=2.13.0,<2.16.0 (unknown)",
                "vulnerabilityID": "GHSA-7rjr-3q55-vv33"
              }
            }
          ],
          "artifact": {
            "id": "5fad944c2c5c1605",
            "name": "log4j-core",
            "version": "2.14.1",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [
              "cpe:2.3:a:log4j-core:log4j-core:2.14.1:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j-core:log4j_core:2.14.1:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j_core:log4j-core:2.14.1:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j_core:log4j_core:2.14.1:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j:log4j-core:2.14.1:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j:log4j_core:2.14.1:*:*:*:*:*:*:*"
            ],
            "purl": "pkg:maven/org.apache.logging.log4j/log4j-core@2.14.1",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-p6xc-xr62-6r2g",
            "dataSource": "https://github.com/advisories/GHSA-p6xc-xr62-6r2g",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-p6xc-xr62-6r2g"
            ],
            "description": "Apache Log4j2 vulnerable to Improper Input Validation and Uncontrolled Recursion",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:C/C:N/I:N/A:H",
                "metrics": {
                  "baseScore": 8.6,
                  "exploitabilityScore": 3.9,
                  "impactScore": 4
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "2.17.0"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2021-45105",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2021-45105",
              "namespace": "nvd:cpe",
              "severity": "Medium",
              "urls": [
                "http://www.openwall.com/lists/oss-security/2021/12/19/1",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-479842.pdf",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-501673.pdf",
                "https://logging.apache.org/log4j/2.x/security.html",
                "https://psirt.global.sonicwall.com/vuln-detail/SNWLID-2021-0032",
                "https://security.netapp.com/advisory/ntap-20211218-0001/",
                "https://tools.cisco.com/security/center/content/CiscoSecurityAdvisory/cisco-sa-apache-log4j-qRuKNEbd",
                "https://www.debian.org/security/2021/dsa-5024",
                "https://www.kb.cert.org/vuls/id/930724",
                "https://www.oracle.com/security-alerts/cpuapr2022.html",
                "https://www.oracle.com/security-alerts/cpujan2022.html",
                "https://www.oracle.com/security-alerts/cpujul2022.html",
                "https://www.zerodayinitiative.com/advisories/ZDI-21-1541/",
                "http://www.openwall.com/lists/oss-security/2021/12/19/1",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-479842.pdf",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-501673.pdf",
                "https://logging.apache.org/log4j/2.x/security.html",
                "https://psirt.global.sonicwall.com/vuln-detail/SNWLID-2021-0032",
                "https://security.netapp.com/advisory/ntap-20211218-0001/",
                "https://tools.cisco.com/security/center/content/CiscoSecurityAdvisory/cisco-sa-apache-log4j-qRuKNEbd",
                "https://www.debian.org/security/2021/dsa-5024",
                "https://www.kb.cert.org/vuls/id/930724",
                "https://www.oracle.com/security-alerts/cpuapr2022.html",
                "https://www.oracle.com/security-alerts/cpujan2022.html",
                "https://www.oracle.com/security-alerts/cpujul2022.html",
                "https://www.zerodayinitiative.com/advisories/ZDI-21-1541/"
              ],
              "description": "Apache Log4j2 versions 2.0-alpha1 through 2.16.0 (excluding 2.12.3 and 2.3.1) did not protect from uncontrolled recursion from self-referential lookups. This allows an attacker with control over Thread Context Map data to cause a denial of service when a crafted string is interpreted. This issue was fixed in Log4j 2.17.0, 2.12.3, and 2.3.1.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "2.0",
                  "vector": "AV:N/AC:M/Au:N/C:N/I:N/A:P",
                  "metrics": {
                    "baseScore": 4.3,
                    "exploitabilityScore": 8.6,
                    "impactScore": 2.9
                  },
                  "vendorMetadata": {}
                },
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:H/PR:N/UI:N/S:U/C:N/I:N/A:H",
                  "metrics": {
                    "baseScore": 5.9,
                    "exploitabilityScore": 2.2,
                    "impactScore": 3.6
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "log4j-core",
                  "version": "2.14.1"
                }
              },
              "found": {
                "versionConstraint": ">=2.13.0,<2.17.0 (unknown)",
                "vulnerabilityID": "GHSA-p6xc-xr62-6r2g"
              }
            }
          ],
          "artifact": {
            "id": "5fad944c2c5c1605",
            "name": "log4j-core",
            "version": "2.14.1",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [
              "cpe:2.3:a:log4j-core:log4j-core:2.14.1:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j-core:log4j_core:2.14.1:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j_core:log4j-core:2.14.1:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j_core:log4j_core:2.14.1:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j:log4j-core:2.14.1:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j:log4j_core:2.14.1:*:*:*:*:*:*:*"
            ],
            "purl": "pkg:maven/org.apache.logging.log4j/log4j-core@2.14.1",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-8489-44mv-ggj8",
            "dataSource": "https://github.com/advisories/GHSA-8489-44mv-ggj8",
            "namespace": "github:language:java",
            "severity": "Medium",
            "urls": [
              "https://github.com/advisories/GHSA-8489-44mv-ggj8"
            ],
            "description": "Improper Input Validation and Injection in Apache Log4j2",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:H/PR:H/UI:N/S:U/C:H/I:H/A:H",
                "metrics": {
                  "baseScore": 6.6,
                  "exploitabilityScore": 0.7,
                  "impactScore": 5.9
                },
                "vendorMetadata": {
                  "base_severity": "Medium",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "2.17.1"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2021-44832",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2021-44832",
              "namespace": "nvd:cpe",
              "severity": "Medium",
              "urls": [
                "http://www.openwall.com/lists/oss-security/2021/12/28/1",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-784507.pdf",
                "https://issues.apache.org/jira/browse/LOG4J2-3293",
                "https://lists.apache.org/thread/s1o5vlo78ypqxnzn6p8zf6t9shtq5143",
                "https://lists.debian.org/debian-lts-announce/2021/12/msg00036.html",
                "https://lists.fedoraproject.org/archives/list/package-announce%40lists.fedoraproject.org/message/EVV25FXL4FU5X6X5BSL7RLQ7T6F65MRA/",
                "https://lists.fedoraproject.org/archives/list/package-announce%40lists.fedoraproject.org/message/T57MPJUW3MA6QGWZRTMCHHMMPQNVKGFC/",
                "https://security.netapp.com/advisory/ntap-20220104-0001/",
                "https://tools.cisco.com/security/center/content/CiscoSecurityAdvisory/cisco-sa-apache-log4j-qRuKNEbd",
                "https://www.oracle.com/security-alerts/cpuapr2022.html",
                "https://www.oracle.com/security-alerts/cpujan2022.html",
                "https://www.oracle.com/security-alerts/cpujul2022.html",
                "http://www.openwall.com/lists/oss-security/2021/12/28/1",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-784507.pdf",
                "https://issues.apache.org/jira/browse/LOG4J2-3293",
                "https://lists.apache.org/thread/s1o5vlo78ypqxnzn6p8zf6t9shtq5143",
                "https://lists.debian.org/debian-lts-announce/2021/12/msg00036.html",
                "https://lists.fedoraproject.org/archives/list/package-announce%40lists.fedoraproject.org/message/EVV25FXL4FU5X6X5BSL7RLQ7T6F65MRA/",
                "https://lists.fedoraproject.org/archives/list/package-announce%40lists.fedoraproject.org/message/T57MPJUW3MA6QGWZRTMCHHMMPQNVKGFC/",
                "https://security.netapp.com/advisory/ntap-20220104-0001/",
                "https://tools.cisco.com/security/center/content/CiscoSecurityAdvisory/cisco-sa-apache-log4j-qRuKNEbd",
                "https://www.oracle.com/security-alerts/cpuapr2022.html",
                "https://www.oracle.com/security-alerts/cpujan2022.html",
                "https://www.oracle.com/security-alerts/cpujul2022.html"
              ],
              "description": "Apache Log4j2 versions 2.0-beta7 through 2.17.0 (excluding security fix releases 2.3.2 and 2.12.4) are vulnerable to a remote code execution (RCE) attack when a configuration uses a JDBC Appender with a JNDI LDAP data source URI when an attacker has control of the target LDAP server. This issue is fixed by limiting JNDI data source names to the java protocol in Log4j2 versions 2.17.1, 2.12.4, and 2.3.2.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "2.0",
                  "vector": "AV:N/AC:M/Au:S/C:C/I:C/A:C",
                  "metrics": {
                    "baseScore": 8.5,
                    "exploitabilityScore": 6.8,
                    "impactScore": 10
                  },
                  "vendorMetadata": {}
                },
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:H/PR:H/UI:N/S:U/C:H/I:H/A:H",
                  "metrics": {
                    "baseScore": 6.6,
                    "exploitabilityScore": 0.7,
                    "impactScore": 5.9
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "log4j-core",
                  "version": "2.14.1"
                }
              },
              "found": {
                "versionConstraint": ">=2.13.0,<2.17.1 (unknown)",
                "vulnerabilityID": "GHSA-8489-44mv-ggj8"
              }
            }
          ],
          "artifact": {
            "id": "5fad944c2c5c1605",
            "name": "log4j-core",
            "version": "2.14.1",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [
              "cpe:2.3:a:log4j-core:log4j-core:2.14.1:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j-core:log4j_core:2.14.1:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j_core:log4j-core:2.14.1:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j_core:log4j_core:2.14.1:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j:log4j-core:2.14.1:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j:log4j_core:2.14.1:*:*:*:*:*:*:*"
            ],
            "purl": "pkg:maven/org.apache.logging.log4j/log4j-core@2.14.1",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-p6xc-xr62-6r2g",
            "dataSource": "https://github.com/advisories/GHSA-p6xc-xr62-6r2g",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-p6xc-xr62-6r2g"
            ],
            "description": "Apache Log4j2 vulnerable to Improper Input Validation and Uncontrolled Recursion",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:C/C:N/I:N/A:H",
                "metrics": {
                  "baseScore": 8.6,
                  "exploitabilityScore": 3.9,
                  "impactScore": 4
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "2.17.0"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2021-45105",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2021-45105",
              "namespace": "nvd:cpe",
              "severity": "Medium",
              "urls": [
                "http://www.openwall.com/lists/oss-security/2021/12/19/1",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-479842.pdf",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-501673.pdf",
                "https://logging.apache.org/log4j/2.x/security.html",
                "https://psirt.global.sonicwall.com/vuln-detail/SNWLID-2021-0032",
                "https://security.netapp.com/advisory/ntap-20211218-0001/",
                "https://tools.cisco.com/security/center/content/CiscoSecurityAdvisory/cisco-sa-apache-log4j-qRuKNEbd",
                "https://www.debian.org/security/2021/dsa-5024",
                "https://www.kb.cert.org/vuls/id/930724",
                "https://www.oracle.com/security-alerts/cpuapr2022.html",
                "https://www.oracle.com/security-alerts/cpujan2022.html",
                "https://www.oracle.com/security-alerts/cpujul2022.html",
                "https://www.zerodayinitiative.com/advisories/ZDI-21-1541/",
                "http://www.openwall.com/lists/oss-security/2021/12/19/1",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-479842.pdf",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-501673.pdf",
                "https://logging.apache.org/log4j/2.x/security.html",
                "https://psirt.global.sonicwall.com/vuln-detail/SNWLID-2021-0032",
                "https://security.netapp.com/advisory/ntap-20211218-0001/",
                "https://tools.cisco.com/security/center/content/CiscoSecurityAdvisory/cisco-sa-apache-log4j-qRuKNEbd",
                "https://www.debian.org/security/2021/dsa-5024",
                "https://www.kb.cert.org/vuls/id/930724",
                "https://www.oracle.com/security-alerts/cpuapr2022.html",
                "https://www.oracle.com/security-alerts/cpujan2022.html",
                "https://www.oracle.com/security-alerts/cpujul2022.html",
                "https://www.zerodayinitiative.com/advisories/ZDI-21-1541/"
              ],
              "description": "Apache Log4j2 versions 2.0-alpha1 through 2.16.0 (excluding 2.12.3 and 2.3.1) did not protect from uncontrolled recursion from self-referential lookups. This allows an attacker with control over Thread Context Map data to cause a denial of service when a crafted string is interpreted. This issue was fixed in Log4j 2.17.0, 2.12.3, and 2.3.1.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "2.0",
                  "vector": "AV:N/AC:M/Au:N/C:N/I:N/A:P",
                  "metrics": {
                    "baseScore": 4.3,
                    "exploitabilityScore": 8.6,
                    "impactScore": 2.9
                  },
                  "vendorMetadata": {}
                },
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:H/PR:N/UI:N/S:U/C:N/I:N/A:H",
                  "metrics": {
                    "baseScore": 5.9,
                    "exploitabilityScore": 2.2,
                    "impactScore": 3.6
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "log4j-core",
                  "version": "2.16.0"
                }
              },
              "found": {
                "versionConstraint": ">=2.13.0,<2.17.0 (unknown)",
                "vulnerabilityID": "GHSA-p6xc-xr62-6r2g"
              }
            }
          ],
          "artifact": {
            "id": "0e921233df588822",
            "name": "log4j-core",
            "version": "2.16.0",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [
              "cpe:2.3:a:log4j-core:log4j-core:2.16.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j-core:log4j_core:2.16.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j_core:log4j-core:2.16.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j_core:log4j_core:2.16.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j:log4j-core:2.16.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j:log4j_core:2.16.0:*:*:*:*:*:*:*"
            ],
            "purl": "pkg:maven/org.apache.logging.log4j/log4j-core@2.16.0",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-8489-44mv-ggj8",
            "dataSource": "https://github.com/advisories/GHSA-8489-44mv-ggj8",
            "namespace": "github:language:java",
            "severity": "Medium",
            "urls": [
              "https://github.com/advisories/GHSA-8489-44mv-ggj8"
            ],
            "description": "Improper Input Validation and Injection in Apache Log4j2",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:H/PR:H/UI:N/S:U/C:H/I:H/A:H",
                "metrics": {
                  "baseScore": 6.6,
                  "exploitabilityScore": 0.7,
                  "impactScore": 5.9
                },
                "vendorMetadata": {
                  "base_severity": "Medium",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "2.17.1"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2021-44832",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2021-44832",
              "namespace": "nvd:cpe",
              "severity": "Medium",
              "urls": [
                "http://www.openwall.com/lists/oss-security/2021/12/28/1",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-784507.pdf",
                "https://issues.apache.org/jira/browse/LOG4J2-3293",
                "https://lists.apache.org/thread/s1o5vlo78ypqxnzn6p8zf6t9shtq5143",
                "https://lists.debian.org/debian-lts-announce/2021/12/msg00036.html",
                "https://lists.fedoraproject.org/archives/list/package-announce%40lists.fedoraproject.org/message/EVV25FXL4FU5X6X5BSL7RLQ7T6F65MRA/",
                "https://lists.fedoraproject.org/archives/list/package-announce%40lists.fedoraproject.org/message/T57MPJUW3MA6QGWZRTMCHHMMPQNVKGFC/",
                "https://security.netapp.com/advisory/ntap-20220104-0001/",
                "https://tools.cisco.com/security/center/content/CiscoSecurityAdvisory/cisco-sa-apache-log4j-qRuKNEbd",
                "https://www.oracle.com/security-alerts/cpuapr2022.html",
                "https://www.oracle.com/security-alerts/cpujan2022.html",
                "https://www.oracle.com/security-alerts/cpujul2022.html",
                "http://www.openwall.com/lists/oss-security/2021/12/28/1",
                "https://cert-portal.siemens.com/productcert/pdf/ssa-784507.pdf",
                "https://issues.apache.org/jira/browse/LOG4J2-3293",
                "https://lists.apache.org/thread/s1o5vlo78ypqxnzn6p8zf6t9shtq5143",
                "https://lists.debian.org/debian-lts-announce/2021/12/msg00036.html",
                "https://lists.fedoraproject.org/archives/list/package-announce%40lists.fedoraproject.org/message/EVV25FXL4FU5X6X5BSL7RLQ7T6F65MRA/",
                "https://lists.fedoraproject.org/archives/list/package-announce%40lists.fedoraproject.org/message/T57MPJUW3MA6QGWZRTMCHHMMPQNVKGFC/",
                "https://security.netapp.com/advisory/ntap-20220104-0001/",
                "https://tools.cisco.com/security/center/content/CiscoSecurityAdvisory/cisco-sa-apache-log4j-qRuKNEbd",
                "https://www.oracle.com/security-alerts/cpuapr2022.html",
                "https://www.oracle.com/security-alerts/cpujan2022.html",
                "https://www.oracle.com/security-alerts/cpujul2022.html"
              ],
              "description": "Apache Log4j2 versions 2.0-beta7 through 2.17.0 (excluding security fix releases 2.3.2 and 2.12.4) are vulnerable to a remote code execution (RCE) attack when a configuration uses a JDBC Appender with a JNDI LDAP data source URI when an attacker has control of the target LDAP server. This issue is fixed by limiting JNDI data source names to the java protocol in Log4j2 versions 2.17.1, 2.12.4, and 2.3.2.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "2.0",
                  "vector": "AV:N/AC:M/Au:S/C:C/I:C/A:C",
                  "metrics": {
                    "baseScore": 8.5,
                    "exploitabilityScore": 6.8,
                    "impactScore": 10
                  },
                  "vendorMetadata": {}
                },
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:H/PR:H/UI:N/S:U/C:H/I:H/A:H",
                  "metrics": {
                    "baseScore": 6.6,
                    "exploitabilityScore": 0.7,
                    "impactScore": 5.9
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "log4j-core",
                  "version": "2.16.0"
                }
              },
              "found": {
                "versionConstraint": ">=2.13.0,<2.17.1 (unknown)",
                "vulnerabilityID": "GHSA-8489-44mv-ggj8"
              }
            }
          ],
          "artifact": {
            "id": "0e921233df588822",
            "name": "log4j-core",
            "version": "2.16.0",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [
              "cpe:2.3:a:log4j-core:log4j-core:2.16.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j-core:log4j_core:2.16.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j_core:log4j-core:2.16.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j_core:log4j_core:2.16.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j:log4j-core:2.16.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:log4j:log4j_core:2.16.0:*:*:*:*:*:*:*"
            ],
            "purl": "pkg:maven/org.apache.logging.log4j/log4j-core@2.16.0",
            "upstreams": []
          }
        }
      ],
      "source": {
        "type": "unknown",
        "target": "unknown"
      },
      "distro": {
        "name": "",
        "version": "",
        "idLike": null
      },
      "descriptor": {
        "name": "grype",
        "version": "0.86.1",
        "configuration": {
          "output": [
            "json"
          ],
          "file": "",
          "distro": "",
          "add-cpes-if-none": true,
          "output-template-file": "",
          "check-for-app-update": true,
          "only-fixed": false,
          "only-notfixed": false,
          "ignore-wontfix": "",
          "platform": "",
          "search": {
            "scope": "squashed",
            "unindexed-archives": false,
            "indexed-archives": true
          },
          "ignore": [
            {
              "vulnerability": "",
              "reason": "",
              "namespace": "",
              "fix-state": "",
              "package": {
                "name": "kernel-headers",
                "version": "",
                "language": "",
                "type": "rpm",
                "location": "",
                "upstream-name": "kernel"
              },
              "vex-status": "",
              "vex-justification": "",
              "match-type": "exact-indirect-match"
            },
            {
              "vulnerability": "",
              "reason": "",
              "namespace": "",
              "fix-state": "",
              "package": {
                "name": "linux-.*-headers-.*",
                "version": "",
                "language": "",
                "type": "deb",
                "location": "",
                "upstream-name": "linux"
              },
              "vex-status": "",
              "vex-justification": "",
              "match-type": "exact-indirect-match"
            },
            {
              "vulnerability": "",
              "reason": "",
              "namespace": "",
              "fix-state": "",
              "package": {
                "name": "linux-libc-dev",
                "version": "",
                "language": "",
                "type": "deb",
                "location": "",
                "upstream-name": "linux"
              },
              "vex-status": "",
              "vex-justification": "",
              "match-type": "exact-indirect-match"
            }
          ],
          "exclude": [],
          "db": {
            "cache-dir": "/home/ut/.cache/grype/db",
            "update-url": "https://toolbox-data.anchore.io/grype/databases/listing.json",
            "ca-cert": "",
            "auto-update": true,
            "validate-by-hash-on-start": false,
            "validate-age": true,
            "max-allowed-built-age": 432000000000000,
            "require-update-check": false,
            "update-available-timeout": 30000000000,
            "update-download-timeout": 300000000000,
            "max-update-check-frequency": 7200000000000
          },
          "externalSources": {
            "enable": false,
            "maven": {
              "searchUpstreamBySha1": true,
              "baseUrl": "https://search.maven.org/solrsearch/select"
            }
          },
          "match": {
            "java": {
              "using-cpes": false
            },
            "jvm": {
              "using-cpes": true
            },
            "dotnet": {
              "using-cpes": false
            },
            "golang": {
              "using-cpes": false,
              "always-use-cpe-for-stdlib": true,
              "allow-main-module-pseudo-version-comparison": false
            },
            "javascript": {
              "using-cpes": false
            },
            "python": {
              "using-cpes": false
            },
            "ruby": {
              "using-cpes": false
            },
            "rust": {
              "using-cpes": false
            },
            "stock": {
              "using-cpes": true
            }
          },
          "fail-on-severity": "",
          "registry": {
            "insecure-skip-tls-verify": false,
            "insecure-use-http": false,
            "auth": null,
            "ca-cert": ""
          },
          "show-suppressed": false,
          "by-cve": false,
          "name": "",
          "default-image-pull-source": "",
          "vex-documents": [],
          "vex-add": [],
          "match-upstream-kernel-headers": false,
          "exp": {
            "dbv6": false
          }
        },
        "db": {
          "built": "2025-01-15T09:45:46Z",
          "schemaVersion": 5,
          "location": "/home/ut/.cache/grype/db/5",
          "checksum": "sha256:3a19dc29e96b59a126fedd926458c790763127b610ceb29bf6ecaf830bcfafa0",
          "error": null
        },
        "timestamp": "2025-01-15T11:30:54.818841671Z"
      }
    },
    "resolved": false
  },
  {
    "scanId": "SCAN428099A7",
    "timestamp": "16 January 2025",
    "status": "Analyzed",
    "Basic": {
      "Name": "Goinit",
      "Description": "enterprise stack switch",
      "sbomFormat": "cyclonedx",
      "sbomVersion": ""
    },
    "Advanced Settings": {
      "sbomValidate": "",
      "sbomIncludeDevDependencies": ""
    },
    "schedule": {
      "frequency": "",
      "time": "",
      "timezone": ""
    },
    "credentials": {},
    "mainscanType": "SBOM",
    "files": {
      "sbomFile": {
        "filename": "sbom-complex-1737005944515.json",
        "originalName": "sbom-complex.json",
        "storedAt": "sbom-complex-1737005944515.json"
      }
    },
    "analysis": {
      "matches": [
        {
          "vulnerability": {
            "id": "GHSA-rgv9-q543-rqg4",
            "dataSource": "https://github.com/advisories/GHSA-rgv9-q543-rqg4",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-rgv9-q543-rqg4"
            ],
            "description": "Uncontrolled Resource Consumption in FasterXML jackson-databind",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                "metrics": {
                  "baseScore": 7.5,
                  "exploitabilityScore": 3.9,
                  "impactScore": 3.6
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "2.13.4"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2022-42004",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2022-42004",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://bugs.chromium.org/p/oss-fuzz/issues/detail?id=50490",
                "https://github.com/FasterXML/jackson-databind/commit/063183589218fec19a9293ed2f17ec53ea80ba88",
                "https://github.com/FasterXML/jackson-databind/issues/3582",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.gentoo.org/glsa/202210-21",
                "https://security.netapp.com/advisory/ntap-20221118-0008/",
                "https://www.debian.org/security/2022/dsa-5283",
                "https://bugs.chromium.org/p/oss-fuzz/issues/detail?id=50490",
                "https://github.com/FasterXML/jackson-databind/commit/063183589218fec19a9293ed2f17ec53ea80ba88",
                "https://github.com/FasterXML/jackson-databind/issues/3582",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.gentoo.org/glsa/202210-21",
                "https://security.netapp.com/advisory/ntap-20221118-0008/",
                "https://www.debian.org/security/2022/dsa-5283"
              ],
              "description": "In FasterXML jackson-databind before 2.13.4, resource exhaustion can occur because of a lack of a check in BeanDeserializer._deserializeFromArray to prevent use of deeply nested arrays. An application is vulnerable only with certain customized choices for deserialization.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                  "metrics": {
                    "baseScore": 7.5,
                    "exploitabilityScore": 3.9,
                    "impactScore": 3.6
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "jackson-databind",
                  "version": "2.13.0"
                }
              },
              "found": {
                "versionConstraint": ">=2.13.0,<2.13.4 (unknown)",
                "vulnerabilityID": "GHSA-rgv9-q543-rqg4"
              }
            }
          ],
          "artifact": {
            "id": "ce3eae9514ee480b",
            "name": "jackson-databind",
            "version": "2.13.0",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [
              "cpe:2.3:a:jackson-databind:jackson-databind:2.13.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:jackson-databind:jackson_databind:2.13.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:jackson_databind:jackson-databind:2.13.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:jackson_databind:jackson_databind:2.13.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:jackson:jackson-databind:2.13.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:jackson:jackson_databind:2.13.0:*:*:*:*:*:*:*"
            ],
            "purl": "pkg:maven/com.fasterxml.jackson.core/jackson-databind@2.13.0",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-jjjh-jjxp-wpff",
            "dataSource": "https://github.com/advisories/GHSA-jjjh-jjxp-wpff",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-jjjh-jjxp-wpff"
            ],
            "description": "Uncontrolled Resource Consumption in Jackson-databind",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                "metrics": {
                  "baseScore": 7.5,
                  "exploitabilityScore": 3.9,
                  "impactScore": 3.6
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "2.13.4.2"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2022-42003",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2022-42003",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://bugs.chromium.org/p/oss-fuzz/issues/detail?id=51020",
                "https://github.com/FasterXML/jackson-databind/commit/d78d00ee7b5245b93103fef3187f70543d67ca33",
                "https://github.com/FasterXML/jackson-databind/issues/3590",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.gentoo.org/glsa/202210-21",
                "https://security.netapp.com/advisory/ntap-20221124-0004/",
                "https://www.debian.org/security/2022/dsa-5283",
                "https://bugs.chromium.org/p/oss-fuzz/issues/detail?id=51020",
                "https://github.com/FasterXML/jackson-databind/commit/d78d00ee7b5245b93103fef3187f70543d67ca33",
                "https://github.com/FasterXML/jackson-databind/issues/3590",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.gentoo.org/glsa/202210-21",
                "https://security.netapp.com/advisory/ntap-20221124-0004/",
                "https://www.debian.org/security/2022/dsa-5283"
              ],
              "description": "In FasterXML jackson-databind before versions 2.13.4.1 and 2.12.17.1, resource exhaustion can occur because of a lack of a check in primitive value deserializers to avoid deep wrapper array nesting, when the UNWRAP_SINGLE_VALUE_ARRAYS feature is enabled.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                  "metrics": {
                    "baseScore": 7.5,
                    "exploitabilityScore": 3.9,
                    "impactScore": 3.6
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "jackson-databind",
                  "version": "2.13.0"
                }
              },
              "found": {
                "versionConstraint": ">=2.13.0,<2.13.4.2 (unknown)",
                "vulnerabilityID": "GHSA-jjjh-jjxp-wpff"
              }
            }
          ],
          "artifact": {
            "id": "ce3eae9514ee480b",
            "name": "jackson-databind",
            "version": "2.13.0",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [
              "cpe:2.3:a:jackson-databind:jackson-databind:2.13.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:jackson-databind:jackson_databind:2.13.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:jackson_databind:jackson-databind:2.13.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:jackson_databind:jackson_databind:2.13.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:jackson:jackson-databind:2.13.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:jackson:jackson_databind:2.13.0:*:*:*:*:*:*:*"
            ],
            "purl": "pkg:maven/com.fasterxml.jackson.core/jackson-databind@2.13.0",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-57j2-w4cx-62h2",
            "dataSource": "https://github.com/advisories/GHSA-57j2-w4cx-62h2",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-57j2-w4cx-62h2"
            ],
            "description": "Deeply nested json in jackson-databind",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                "metrics": {
                  "baseScore": 7.5,
                  "exploitabilityScore": 3.9,
                  "impactScore": 3.6
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "2.13.2.1"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2020-36518",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2020-36518",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://github.com/FasterXML/jackson-databind/issues/2816",
                "https://lists.debian.org/debian-lts-announce/2022/05/msg00001.html",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.netapp.com/advisory/ntap-20220506-0004/",
                "https://www.debian.org/security/2022/dsa-5283",
                "https://www.oracle.com/security-alerts/cpuapr2022.html",
                "https://www.oracle.com/security-alerts/cpujul2022.html",
                "https://github.com/FasterXML/jackson-databind/issues/2816",
                "https://lists.debian.org/debian-lts-announce/2022/05/msg00001.html",
                "https://lists.debian.org/debian-lts-announce/2022/11/msg00035.html",
                "https://security.netapp.com/advisory/ntap-20220506-0004/",
                "https://www.debian.org/security/2022/dsa-5283",
                "https://www.oracle.com/security-alerts/cpuapr2022.html",
                "https://www.oracle.com/security-alerts/cpujul2022.html"
              ],
              "description": "jackson-databind before 2.13.0 allows a Java StackOverflow exception and denial of service via a large depth of nested objects.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "2.0",
                  "vector": "AV:N/AC:L/Au:N/C:N/I:N/A:P",
                  "metrics": {
                    "baseScore": 5,
                    "exploitabilityScore": 10,
                    "impactScore": 2.9
                  },
                  "vendorMetadata": {}
                },
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                  "metrics": {
                    "baseScore": 7.5,
                    "exploitabilityScore": 3.9,
                    "impactScore": 3.6
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "jackson-databind",
                  "version": "2.13.0"
                }
              },
              "found": {
                "versionConstraint": ">=2.13.0,<=2.13.2.0 (unknown)",
                "vulnerabilityID": "GHSA-57j2-w4cx-62h2"
              }
            }
          ],
          "artifact": {
            "id": "ce3eae9514ee480b",
            "name": "jackson-databind",
            "version": "2.13.0",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [
              "cpe:2.3:a:jackson-databind:jackson-databind:2.13.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:jackson-databind:jackson_databind:2.13.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:jackson_databind:jackson-databind:2.13.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:jackson_databind:jackson_databind:2.13.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:jackson:jackson-databind:2.13.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:jackson:jackson_databind:2.13.0:*:*:*:*:*:*:*"
            ],
            "purl": "pkg:maven/com.fasterxml.jackson.core/jackson-databind@2.13.0",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-3x8x-79m2-3w2w",
            "dataSource": "https://github.com/advisories/GHSA-3x8x-79m2-3w2w",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-3x8x-79m2-3w2w"
            ],
            "description": "jackson-databind possible Denial of Service if using JDK serialization to serialize JsonNode",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                "metrics": {
                  "baseScore": 7.5,
                  "exploitabilityScore": 3.9,
                  "impactScore": 3.6
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "2.13.1"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2021-46877",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2021-46877",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://github.com/FasterXML/jackson-databind/issues/3328",
                "https://groups.google.com/g/jackson-user/c/OsBsirPM_Vw",
                "https://github.com/FasterXML/jackson-databind/issues/3328",
                "https://groups.google.com/g/jackson-user/c/OsBsirPM_Vw"
              ],
              "description": "jackson-databind 2.10.x through 2.12.x before 2.12.6 and 2.13.x before 2.13.1 allows attackers to cause a denial of service (2 GB transient heap usage per read) in uncommon situations involving JsonNode JDK serialization.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:H",
                  "metrics": {
                    "baseScore": 7.5,
                    "exploitabilityScore": 3.9,
                    "impactScore": 3.6
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "jackson-databind",
                  "version": "2.13.0"
                }
              },
              "found": {
                "versionConstraint": ">=2.13.0,<2.13.1 (unknown)",
                "vulnerabilityID": "GHSA-3x8x-79m2-3w2w"
              }
            }
          ],
          "artifact": {
            "id": "ce3eae9514ee480b",
            "name": "jackson-databind",
            "version": "2.13.0",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [
              "cpe:2.3:a:jackson-databind:jackson-databind:2.13.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:jackson-databind:jackson_databind:2.13.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:jackson_databind:jackson-databind:2.13.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:jackson_databind:jackson_databind:2.13.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:jackson:jackson-databind:2.13.0:*:*:*:*:*:*:*",
              "cpe:2.3:a:jackson:jackson_databind:2.13.0:*:*:*:*:*:*:*"
            ],
            "purl": "pkg:maven/com.fasterxml.jackson.core/jackson-databind@2.13.0",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-4wrc-f8pq-fpqp",
            "dataSource": "https://github.com/advisories/GHSA-4wrc-f8pq-fpqp",
            "namespace": "github:language:java",
            "severity": "Critical",
            "urls": [
              "https://github.com/advisories/GHSA-4wrc-f8pq-fpqp"
            ],
            "description": "Pivotal Spring Framework contains unsafe Java deserialization methods",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:H/I:H/A:H",
                "metrics": {
                  "baseScore": 9.8,
                  "exploitabilityScore": 3.9,
                  "impactScore": 5.9
                },
                "vendorMetadata": {
                  "base_severity": "Critical",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "6.0.0"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2016-1000027",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2016-1000027",
              "namespace": "nvd:cpe",
              "severity": "Critical",
              "urls": [
                "https://bugzilla.redhat.com/show_bug.cgi?id=CVE-2016-1000027",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-579669626",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-582313417",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-744519525",
                "https://raw.githubusercontent.com/distributedweaknessfiling/cvelist/master/2016/1000xxx/CVE-2016-1000027.json",
                "https://security-tracker.debian.org/tracker/CVE-2016-1000027",
                "https://security.netapp.com/advisory/ntap-20230420-0009/",
                "https://spring.io/blog/2022/05/11/spring-framework-5-3-20-and-5-2-22-available-now",
                "https://www.tenable.com/security/research/tra-2016-20",
                "https://bugzilla.redhat.com/show_bug.cgi?id=CVE-2016-1000027",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-579669626",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-582313417",
                "https://github.com/spring-projects/spring-framework/issues/24434#issuecomment-744519525",
                "https://raw.githubusercontent.com/distributedweaknessfiling/cvelist/master/2016/1000xxx/CVE-2016-1000027.json",
                "https://security-tracker.debian.org/tracker/CVE-2016-1000027",
                "https://security.netapp.com/advisory/ntap-20230420-0009/",
                "https://spring.io/blog/2022/05/11/spring-framework-5-3-20-and-5-2-22-available-now",
                "https://www.tenable.com/security/research/tra-2016-20"
              ],
              "description": "Pivotal Spring Framework through 5.3.16 suffers from a potential remote code execution (RCE) issue if used for Java deserialization of untrusted data. Depending on how the library is implemented within a product, this issue may or not occur, and authentication may be required. NOTE: the vendor's position is that untrusted data is not an intended use case. The product's behavior will not be changed because some users rely on deserialization of trusted data.",
              "cvss": [
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "2.0",
                  "vector": "AV:N/AC:L/Au:N/C:P/I:P/A:P",
                  "metrics": {
                    "baseScore": 7.5,
                    "exploitabilityScore": 10,
                    "impactScore": 6.4
                  },
                  "vendorMetadata": {}
                },
                {
                  "source": "nvd@nist.gov",
                  "type": "Primary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:H/I:H/A:H",
                  "metrics": {
                    "baseScore": 9.8,
                    "exploitabilityScore": 3.9,
                    "impactScore": 5.9
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "spring-web",
                  "version": "5.3.10"
                }
              },
              "found": {
                "versionConstraint": "<6.0.0 (unknown)",
                "vulnerabilityID": "GHSA-4wrc-f8pq-fpqp"
              }
            }
          ],
          "artifact": {
            "id": "d9fe63f0bf4a4200",
            "name": "spring-web",
            "version": "5.3.10",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [
              "cpe:2.3:a:spring-web:spring-web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring-web:spring_web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring_web:spring-web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring_web:spring_web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring:spring-web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring:spring_web:5.3.10:*:*:*:*:*:*:*"
            ],
            "purl": "pkg:maven/org.springframework/spring-web@5.3.10",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-hgjh-9rj2-g67j",
            "dataSource": "https://github.com/advisories/GHSA-hgjh-9rj2-g67j",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-hgjh-9rj2-g67j"
            ],
            "description": "Spring Framework URL Parsing with Host Validation Vulnerability",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                "metrics": {
                  "baseScore": 8.1,
                  "exploitabilityScore": 2.8,
                  "impactScore": 5.2
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "5.3.33"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2024-22259",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2024-22259",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://security.netapp.com/advisory/ntap-20240524-0002/",
                "https://spring.io/security/cve-2024-22259",
                "https://security.netapp.com/advisory/ntap-20240524-0002/",
                "https://spring.io/security/cve-2024-22259"
              ],
              "description": "Applications that use UriComponentsBuilder in Spring Framework to parse an externally provided URL (e.g. through a query parameter) AND perform validation checks on the host of the parsed URL may be vulnerable to a  open redirect https://cwe.mitre.org/data/definitions/601.html  attack or to a SSRF attack if the URL is used after passing validation checks.\n\nThis is the same as  CVE-2024-22243 https://spring.io/security/cve-2024-22243 , but with different input.\n\n",
              "cvss": [
                {
                  "source": "security@vmware.com",
                  "type": "Secondary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                  "metrics": {
                    "baseScore": 8.1,
                    "exploitabilityScore": 2.8,
                    "impactScore": 5.2
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "spring-web",
                  "version": "5.3.10"
                }
              },
              "found": {
                "versionConstraint": "<5.3.33 (unknown)",
                "vulnerabilityID": "GHSA-hgjh-9rj2-g67j"
              }
            }
          ],
          "artifact": {
            "id": "d9fe63f0bf4a4200",
            "name": "spring-web",
            "version": "5.3.10",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [
              "cpe:2.3:a:spring-web:spring-web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring-web:spring_web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring_web:spring-web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring_web:spring_web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring:spring-web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring:spring_web:5.3.10:*:*:*:*:*:*:*"
            ],
            "purl": "pkg:maven/org.springframework/spring-web@5.3.10",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-ccgv-vj62-xf9h",
            "dataSource": "https://github.com/advisories/GHSA-ccgv-vj62-xf9h",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-ccgv-vj62-xf9h"
            ],
            "description": "Spring Web vulnerable to Open Redirect or Server Side Request Forgery",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                "metrics": {
                  "baseScore": 8.1,
                  "exploitabilityScore": 2.8,
                  "impactScore": 5.2
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "5.3.32"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2024-22243",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2024-22243",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://security.netapp.com/advisory/ntap-20240524-0001/",
                "https://spring.io/security/cve-2024-22243",
                "http://seclists.org/fulldisclosure/2024/Sep/24",
                "https://security.netapp.com/advisory/ntap-20240524-0001/",
                "https://spring.io/security/cve-2024-22243"
              ],
              "description": "Applications that use UriComponentsBuilder to parse an externally provided URL (e.g. through a query parameter) AND perform validation checks on the host of the parsed URL may be vulnerable to a  open redirect https://cwe.mitre.org/data/definitions/601.html  attack or to a SSRF attack if the URL is used after passing validation checks.\n",
              "cvss": [
                {
                  "source": "security@vmware.com",
                  "type": "Secondary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                  "metrics": {
                    "baseScore": 8.1,
                    "exploitabilityScore": 2.8,
                    "impactScore": 5.2
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "spring-web",
                  "version": "5.3.10"
                }
              },
              "found": {
                "versionConstraint": ">=5.3.0,<5.3.32 (unknown)",
                "vulnerabilityID": "GHSA-ccgv-vj62-xf9h"
              }
            }
          ],
          "artifact": {
            "id": "d9fe63f0bf4a4200",
            "name": "spring-web",
            "version": "5.3.10",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [
              "cpe:2.3:a:spring-web:spring-web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring-web:spring_web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring_web:spring-web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring_web:spring_web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring:spring-web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring:spring_web:5.3.10:*:*:*:*:*:*:*"
            ],
            "purl": "pkg:maven/org.springframework/spring-web@5.3.10",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-2wrp-6fg6-hmc5",
            "dataSource": "https://github.com/advisories/GHSA-2wrp-6fg6-hmc5",
            "namespace": "github:language:java",
            "severity": "High",
            "urls": [
              "https://github.com/advisories/GHSA-2wrp-6fg6-hmc5"
            ],
            "description": "Spring Framework URL Parsing with Host Validation",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                "metrics": {
                  "baseScore": 8.1,
                  "exploitabilityScore": 2.8,
                  "impactScore": 5.2
                },
                "vendorMetadata": {
                  "base_severity": "High",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "5.3.34"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2024-22262",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2024-22262",
              "namespace": "nvd:cpe",
              "severity": "High",
              "urls": [
                "https://security.netapp.com/advisory/ntap-20240524-0003/",
                "https://spring.io/security/cve-2024-22262",
                "https://security.netapp.com/advisory/ntap-20240524-0003/",
                "https://spring.io/security/cve-2024-22262"
              ],
              "description": "Applications that use UriComponentsBuilder to parse an externally provided URL (e.g. through a query parameter) AND perform validation checks on the host of the parsed URL may be vulnerable to a  open redirect https://cwe.mitre.org/data/definitions/601.html  attack or to a SSRF attack if the URL is used after passing validation checks.\n\nThis is the same as  CVE-2024-22259 https://spring.io/security/cve-2024-22259  and  CVE-2024-22243 https://spring.io/security/cve-2024-22243 , but with different input.\n\n",
              "cvss": [
                {
                  "source": "security@vmware.com",
                  "type": "Secondary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:R/S:U/C:H/I:H/A:N",
                  "metrics": {
                    "baseScore": 8.1,
                    "exploitabilityScore": 2.8,
                    "impactScore": 5.2
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "spring-web",
                  "version": "5.3.10"
                }
              },
              "found": {
                "versionConstraint": "<5.3.34 (unknown)",
                "vulnerabilityID": "GHSA-2wrp-6fg6-hmc5"
              }
            }
          ],
          "artifact": {
            "id": "d9fe63f0bf4a4200",
            "name": "spring-web",
            "version": "5.3.10",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [
              "cpe:2.3:a:spring-web:spring-web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring-web:spring_web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring_web:spring-web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring_web:spring_web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring:spring-web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring:spring_web:5.3.10:*:*:*:*:*:*:*"
            ],
            "purl": "pkg:maven/org.springframework/spring-web@5.3.10",
            "upstreams": []
          }
        },
        {
          "vulnerability": {
            "id": "GHSA-2rmj-mq67-h97g",
            "dataSource": "https://github.com/advisories/GHSA-2rmj-mq67-h97g",
            "namespace": "github:language:java",
            "severity": "Medium",
            "urls": [
              "https://github.com/advisories/GHSA-2rmj-mq67-h97g"
            ],
            "description": "Spring Framework DoS via conditional HTTP request",
            "cvss": [
              {
                "version": "3.1",
                "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:L",
                "metrics": {
                  "baseScore": 5.3,
                  "exploitabilityScore": 3.9,
                  "impactScore": 1.4
                },
                "vendorMetadata": {
                  "base_severity": "Medium",
                  "status": "N/A"
                }
              }
            ],
            "fix": {
              "versions": [
                "5.3.38"
              ],
              "state": "fixed"
            },
            "advisories": []
          },
          "relatedVulnerabilities": [
            {
              "id": "CVE-2024-38809",
              "dataSource": "https://nvd.nist.gov/vuln/detail/CVE-2024-38809",
              "namespace": "nvd:cpe",
              "severity": "Medium",
              "urls": [
                "https://spring.io/security/cve-2024-38809",
                "https://security.netapp.com/advisory/ntap-20240920-0003/"
              ],
              "description": "Applications that parse ETags from \"If-Match\" or \"If-None-Match\" request headers are vulnerable to DoS attack.\n\nUsers of affected versions should upgrade to the corresponding fixed version.\n\nUsers of older, unsupported versions could enforce a size limit on \"If-Match\" and \"If-None-Match\" headers, e.g. through a Filter.",
              "cvss": [
                {
                  "source": "security@vmware.com",
                  "type": "Secondary",
                  "version": "3.1",
                  "vector": "CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:L",
                  "metrics": {
                    "baseScore": 5.3,
                    "exploitabilityScore": 3.9,
                    "impactScore": 1.4
                  },
                  "vendorMetadata": {}
                }
              ]
            }
          ],
          "matchDetails": [
            {
              "type": "exact-direct-match",
              "matcher": "java-matcher",
              "searchedBy": {
                "language": "java",
                "namespace": "github:language:java",
                "package": {
                  "name": "spring-web",
                  "version": "5.3.10"
                }
              },
              "found": {
                "versionConstraint": "<5.3.38 (unknown)",
                "vulnerabilityID": "GHSA-2rmj-mq67-h97g"
              }
            }
          ],
          "artifact": {
            "id": "d9fe63f0bf4a4200",
            "name": "spring-web",
            "version": "5.3.10",
            "type": "java-archive",
            "locations": [],
            "language": "java",
            "licenses": [
              "Apache-2.0"
            ],
            "cpes": [
              "cpe:2.3:a:spring-web:spring-web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring-web:spring_web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring_web:spring-web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring_web:spring_web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring:spring-web:5.3.10:*:*:*:*:*:*:*",
              "cpe:2.3:a:spring:spring_web:5.3.10:*:*:*:*:*:*:*"
            ],
            "purl": "pkg:maven/org.springframework/spring-web@5.3.10",
            "upstreams": []
          }
        }
      ],
      "source": {
        "type": "unknown",
        "target": "unknown"
      },
      "distro": {
        "name": "Ubuntu",
        "version": "22.04",
        "idLike": [
          "Ubuntu"
        ]
      },
      "descriptor": {
        "name": "grype",
        "version": "0.86.1",
        "configuration": {
          "output": [
            "json"
          ],
          "file": "",
          "distro": "",
          "add-cpes-if-none": true,
          "output-template-file": "",
          "check-for-app-update": true,
          "only-fixed": false,
          "only-notfixed": false,
          "ignore-wontfix": "",
          "platform": "",
          "search": {
            "scope": "squashed",
            "unindexed-archives": false,
            "indexed-archives": true
          },
          "ignore": [
            {
              "vulnerability": "",
              "reason": "",
              "namespace": "",
              "fix-state": "",
              "package": {
                "name": "kernel-headers",
                "version": "",
                "language": "",
                "type": "rpm",
                "location": "",
                "upstream-name": "kernel"
              },
              "vex-status": "",
              "vex-justification": "",
              "match-type": "exact-indirect-match"
            },
            {
              "vulnerability": "",
              "reason": "",
              "namespace": "",
              "fix-state": "",
              "package": {
                "name": "linux-.*-headers-.*",
                "version": "",
                "language": "",
                "type": "deb",
                "location": "",
                "upstream-name": "linux"
              },
              "vex-status": "",
              "vex-justification": "",
              "match-type": "exact-indirect-match"
            },
            {
              "vulnerability": "",
              "reason": "",
              "namespace": "",
              "fix-state": "",
              "package": {
                "name": "linux-libc-dev",
                "version": "",
                "language": "",
                "type": "deb",
                "location": "",
                "upstream-name": "linux"
              },
              "vex-status": "",
              "vex-justification": "",
              "match-type": "exact-indirect-match"
            }
          ],
          "exclude": [],
          "db": {
            "cache-dir": "/home/ut/.cache/grype/db",
            "update-url": "https://toolbox-data.anchore.io/grype/databases/listing.json",
            "ca-cert": "",
            "auto-update": true,
            "validate-by-hash-on-start": false,
            "validate-age": true,
            "max-allowed-built-age": 432000000000000,
            "require-update-check": false,
            "update-available-timeout": 30000000000,
            "update-download-timeout": 300000000000,
            "max-update-check-frequency": 7200000000000
          },
          "externalSources": {
            "enable": false,
            "maven": {
              "searchUpstreamBySha1": true,
              "baseUrl": "https://search.maven.org/solrsearch/select"
            }
          },
          "match": {
            "java": {
              "using-cpes": false
            },
            "jvm": {
              "using-cpes": true
            },
            "dotnet": {
              "using-cpes": false
            },
            "golang": {
              "using-cpes": false,
              "always-use-cpe-for-stdlib": true,
              "allow-main-module-pseudo-version-comparison": false
            },
            "javascript": {
              "using-cpes": false
            },
            "python": {
              "using-cpes": false
            },
            "ruby": {
              "using-cpes": false
            },
            "rust": {
              "using-cpes": false
            },
            "stock": {
              "using-cpes": true
            }
          },
          "fail-on-severity": "",
          "registry": {
            "insecure-skip-tls-verify": false,
            "insecure-use-http": false,
            "auth": null,
            "ca-cert": ""
          },
          "show-suppressed": false,
          "by-cve": false,
          "name": "",
          "default-image-pull-source": "",
          "vex-documents": [],
          "vex-add": [],
          "match-upstream-kernel-headers": false,
          "exp": {
            "dbv6": false
          }
        },
        "db": {
          "built": "2025-01-16T01:30:59Z",
          "schemaVersion": 5,
          "location": "/home/ut/.cache/grype/db/5",
          "checksum": "sha256:4b61841839558cfeee5d5e5005c2a0e801cab036f902da88b2401774388f3aa5",
          "error": null
        },
        "timestamp": "2025-01-16T05:39:56.897600248Z"
      }
    },
    "resolved": false
  },
  {
    "scanId": "SCANF1C1D47A",
    "timestamp": "17 January 2025",
    "status": "Analyzed",
    "Basic": {
      "Name": "edugenie labs",
      "Description": "LMS ",
      "target": "edugenielabs.com",
      "scanType": ""
    },
    "schedule": {
      "frequency": "",
      "time": "",
      "timezone": ""
    },
    "credentials": {},
    "mainscanType": "basic",
    "files": {},
    "resolved": false,
    "vulnerabilities": {
      "edugenielabs.com": [
        {
          "name": "HTTP Server Type and Version",
          "protocol": "tcp",
          "cvss": 0,
          "port": 80,
          "synopsis": "An HTTP web server is detected on the remote host, indicating potential points of network exposure.",
          "description": "This assessment identifies the type and version of the remote HTTP web server.  Knowing this information is crucial for understanding potential vulnerabilities and implementing appropriate security measures.  Version identification allows for targeted security patching and mitigation strategies.",
          "solution": "Implement a robust vulnerability management program that includes regular patching and updates of the web server software.  Consider implementing a web application firewall (WAF) to mitigate potential attacks. Regularly review security logs for suspicious activity.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "IAVT:0001-T-0931",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HTTP Server Type and Version",
          "protocol": "tcp",
          "cvss": 0,
          "port": 443,
          "synopsis": "An HTTPS web server is detected on the remote host.  Further analysis is needed to identify the specific server software and version.",
          "description": "This assessment identifies the presence of an HTTPS web server.  Determining the specific server software and version is crucial for identifying potential vulnerabilities and implementing appropriate security measures.  The lack of version information prevents a precise security risk assessment.",
          "solution": "Implement a comprehensive vulnerability management program to regularly scan for and address vulnerabilities in web server software.  Maintain up-to-date patching and configuration best practices.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "IAVT:0001-T-0931",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "ICMP Timestamp Request Remote Date Disclosure",
          "protocol": "icmp",
          "cvss": 0,
          "port": 0,
          "synopsis": "Exploitation of ICMP timestamp requests can reveal the remote host's system time.",
          "description": "The remote host responds to ICMP timestamp requests (type 13), providing the attacker with the system time. This information could aid in bypassing time-based authentication mechanisms or other security controls that rely on accurate time synchronization. While systems such as Windows Vista, 7, 2008, and 2008 R2 may return timestamps that deviate from the actual system time, these inaccuracies are typically within 1000 seconds. This level of imprecision may still allow an attacker to make inferences about the system time.",
          "solution": "Implement network filtering to block ICMP timestamp requests (type 13) and replies (type 14) at the network perimeter or host level. This prevents the remote host from participating in this type of information disclosure.",
          "risk_factor": "Low",
          "cve": "CVE-1999-0524",
          "bid": "",
          "xref": "CWE:200",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSH Server Type and Version Information",
          "protocol": "tcp",
          "cvss": 0,
          "port": 22,
          "synopsis": "An SSH server is listening on port 22.  This indicates a potential entry point for unauthorized access.",
          "description": "Passive reconnaissance techniques may reveal information about the remote SSH server's configuration and version.  An empty authentication request can elicit a response that may contain version information, potentially revealing vulnerabilities or outdated software.",
          "solution": "Implement strong network segmentation and access controls to limit access to the SSH server. Regularly review and update SSH server software to address known vulnerabilities. Utilize strong authentication methods such as public key authentication to prevent unauthorized login attempts. Regularly audit SSH server logs for suspicious activities.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "IAVT:0001-T-0933",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Traceroute Information",
          "protocol": "udp",
          "cvss": 0,
          "port": 0,
          "synopsis": "Network reconnaissance via traceroute was successful.",
          "description": "An attacker was able to perform a traceroute to the target host, potentially revealing network topology information including intermediate hops and their associated network addresses.  This information could be used to plan further attacks or gain insights into network infrastructure.",
          "solution": "Implement network segmentation and access controls to limit the visibility of internal network infrastructure.  Consider using network monitoring tools to detect unauthorized traceroute attempts.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Web Server robots.txt Information Disclosure",
          "protocol": "tcp",
          "cvss": 0,
          "port": 80,
          "synopsis": "A 'robots.txt' file is present on the remote web server.",
          "description": "The presence of a 'robots.txt' file indicates that the web server utilizes a standard mechanism to control web crawler access to specific directories or files.  However, the contents of this file may inadvertently reveal information about the website's structure and potentially sensitive resources.  A malicious actor could exploit this information to identify targets for further attacks, such as directory traversal or unauthorized data retrieval.  This disclosure might indicate a lack of comprehensive access control measures beyond the 'robots.txt' file.",
          "solution": "Implement a robust access control strategy. This includes regularly reviewing the contents of the 'robots.txt' file for unintended disclosures. Consider using alternative mechanisms like HTTP authentication or authorization to restrict access to sensitive resources, rather than relying solely on 'robots.txt'. Evaluate the necessity of each directory or file listed within the 'robots.txt' file;  remove entries that are unnecessary and enhance security posture.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Web Server No 404 Error Code Check",
          "protocol": "tcp",
          "cvss": 0,
          "port": 80,
          "synopsis": "The remote web server does not return standard 404 error codes for nonexistent resources.",
          "description": "The web server's response to requests for nonexistent files or resources deviates from the expected HTTP 404 (Not Found) error code. Instead of a 404 response, the server might return a site map, search page, or authentication page. This behavior could potentially provide unintended information disclosure or facilitate certain types of attacks. While some mitigation attempts may be in place, their effectiveness cannot be guaranteed, especially under high-volume attack conditions.  An inaccurate assessment of vulnerabilities is possible if a high number of issues are reported for this port.",
          "solution": "Implement proper error handling to ensure that the web server consistently returns a 404 Not Found response for all requests targeting nonexistent resources.  Review server configuration and application logic to identify and correct the source of the unexpected response.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Web Server No 404 Error Code Check",
          "protocol": "tcp",
          "cvss": 0,
          "port": 443,
          "synopsis": "The remote web server does not return standard 404 error codes for non-existent resources.",
          "description": "The web server's response to requests for non-existent files or resources deviates from the expected HTTP 404 Not Found response.  Instead of returning a 404 error, the server might return a different response, such as a sitemap, search results page, or authentication prompt. This behavior could potentially mask the true existence of vulnerabilities or provide unintended information disclosure. While mitigations have been attempted, their efficacy is not guaranteed, and a large number of potential security issues reported for this port may indicate inaccuracies in detection.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "MySQL Server Detection",
          "protocol": "tcp",
          "cvss": 0,
          "port": 3306,
          "synopsis": "A database server instance is listening on TCP port 3306, indicating potential exposure.",
          "description": "The remote host is responding to TCP port 3306, the default port for the MySQL relational database management system.  This suggests a MySQL server is running and potentially accessible from the network.",
          "solution": "Restrict network access to port 3306 to authorized users and systems only.  Implement strong authentication and authorization mechanisms, including robust password policies and potentially multi-factor authentication. Regularly review and update MySQL configurations and security settings.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "IAVT:0001-T-0802",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Information",
          "protocol": "tcp",
          "cvss": 0,
          "port": 443,
          "synopsis": "This module retrieves and analyzes SSL/TLS certificates.",
          "description": "This module establishes a connection to ports utilizing the SSL/TLS protocol (typically port 443) and attempts to extract and display the associated X.509 certificate details. This allows for inspection of certificate validity, issuer, subject, and other relevant cryptographic properties.",
          "solution": "Regularly review and update SSL/TLS certificates to ensure they are valid and appropriately configured.  Implement certificate pinning where appropriate to prevent man-in-the-middle attacks.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSH Protocol Versions Supported",
          "protocol": "tcp",
          "cvss": 0,
          "port": 22,
          "synopsis": "An SSH server is detected on the remote host.",
          "description": "This assessment identifies the SSH protocol versions supported by the remote SSH daemon.  Knowledge of supported versions allows for targeted security analysis and potential vulnerability assessment.",
          "solution": "Implement a policy to restrict supported SSH protocol versions to the most secure options available and regularly update the SSH server software.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection (HELP Request)",
          "protocol": "tcp",
          "cvss": 0,
          "port": 3306,
          "synopsis": "Remote service identification via banner grabbing or error message analysis.",
          "description": "The remote service was identified through analysis of its response to a 'HELP' request. This was achieved either by examining the service banner or by interpreting the error message returned upon sending the request.  This indicates a lack of robust input validation or error handling on the remote system.",
          "solution": "Implement robust input validation to prevent unauthorized service detection attempts and consider masking or removing sensitive information from error messages.  Enhance logging to monitor and detect suspicious activity.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SYN scanner",
          "protocol": "tcp",
          "cvss": 0,
          "port": 22,
          "synopsis": "Detection of open TCP ports is possible.",
          "description": "This plugin utilizes a SYN (half-open) TCP scan to identify open ports. This method offers a relatively low detection footprint compared to a full TCP connect scan, making it less likely to trigger alerts on well-configured systems. However,  SYN scans can still overload less robust firewalls or leave incomplete connections on the target if the network is congested.  The incomplete connection is because the TCP three-way handshake is not completed.",
          "solution": "Implement network-based intrusion detection and prevention systems (NIDPS/NIPS) with appropriate rules to filter and block unauthorized SYN scans.  Additionally, robust firewall configuration is essential to mitigate potential impacts.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SYN scanner",
          "protocol": "tcp",
          "cvss": 0,
          "port": 80,
          "synopsis": "Identification of open TCP ports is possible using this technique.",
          "description": "This technique employs a SYN scan, also known as a half-open scan, to determine which TCP ports are open on a target system.  It is designed for speed, even when encountering network firewalls.  While less intrusive than a full TCP connect scan on unresponsive services, SYN scans can potentially overload less robust firewalls or leave lingering half-open connections on the target, especially under high network load.  This behavior is due to the incomplete three-way handshake.",
          "solution": "Implement network-level ingress filtering to restrict inbound TCP connections to only necessary ports.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SYN scanner",
          "protocol": "tcp",
          "cvss": 0,
          "port": 443,
          "synopsis": "Detection of open TCP ports is possible using network scanning techniques.",
          "description": "This technique employs a TCP SYN scan, also known as a half-open scan.  This method is relatively fast, even against systems protected by firewalls.  While less intrusive than a full TCP connect scan against malfunctioning services, SYN scans can still disrupt less robust firewalls and may leave half-open connections on a heavily loaded target system, potentially impacting network performance.",
          "solution": "Implement network-based access control lists (ACLs) to restrict inbound connections to only necessary ports and services.  Employ intrusion detection/prevention systems (IDS/IPS) to monitor for and mitigate malicious scanning activity.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SYN scanner",
          "protocol": "tcp",
          "cvss": 0,
          "port": 2000,
          "synopsis": "A SYN scan can reveal open TCP ports on a target system.",
          "description": "This technique employs a TCP SYN scan, also known as a half-open scan.  It is designed for relatively rapid port enumeration, even against systems behind firewalls.  While less intrusive than a full TCP connect scan when encountering unresponsive services, SYN scans can still potentially overload less robust firewalls or leave lingering half-open connections on the target system under high network load. This can lead to resource exhaustion on the target.",
          "solution": "Implement network-level access controls, such as firewalls or intrusion prevention systems, to restrict unauthorized network access to the target system.  Consider implementing rate limiting to mitigate the impact of potential SYN scan attacks.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SYN scanner",
          "protocol": "tcp",
          "cvss": 0,
          "port": 3306,
          "synopsis": "Detection of open TCP ports using SYN scans.",
          "description": "This technique employs a SYN scan, also known as a half-open scan, to identify open TCP ports on a target system.  This method is relatively fast, even against systems protected by firewalls.  While less intrusive than a full TCP connect scan,  SYN scans can still impact less robust firewalls or overloaded networks by potentially leaving incomplete connection attempts unclosed.",
          "solution": "Implement network-level access controls, such as firewalls or intrusion detection/prevention systems, to restrict unauthorized port access.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SYN scanner",
          "protocol": "tcp",
          "cvss": 0,
          "port": 5060,
          "synopsis": "Remote hosts may attempt to identify open TCP ports using SYN scans.",
          "description": "This technique employs a TCP SYN scan (also known as a half-open scan) to determine which TCP ports on a target system are open.  SYN scans are generally faster than full TCP connect scans, even against systems protected by firewalls.  However, while less intrusive than a full connection scan, they can still overload less robust firewalls or leave half-open connections on the target if network conditions are congested.  These partially established connections consume resources on the target and may impact performance.",
          "solution": "Implement robust network-level filtering to restrict unauthorized TCP port scanning activity.  Employ intrusion detection/prevention systems (IDS/IPS) to monitor and block malicious scanning attempts.  Regularly review and update firewall rules to ensure they are effectively mitigating unauthorized access attempts.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "OS Identification",
          "protocol": "tcp",
          "cvss": 0,
          "port": 0,
          "synopsis": "Inference of the remote operating system is possible.",
          "description": "Network probing techniques targeting various protocols (e.g., TCP/IP, SMB, HTTP, NTP, SNMP) can reveal information about the remote operating system, potentially including its version.  This information is often passively gathered from standard operational responses.",
          "solution": "Implementing robust network segmentation and restricting network visibility can mitigate the risk of OS fingerprinting.  Employing firewalls to limit network scanning activity can reduce exposure.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Host Fully Qualified Domain Name (FQDN) Resolution",
          "protocol": "tcp",
          "cvss": 0,
          "port": 0,
          "synopsis": "Successful DNS resolution of the remote host's FQDN was observed.",
          "description": "A network scan confirmed the ability to resolve the fully qualified domain name (FQDN) of the target host to its corresponding IP address. This indicates that the host's DNS records are publicly accessible.",
          "solution": "Network segmentation, DNS security extensions (DNSSEC), and restricting DNS resolution to authorized systems can mitigate the potential for unauthorized discovery.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Scan Information",
          "protocol": "tcp",
          "cvss": 0,
          "port": 0,
          "synopsis": "This plugin provides metadata about the automated vulnerability assessment scan.",
          "description": "This plugin reports, for each target system, detailed metadata regarding the vulnerability scan execution:\n\n  - The version of the scanning toolset.\n  - The type of scanning engine used (e.g., Network, Host-based).\n  - The version of the core scanning engine.\n  - The network port scanning methods employed.\n  - The range of network ports scanned.\n  - Network latency measurements (ping round-trip time).\n  - Capability assessment for authenticated and/or privileged scanning.\n  - Status of superseded vulnerability detection (enabled/disabled).\n  - The timestamp of scan initiation.\n  - The total duration of the scan.\n  - The number of concurrently scanned hosts.\n  - The number of concurrently processed vulnerability checks.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Cipher Suites Supported",
          "protocol": "tcp",
          "cvss": 0,
          "port": 443,
          "synopsis": "The remote service uses SSL/TLS for encrypted communication.  This assessment identifies the supported cipher suites.",
          "description": "This assessment determines the SSL/TLS cipher suites enabled on the remote service.  Knowledge of supported cipher suites is crucial for evaluating the strength of the encryption used to protect communication channels.",
          "solution": "Implement a strong cipher suite policy that prioritizes modern, secure algorithms with forward secrecy. Regularly review and update this policy to address emerging cryptographic vulnerabilities.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "cvss": 0,
          "port": 22,
          "synopsis": "Remote service identification detected.",
          "description": "Network scanning revealed a remote service on port 22.  This was confirmed through analysis of the service banner or by observing the response to a probing request. The nature of the response indicates the service is active and responding to network traffic.",
          "solution": "Implement appropriate network segmentation and access controls to limit exposure of this service to only authorized systems and users. Regularly review and update firewall rules to ensure only necessary ports are open.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "cvss": 0,
          "port": 80,
          "synopsis": "Remote service identification detected.",
          "description": "Network scanning revealed a remote service on port 80.  Service identification was achieved through analysis of the service banner or error messages returned in response to an HTTP request. This indicates the service is accessible and potentially vulnerable to further exploitation if not properly secured.",
          "solution": "Implement robust network segmentation and access controls. Regularly review and update security configurations to minimize the service's attack surface.  Consider deploying a web application firewall (WAF) to mitigate potential vulnerabilities.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "cvss": 0,
          "port": 443,
          "synopsis": "Remote service identification confirmed.",
          "description": "Network scanning revealed the presence of a remote service on port 443.  Service identification was achieved through analysis of the service banner or by examining error responses to HTTP requests. This indicates that a service is listening and responding on this port, potentially exposing information about its implementation.",
          "solution": "Implement robust network segmentation and restrict network access to only authorized systems.  Regularly review and update network security policies to ensure appropriate access controls are in place. Consider implementing application-level firewalls or web application firewalls (WAFs) to further mitigate potential risks.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "cvss": 0,
          "port": 443,
          "synopsis": "Remote service identification confirmed.",
          "description": "Network scanning revealed the presence of a remote service on port 443.  This was determined through analysis of the service's response to a standard network probe, specifically examining the banner or error messages returned following an HTTP request. The ability to obtain this information indicates the service is accessible and potentially provides information about its configuration or implementation.",
          "solution": "Implement robust network segmentation and restrict access to port 443 to authorized users and systems only. Regularly review and update network security policies to minimize exposure to unauthorized scanning and probing.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "cvss": 0,
          "port": 2000,
          "synopsis": "Remote service identification detected.",
          "description": "Network scanning revealed the presence of a remote service on port 2000.  Service identification was achieved through analysis of the service banner or error messages returned in response to probing requests. The nature of the service is currently unknown. Further investigation is required to determine the specific service and its configuration.",
          "solution": "Implement a robust network segmentation strategy and restrict access to port 2000 unless explicitly required by legitimate services. Regularly review and update network access controls.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Service Detection",
          "protocol": "tcp",
          "cvss": 0,
          "port": 5060,
          "synopsis": "Remote service identification confirmed.",
          "description": "Network scanning revealed the presence of a remote service on port 5060.  Service identification was achieved through analysis of the service banner or an error response obtained by sending a test request.  The nature of the service remains undefined.",
          "solution": "Implement robust network segmentation and access controls to limit the impact of potential service exploitation.  Regularly review and update network security monitoring tools and processes to detect unauthorized services.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HyperText Transfer Protocol (HTTP) Information",
          "protocol": "tcp",
          "cvss": 0,
          "port": 80,
          "synopsis": "Passive reconnaissance reveals details about the remote HTTP server configuration.",
          "description": "This test passively gathers information about the remote HTTP service, including the HTTP version utilized and the presence of HTTP Keep-Alive functionality.  This passive information gathering does not inherently indicate a security vulnerability but provides context for further analysis.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TCP/IP Timestamps Supported",
          "protocol": "tcp",
          "cvss": 0,
          "port": 0,
          "synopsis": "TCP timestamps are enabled on the remote service.",
          "description": "The remote host's TCP implementation includes support for timestamps as specified in RFC 1323.  This feature, while beneficial for performance in some scenarios, allows for potential inference of system uptime through analysis of timestamp values.  Precise uptime calculation may be limited by factors such as network conditions and timestamp handling variations.",
          "solution": "Disabling TCP timestamps, if feasible and without significant performance impact, can mitigate the potential for uptime inference.  However, this depends on the underlying operating system and network configuration, and disabling may not always be advisable.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Reverse NAT/Intercepting Proxy Detection",
          "protocol": "tcp",
          "cvss": 0,
          "port": 0,
          "synopsis": "Network traffic analysis indicates multiple distinct host systems are reachable via a single public IP address, suggesting the use of Reverse NAT or an intermediary network device.",
          "description": "The observed network behavior is consistent with the use of Reverse NAT, a technique enabling multiple internal hosts to expose services on distinct ports through a shared public IP address.  Analysis of network responses suggests that different operating systems are associated with these services. This behavior could also be indicative of an intercepting proxy, a load balancer, or other network traffic management device actively modifying network traffic.",
          "solution": "Verify that the observed network configuration is consistent with established security policies and architectural designs.  Thorough network diagrams and documentation should be reviewed to confirm the intended behavior and identify any unauthorized intermediary devices.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Apache Tomcat Detection",
          "protocol": "tcp",
          "cvss": 0,
          "port": 80,
          "synopsis": "A web server responding on port 80 has been identified as Apache Tomcat.",
          "description": "Network scanning revealed a web server utilizing the Apache Tomcat application server.  This indicates the presence of a Tomcat instance accessible via port 80. Further investigation is required to determine the specific version and configuration.",
          "solution": "Implement appropriate access controls and security hardening measures for the identified Apache Tomcat instance. Regular security audits and vulnerability assessments should be performed.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "IAVT:0001-T-0535",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Apache Tomcat Detection",
          "protocol": "tcp",
          "cvss": 0,
          "port": 443,
          "synopsis": "A remote web server identified as Apache Tomcat is accessible on port 443.",
          "description": "Network scanning revealed the presence of a remote Apache Tomcat web server instance.  Further investigation is required to determine the specific Tomcat version and configuration.",
          "solution": "Implement appropriate security measures based on the identified version and configuration of the Apache Tomcat server.  This may include regular patching, secure configuration hardening, and access control restrictions.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "IAVT:0001-T-0535",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Backported Security Patch Detection (SSH)",
          "protocol": "tcp",
          "cvss": 0,
          "port": 22,
          "synopsis": "Detection of potentially backported SSH security patches.",
          "description": "This check identifies instances where security patches may have been applied to the remote SSH server without a corresponding version number increment.  The absence of a version change can complicate vulnerability management and tracking. Active banner grabbing techniques have been avoided to reduce the likelihood of false positives. This check is informational and does not inherently indicate a security compromise.  Further investigation is recommended to confirm the presence and effectiveness of applied patches.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Expiry - Future Expiry",
          "protocol": "tcp",
          "cvss": 0,
          "port": 443,
          "synopsis": "The SSL/TLS certificate used for secure communication with the remote service is nearing its expiration date.",
          "description": "The SSL/TLS certificate securing communication on port 443 is approaching its expiration date.  This poses a risk of service interruption and potential compromise of data integrity and confidentiality if not renewed before expiration.",
          "solution": "Implement a process for timely renewal of SSL/TLS certificates.  This includes establishing a monitoring system to track certificate expiration dates and automating the certificate renewal process to prevent service disruptions.  Consider using a certificate management system.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HTTP Methods Allowed (per directory)",
          "protocol": "tcp",
          "cvss": 0,
          "port": 80,
          "synopsis": "This assessment determines the HTTP methods permitted for various directories.",
          "description": "By using the OPTIONS HTTP method, it's possible to identify the allowed HTTP methods for each directory.\n\nThe following HTTP methods are generally considered insecure due to their potential for unintended data manipulation or exposure: PUT, DELETE, CONNECT, TRACE, HEAD.\n\nMany application frameworks and programming languages handle the 'HEAD' method similarly to 'GET', omitting the response body.  If access controls are implemented to restrict 'GET' requests (e.g., requiring authentication), a vulnerability might exist allowing unauthorized access via 'HEAD' requests. This could enable the unauthorized execution of privileged 'GET' operations without detection.\n\nThis assessment, if configured for comprehensive testing, probes various known HTTP methods against each directory and flags those returning 400, 403, 405, or 501 response codes as unsupported.\n\nNote that the assessment results provide informational insights and do not definitively indicate the presence of vulnerabilities.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Common Platform Enumeration (CPE)",
          "protocol": "tcp",
          "cvss": 0,
          "port": 0,
          "synopsis": "Remote system's CPE name(s) were identified through network enumeration.",
          "description": "This vulnerability report details the identification of Common Platform Enumeration (CPE) names associated with hardware and software components on a remote host.  This information was derived from network-based identification techniques.  The accuracy of CPE identification depends on the availability of official CPE entries; in their absence, the best possible match based on available data was generated.",
          "solution": "Implement network segmentation and restrict network access to reduce the surface area for enumeration attacks. Regularly update asset inventories to maintain an accurate representation of the system's configuration.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Apache HTTP Server Version",
          "protocol": "tcp",
          "cvss": 0,
          "port": 80,
          "synopsis": "Remote information disclosure: The version number of the Apache HTTP server is accessible.",
          "description": "The remote host is running an instance of the Apache HTTP Server, an open-source web server.  A remote request revealed the server's version number via the HTTP response banner. This information could potentially be used to identify potential vulnerabilities based on known exploits targeting specific Apache HTTP Server versions.",
          "solution": "Regularly update the Apache HTTP Server to the latest stable release and implement appropriate security hardening techniques to minimize exposure to potential exploits.  Restrict network access to the web server to authorized users and systems only.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "IAVT:0001-T-0030;IAVT:0001-T-0530",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Apache HTTP Server Version",
          "protocol": "tcp",
          "cvss": 0,
          "port": 443,
          "synopsis": "Information disclosure: Remote retrieval of Apache HTTP Server version number.",
          "description": "The remote host is running an instance of the Apache HTTP Server, an open-source web server.  Banner grabbing revealed the server's version number. This information can potentially aid in identifying vulnerabilities specific to that version.",
          "solution": "Regularly update the Apache HTTP Server to the latest stable release. Implement robust security measures to prevent unauthorized access and information gathering techniques.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "IAVT:0001-T-0030;IAVT:0001-T-0530",
          "mskb": "",
          "metasploit": "",
          "core_impact": "Information disclosure of the Apache HTTP Server version number.",
          "canvas": ""
        },
        {
          "name": "Device Type",
          "protocol": "tcp",
          "cvss": 0,
          "port": 0,
          "synopsis": "Remote device type inference vulnerability.",
          "description": "Network communication analysis can reveal information about the remote system's operational characteristics, potentially allowing an attacker to infer its type (e.g., printer, router, general-purpose computer).  This inference is based on the observed behavior and response patterns of the remote system.",
          "solution": "Network segmentation and minimizing network exposure can help mitigate the risk of device type inference. Implementing robust network monitoring and intrusion detection systems can aid in early detection of potential exploitation.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL / TLS Versions Supported",
          "protocol": "tcp",
          "cvss": 0,
          "port": 443,
          "synopsis": "Assessment of the SSL/TLS protocol versions supported by the remote service for secure communication.",
          "description": "This assessment determines the SSL and TLS versions supported by the remote service for encrypting communications.  This information is crucial for evaluating the strength of the encryption and potential vulnerabilities to known exploits targeting older, less secure protocols.",
          "solution": "Implement a policy to restrict the supported SSL/TLS versions to only those considered secure by industry best practices and regularly review and update this policy. Consider disabling support for outdated and vulnerable protocols.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Perfect Forward Secrecy Cipher Suites Supported",
          "protocol": "tcp",
          "cvss": 0,
          "port": 443,
          "synopsis": "The remote service advertises support for SSL/TLS cipher suites offering Perfect Forward Secrecy (PFS).  This mitigates the risk of retroactive decryption of past communication sessions.",
          "description": "The remote host indicates support for TLS cipher suites with Perfect Forward Secrecy (PFS).  PFS ensures that compromise of the server's long-term private key does not compromise the confidentiality of past sessions established using ephemeral key exchange mechanisms.  However,  the specific cipher suites in use and their strength are not explicitly identified.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Certificate Chain Contains Certificates Expiring Soon",
          "protocol": "tcp",
          "cvss": 0,
          "port": 443,
          "synopsis": "One or more certificates within the remote host's SSL/TLS certificate chain are nearing expiration.",
          "description": "The server presents an SSL/TLS certificate chain containing one or more certificates with imminent expiration dates.  Failure to renew these certificates before expiration will result in interruption of secure communication and potential service unavailability for clients.",
          "solution": "Implement a proactive certificate lifecycle management process.  Renew all certificates approaching expiration dates well in advance to prevent service disruptions.  Consider using automated certificate renewal tools.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HSTS Missing From HTTPS Server",
          "protocol": "tcp",
          "cvss": 0,
          "port": 443,
          "synopsis": "The remote web server lacks HTTP Strict Transport Security (HSTS) enforcement.",
          "description": "The HTTPS server does not implement HTTP Strict Transport Security (HSTS).  HSTS is a security mechanism that instructs the client (typically a web browser) to exclusively communicate with the server using HTTPS.  The absence of HSTS weakens the security posture by permitting downgrade attacks, where a connection is downgraded from HTTPS to HTTP, rendering it vulnerable to eavesdropping and manipulation.  This also increases the risk of SSL stripping attacks, where an attacker intercepts and modifies the communication, and compromises the integrity of cookie-based authentication mechanisms, potentially leading to session hijacking.",
          "solution": "Implement HSTS by configuring the web server to include the appropriate `Strict-Transport-Security` header in its responses.  Consider including parameters like `max-age` to specify the duration for which the browser should enforce HSTS, and potentially `includeSubDomains` and `preload` for enhanced protection.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS ALPN Supported Protocol Enumeration",
          "protocol": "tcp",
          "cvss": 0,
          "port": 443,
          "synopsis": "Detection of TLS Application-Layer Protocol Negotiation (ALPN) support on the remote host.",
          "description": "The remote host supports the TLS ALPN extension.  This indicates the server is capable of negotiating the application protocol (e.g., HTTP/1.1, HTTP/2, h2c) during the TLS handshake.  This improves performance and security by allowing for efficient protocol selection.",
          "solution": "No specific remediation is required if ALPN support is intended. Ensure proper configuration of supported application protocols to mitigate potential vulnerabilities arising from insecure protocol usage.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "SSL Root Certification Authority Certificate Information",
          "protocol": "tcp",
          "cvss": 0,
          "port": 443,
          "synopsis": "A self-signed root Certificate Authority (CA) certificate was identified at the apex of the certificate chain during SSL/TLS handshake verification.",
          "description": "The remote system presents an SSL/TLS certificate chain where the root CA certificate is self-signed.  This indicates that the certificate authority is not publicly trusted and was likely generated internally.",
          "solution": "Verify the legitimacy and trustworthiness of this self-signed root CA certificate.  Ensure its use adheres to organizational security policies and procedures concerning certificate management and trust models.  Consider the implications of relying on an internal, untrusted root CA for production systems, weighing the risks against the benefits.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Web Application Cookies Are Expired",
          "protocol": "tcp",
          "cvss": 0,
          "port": 80,
          "synopsis": "HTTP cookies exhibit an 'Expires' attribute set to a past date or time.",
          "description": "The web application manages HTTP cookies throughout user sessions, both authenticated and unauthenticated.  An assessment has revealed that one or more cookies possess an 'Expires' attribute with a past timestamp. This indicates that these cookies are considered expired by the client browser and will be discarded.",
          "solution": "A comprehensive review of each cookie is necessary to determine its contents and whether it stores sensitive data or plays a role in security-related decisions.  If the cookie's persistence is required, adjust the 'Expires' attribute to a future date. Alternatively, remove the 'Expires' attribute entirely to transform the cookie into a session-only cookie, relying on browser session management for its lifecycle.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Web Application Cookies Are Expired",
          "protocol": "tcp",
          "cvss": 0,
          "port": 443,
          "synopsis": "HTTP cookies possess an 'Expires' attribute set to a past date or time.",
          "description": "The web application utilizes HTTP cookies during both authenticated and unauthenticated user sessions.  Analysis reveals that one or more cookies have an 'Expires' attribute with a past timestamp, rendering them invalid and subject to immediate removal by the user's browser.",
          "solution": "A comprehensive review of each cookie is necessary to determine its sensitivity and functional role within security mechanisms.  If the cookie's persistence is required, update the 'Expires' attribute to a future date. Alternatively, remove the 'Expires' attribute entirely to transform the cookie into a session-only cookie, relying on browser session management for its lifecycle.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "Target Credential Status by Authentication Protocol - No Credentials Provided",
          "protocol": "tcp",
          "cvss": 0,
          "port": 0,
          "synopsis": "Network scan identified common ports associated with authentication services, however, no authentication credentials were supplied during the scan.",
          "description": "The remote target's network service(s) supporting authentication protocols were detected.  However, the scan failed to authenticate to the remote service due to lack of provided credentials or potential protocol incompatibility.  The inability to authenticate may indicate missing or incorrect credentials, or a failure in the authentication mechanism itself.  Detailed error messages from the scan may provide additional insights. \n\nPlease note the following:\n\n- This report analyzes authentication per protocol.  Successful authentication via one protocol (e.g., SSH) does not imply success with another (e.g., SMB or SNMP).\n\n- Providing appropriate credentials for all accessible authentication protocols can improve scan coverage. However, the usefulness of authentication success varies across target systems and protocols.  For example, SSH authentication is more valuable for Linux systems, while SMB authentication is more valuable for Windows systems.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "IAVB:0001-B-0504",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "OS Security Patch Assessment Not Available",
          "protocol": "tcp",
          "cvss": 0,
          "port": 0,
          "synopsis": "Operating System security patch assessment is unavailable.",
          "description": "The remote host did not provide an operating system security patch assessment. This may not indicate a vulnerability.  Several factors could prevent this assessment, including the absence of necessary credentials, lack of OS patch assessment support on the target, failure to identify the target operating system, or other technical issues.  Detailed error logs (if available) should be consulted for specific reasons.  This report indicates the unavailability of the assessment;  separate reporting mechanisms would highlight failures or unsupported systems.",
          "solution": "n/a",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "IAVB:0001-B-0515",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "web.config File Information Disclosure",
          "protocol": "tcp",
          "cvss": 5.3,
          "port": 80,
          "synopsis": "The remote web server exposes sensitive configuration data through an information disclosure vulnerability.",
          "description": "An information disclosure vulnerability exists due to improper protection of the web.config file.  An unauthenticated attacker can retrieve this file via a standard HTTP GET request, potentially revealing sensitive application settings, database credentials, or other confidential information impacting confidentiality and potentially integrity.",
          "solution": "Implement robust access control mechanisms to restrict access to the web.config file.  Consider alternative configuration strategies that do not rely on directly exposing sensitive data within a publicly accessible file.  If the file is not essential for application functionality, remove it entirely.",
          "risk_factor": "Medium",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.2 Protocol Detection",
          "protocol": "tcp",
          "cvss": 0,
          "port": 443,
          "synopsis": "The remote service uses TLS for encrypted communication.",
          "description": "The remote service is observed to support TLS 1.2 for secure connections on port 443.  This indicates the service implements at least TLS 1.2 encryption capabilities. Further analysis is required to determine the full range of TLS protocols supported and their cryptographic configurations.",
          "solution": "Implement a robust security posture by regularly reviewing and updating cryptographic protocols to utilize the latest, secure TLS versions. Ensure that only strong cipher suites are enabled and outdated protocols are disabled to mitigate potential vulnerabilities.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "TLS Version 1.3 Protocol Detection",
          "protocol": "tcp",
          "cvss": 0,
          "port": 443,
          "synopsis": "The remote service uses TLS for encryption.  Further analysis is required to determine the specific cipher suites and cryptographic algorithms in use.",
          "description": "The remote service is observed to accept connections using the TLS 1.3 protocol.  This indicates support for modern encryption standards, but does not guarantee the absence of vulnerabilities related to configuration or implementation of TLS 1.3.",
          "solution": "Implement a comprehensive security posture assessment to identify potential weaknesses in TLS 1.3 configuration and the selection of cipher suites. Regularly review and update cryptographic libraries and server software to ensure compatibility with the latest security standards and patches. Consider using network monitoring tools to identify any unusual TLS handshake behavior or failures.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "HSTS Missing From HTTPS Server (RFC 6797)",
          "protocol": "tcp",
          "cvss": 6.5,
          "port": 443,
          "synopsis": "The remote web server lacks the HTTP Strict Transport Security (HSTS) header as specified in RFC 6797.",
          "description": "The absence of the HSTS header on the remote web server represents a significant security vulnerability. HSTS is a security mechanism that instructs the client browser to exclusively communicate with the server using HTTPS.  Without HSTS, various attacks become significantly more feasible.  These include downgrade attacks, where a connection is downgraded from HTTPS to HTTP, exposing sensitive data in transit; SSL stripping attacks, where an attacker intercepts and removes the HTTPS encryption; and weakened cookie protection, increasing the risk of session hijacking.  The lack of HSTS reduces the server's resistance to various man-in-the-middle attacks.",
          "solution": "Implement and configure the HTTP Strict Transport Security (HSTS) header on the web server. This involves adding the appropriate header to the server's response, specifying a strict-transport-security max-age directive to dictate the duration for which the browser should enforce HTTPS.",
          "risk_factor": "Medium",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        },
        {
          "name": "OpenSSH Detection",
          "protocol": "tcp",
          "cvss": 0,
          "port": 22,
          "synopsis": "A remote host is hosting an SSH server, likely based on the OpenSSH implementation.",
          "description": "Network scanning revealed an SSH server listening on port 22.  This indicates the presence of a system capable of secure remote access via SSH.  Further investigation is required to identify the specific SSH server version and configuration.",
          "solution": "Implement robust SSH security practices, including strong password policies, key-based authentication, and regular security updates to the SSH server software.  Restrict access to authorized users only through appropriate firewall rules and access control lists.",
          "risk_factor": "None",
          "cve": "",
          "bid": "",
          "xref": "",
          "mskb": "",
          "metasploit": "",
          "core_impact": "",
          "canvas": ""
        }
      ]
    }
  }
]